'use strict';

var app = angular.module('Application', ['ui.bootstrap', 'ngSanitize', 'ngDragDrop', 'slick', 'pascalprecht.translate', 'angularjs-gauge']);

document.createElement('slick');


/*
 *  Dichiaro l'oggetto LMS per interagire con l'LMS per le chiamate
 *  e i punteggi se presente un test
 */
$.LMS = function (options) {
    var symbolOfScoreAndLastPage = '//';

    String.prototype.replaceAt = function (index, character) {
        return this.substring(0, index) + character + this.substring(index + 1, character.length);
    };

    var defaults = {
        type: '',
        versionSCORM: '1.2',
        linkedBrowsing: false,
        versionAICC: '2.0',
        commit: true,
        test: false,
        debug: false,
        closeBtn: '#js-close',
        getPages: function () {
        },
        numberOfPages: 1,
        completedWithPages: false
    };

    var options = $.extend(defaults, options);

    // invio un messaggio di debug alla console
    // del browser se il parametro di debug viene
    // attivato
    var debugMessage = function (text) {
        if (typeof console == "undefined") {
            window.console = {
                log: function () {
                }
            };
        }
        if (options.debug) {
            // console.log(text);
            // console.log(' ');
            return true;
        }
        return false;
    };

    // controllo se la variabile passata come parametro
    // è una funzione e può quindi essere richiamata
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    };

    var Cmi = {
        settings: {
            obj: false,
            httpArrayRequests: [
                function () {
                    return new XMLHttpRequest()
                },
                function () {
                    return new ActiveXObject("Msxml2.XMLHTTP")
                },
                function () {
                    return new ActiveXObject("Msxml3.XMLHTTP")
                },
                function () {
                    return new ActiveXObject("Microsoft.XMLHTTP")
                }
            ]
        },
        init: function () {
            for (var i = 0; i < this.settings.httpArrayRequests.length; i++) {
                try {
                    this.settings.obj = this.settings.httpArrayRequests[i]();
                }
                catch (e) {
                    continue;
                }
                break;
            }
        },
        getUrl: function (url, message) {
            this.settings.obj.open("POST", url, false);
            this.settings.obj.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            this.settings.obj.send(message);
            return this.settings.obj.responseText;
        },
        getError: function (result) {
            if (result) return parseInt(result.substring(result.indexOf("=") + 1, result.indexOf(String.fromCharCode(13))), 10);
            return false;
        },
        getScore: function (result) {
            var appo = result.toLowerCase().substring(result.toLowerCase().indexOf("score"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)))
        },
        getLocation: function (result) {
            var appo = result.substring(result.toLowerCase().indexOf("lesson_location"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)));
        },
        getStatus: function (result) {
            var appo = result.substring(result.toLowerCase().indexOf("lesson_status"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)));
        },
        getTime: function (result) {
            var appo = result.substring(result.toLowerCase().indexOf("time"));
            return appo.substring(appo.indexOf("=") + 1, appo.indexOf(String.fromCharCode(13)));
        }
    };

    var StringaVisti = {
        settings: {
            string: '',
            pages: '',
            separator: '//'
        },
        make: function () {
            var pages = this.addPages();
            var viewed = '1';
            this.settings.string = this.create(viewed, pages);
            return this.settings.string;
        },
        create: function (lastVisitedPage, totalPages) {
            var radice = lastVisitedPage + this.settings.separator;
            var lezione = this.areAllViewed() ? '1*' : '0*';
            var string = radice + lezione + this.addPages();
            return string;
        },
        getTotalPages: function () {
            return options.numberOfPages;
        },
        areAllViewed: function () {
            var pages = this.getTotalPages();
            if (pages) {
                for (var i = 0; i < pages.length; i++) {
                    var char = this.settings.pages.substr(i, i + 1);
                    if (char == "0") return false;
                }
                return true;
            }
            return false;
        },
        // aggiungo la serie di 1 o 0 per il totale delle pagine
        // che sono presenti all'interno dei moduli
        addPages: function () {
            if (!this.settings.pages) {
                var string = '';
                for (var i = 0; i < this.getTotalPages(); i++) {
                    string = string + '0';
                }
                this.settings.pages = string;
            }
            return this.settings.pages;
        },
        // effettuo l'update di una stringa visti
        // modificando l'ultima pagina visualizzata
        // se la lezione è stata completata
        // tutte le pagine viste a 1
        update: function (string, index, number) {
            var number = (number != "0" && number != "1") ? '1' : number;
            var index = index + 5;
            var string = this.replaceViewed(string, index - 4);
            if (index >= 14) index++
            string = string.replaceAt(index, number);
            this.settings.pages = string.substr(5, string.length);
            if (this.areAllViewed()) string = this.setLezioneAllViewed(string);
            return string;
        },
        // rimpiazzo nella stringa il parametro che indica
        // l'ultima pagina vista
        updateViewed: function (value) {
            return LMS.string.lastViewed = value;
        },
        // rimpiazzo nella stringa il parametro che indica
        // l'ultima pagina vista
        replaceViewed: function (string, value) {
            value = Number(value);
            if (value <= 0 || value > this.getTotalPages()) value = 1;
            if (isNaN(value)) value = 1;
            var string = string.split(this.settings.separator)[1];
            string = value + this.settings.separator + string;
            return string;
        },
        // se sono state visualizzate tutte le pagine
        // setto la lezione a 1
        setLezioneAllViewed: function (string) {
            var lastViewed = this.getLastViewed(string);
            var string = string.replaceAt(2 + lastViewed.length, "1");
            return string;
        },
        // ottengo la StringaVisti da un testo
        getFromText: function (text) {
            return Cmi.getLocation(text);
        },
        // ottengo il valore dell'ultima pagina visualizzata
        getLastViewed: function (string) {
            var page = string.split('//')[0];
            if (page < 1) page = 1;
            return page;
        }
    };

    var URL = {
        settings: {
            params: false
        },
        getParamsArray: function () {
            if (!this.settings.params) {
                var url = window.location.search.substr(1);
                if (url) {
                    var params = new Array();
                    var array = url.split('&');
                    for (var i = 0; i < array.length; i++) {
                        array[i] = array[i].trim();
                        var nameValue = array[i].split('=');
                        params[nameValue[0].trim()] = nameValue[1].trim();
                    }
                    this.settings.params = params;
                }
            }
            return this.settings.params;
        },
        hasParam: function (param) {
            var params = this.getParamsArray();
            for (var key in params) {
                if (key == param) {
                    return params[param];
                }
            }
            return false;
        },
        getNameParam: function (string) {
            var i = string.indexOf("=");
            if (i) {
                return string.substring(0, i).toLowerCase();
            }
            return false;
        },
        getValueParam: function (string) {
            var i = string.indexOf("=");
            if (i) {
                var value = string.substring(i + 1, string.leght).toLowerCase();
                return unescape(value);
            }
            return false;
        },
        hasHTTP: function (url) {
            return url.substring(0, 4).toUpperCase() == "HTTP";
        }
    };

    var AICC = {
        settings: {
            data: false,
            url: '',
            id: '',
            score: 0,
            mastery_score: '',
            idName: 'aicc_sid',
            urlName: 'aicc_url'
        },
        failed: function () {
            return 'F';
        },
        passed: function () {
            return 'P';
        },
        completed: function () {
            return 'C';
        },
        incomplete: function () {
            return 'I';
        },
        version: function () {
            return options.versionAICC;
        },
        url: function () {
            if (!this.settings.url) {
                this.parseURL();
            }
            return this.settings.url;
        },
        id: function () {
            if (!this.settings.id) {
                this.parseURL();
            }
            return this.settings.id;
        },
        location: function () {
            return Cmi.getLocation(this.getData());
        },
        // ritorno lo stato della lezione
        statoLezione: function () {
            var value = Cmi.getStatus(this.getData())
            return value.substring(0, 1);
        },
        getData: function () {
            if (!this.settings.data) {
                var data;
                data = Cmi.getUrl(this.url(), this.createMessage('getparam'));
                if (Cmi.getError(data) != "0") {
                    debugMessage('AICC.getData(): Errore: ' + Cmi.getError(data));
                    LMS.logout();
                }
                else {
                    this.settings.data = data.toLowerCase();
                }
            }
            return this.settings.data;
        },
        setScore: function (score) {
            debugMessage('Mastery' + this.getMasteryScore());
            if (Number(score) >= this.getMasteryScore()) {
                Lezione.setStato(Lezione.passed());
            }
            else {
                Lezione.setStato(Lezione.failed());
            }
            return this.settings.score = score;
        },
        getStudentName:function(){
            var params = this.getParam();
            return (params.student_name) ? params.student_name : "";
        },
        getScore: function () {
            if (!this.settings.score) {
                var data = this.getData();
                var score = Cmi.getScore(data);
                if (LMS.isTest()) {
                    if (isNaN(parseInt(score, 10))) {
                        score = 0;
                    }
                }
                else {
                    score = 0;
                }
                this.settings.score = score;
            }
            return this.settings.score;
        },
        getMasteryScore: function () {
            if (!this.settings.mastery_score) {
                var data = escape(this.getData());
                var string = 'mastery_score%3D';
                var pos = data.indexOf(string);
                if (pos != -1) {
                    mastery_score = data.substring(pos, data.length - 1);
                    pos = mastery_score.indexOf("%0D");
                    this.settings.mastery_score = Number(mastery_score.substring(string.length, pos));
                }
                else this.settings.mastery_score = "";
            }
            return this.settings.mastery_score;
        },
        getAutocertificazione: function () {
            if (!this.settings.autocertificazione) {
                var data = escape(this.getData());
                var string = 'autocertificazione%3Dtrue';
                var pos = data.indexOf(string);
                this.settings.autocertificazione = (pos != -1) ? true : false;
            }
            return this.settings.autocertificazione;
        },
        getReportCompleto: function () {
            if (!this.settings.reportCompleto) {
                var data = escape(this.getData());
                var string = 'reportcompleto%3Dtrue';
                var pos = data.indexOf(string);
                this.settings.reportCompleto = (pos != -1) ? true : false;
            }
            return this.settings.reportCompleto;
        },
        hasParam: function (url) {
            return url.indexOf("=") > -1;
        },
        isIdParam: function (param) {
            return param == "aicc-sid" || param == this.settings.idName;
        },
        isUrlParam: function (param) {
            return param == "aicc-url" || param == this.settings.urlName;
        },
        parseURL: function () {
            var id, url;

            // ottengo l'id dell'AICC
            if (id = URL.hasParam(this.settings.idName)) {
                this.setId(id);
            }

            // ottengo l'url dell'AICC
            if (url = URL.hasParam(this.settings.urlName)) {
                url = !URL.hasHTTP(url) ? unescape("http://") + url : url;
                this.setUrl(unescape(url));
            }

            Time.start();
            if (this.settings.url && this.settings.id) return true;
            return false;
        },
        setId: function (value) {
            return this.settings.id = value;
        },
        setUrl: function (value) {
            return this.settings.url = value;
        },
        hasParamsIdAndUrl: function () {
            if (URL.hasParam(this.settings.idName)) {
                if (URL.hasParam(this.settings.urlName)) {
                    return true;
                }
            }
            return false;
        },
        // creo il messaggio di invio per i vari comandi
        // alla piattaforma AICC
        createMessage: function (command, aicc_data) {
            if (!aicc_data) aicc_data = false;
            return "command=" + command + "&version=" + this.version() + "&session_id=" + this.id() + "&aicc_data=" + aicc_data;
        },
        logout: function () {
            var _return = Cmi.getUrl(this.url(), this.createMessage('exitau'));
            if (Cmi.getError(_return) != "0") {
                debugMessage("Errore nella comunicazione con la piattaforma.\n Il corso verrà  chiuso.");
                return false;
            }
            return true;
        },
        // invio i parametri di aggiornamento per effettuare
        // l'update della piattaforma AICC
        update: function () {
            // se è abilitato l'invio degli aggiornamenti
            if (LMS.isSCORMVersion('1.2')) {
                this.setValue("cmi.core.session_time", Time.timer());
            }
            else {
                this.setValue("cmi.session_time", Time.timer());
            }
            var data = "\r\nScore=" + this.getScore() + "\r\nTime=" + Time.timer() + "\r\nLesson_Status=" + Lezione.stato() + "\r\nLesson_Location=" + Lezione.stringaVisti();
            data = "[core]" + escape(data);
            var message = this.createMessage('putparam', data);
            var error = Cmi.getError(Cmi.getUrl(this.url(), message));
            if (error != "0") {
                debugMessage('AICC:update(): Errore: ' + error);
                debugMessage("Errore nella comunicazione con la piattaforma.\n Il corso verrà  chiuso.");
                return this.logout();
            }
            Time.reset();
            return true;
        },
        getTime: function () {
            return Time.timer();
        }
    };

    var SCORM = {
        settings: { score: 0 },
        failed: function () {
            return "failed";
        },
        passed: function () {
            return "passed";
        },
        completed: function () {
            return 'completed';
        },
        incomplete: function () {
            return 'incomplete';
        },
        statoLezione: function () {
            return (LMS.isSCORMVersion('1.2') ? this.getValue('cmi.core.lesson_status') : this.getValue("cmi.completion_status"));
        },
        init: function () {
            Time.set(this.getTime());
            Time.start();

            // se la lezione non è fallita o passata
            // vuol dire che è incompleta
            if (
                this.failed() != this.getParam().lesson_status &&
                this.passed() != this.getParam().lesson_status
            ) {
                Lezione.setStato("incomplete");
                this.setValue("cmi.core.lesson_status", "incomplete");
                return LMS.commit();
            }
            return false;
        },
        getParam: function () {
            if (!this.settings.param) {
                var obj = new Object();
                var lesson_location = this.getValue(LMS.isSCORMVersion('1.2') ? "cmi.core.lesson_location" : "cmi.location");
                obj.launch_data = this.getValue("cmi.launch_data");
                obj.lesson_status = this.getValue("cmi.core.lesson_status") ? this.getValue("cmi.core.lesson_status") : this.incomplete();
                obj.lesson_location = lesson_location ? lesson_location : false;

                // obj.lesson_location="0//1|2//111|0//1|2//110|0//0|0//00|0//0|0//0|";

                obj.suspend_data = this.getValue("cmi.suspend_data");
                obj.student_data = this.getValue('cmi.student_data._children');
                obj.mastery_score = this.getValue('cmi.student_data.mastery_score');
                obj.raw = this.getValue("cmi.core.score.raw");
                debugMessage(obj);
                this.settings.param = obj;
            }
            return this.settings.param;
        },
        getStudentName:function(){
            var params = this.getParam();
            return (params.student_name) ? params.student_name : "";
        },
        getTime: function () {
            var params = this.getParam();
            var time = params.time;
            if (!time) time = Time.timer();
            return time;
        },
        getMasteryScore: function () {
            var params = this.getParam();
            return Number(params.mastery_score);
        },
        getAutocertificazione: function () {
            var launchData = this.getParam().launch_data;
            if (launchData) {
                var autocertificazione = launchData.split(';')[1].replace("autocertificazione=", "");
                autocertificazione = (autocertificazione == 'true') ? true : false;
                return autocertificazione;
            }
            return false;
        },
        getReportCompleto: function () {
            var launchData = this.getParam().launch_data;
            if (launchData) {
                var param = launchData.split(';')[0].replace("reportcompleto=", "");
                param = (param == 'true') ? true : false;
                return param;
            }
            return false;
        },
        setScore: function (score) {
            if (this.getParam().raw) {
                if (Number(this.getParam().raw) >= Number(score)) {
                    debugMessage('setScore');
                    return false;
                }
            }
            debugMessage('Mastery' + this.getMasteryScore());
            if (Number(score) >= this.getMasteryScore()) {
                debugMessage('TEST PASSED');
                debugMessage(Lezione.passed());
                Lezione.setStato(Lezione.passed());
            }
            else {
                debugMessage('TEST FAILED');
                debugMessage(Lezione.failed());
                Lezione.setStato(Lezione.failed());
            }
            this.settings.param.raw = score;
            this.setValue("cmi.core.score.raw", score);
            this.setValue("cmi.core.lesson_status", Lezione.stato());
            LMS.commit();
            return this.settings.score = score;
        },
        getScore: function () {
            var params = this.getParam();
            return (params.raw) ? Number(params.raw) : 0;
        },
        // ottengo il valore del name passato
        // in parametro
        getValue: function (name) {
            var value, codeError, error = false;
            if (LMS.isSCORMVersion('1.2')) {
                if (API.get()) {
                    value = API.get().LMSGetValue(name);
                    error = this.getErrorDescription();
                }
                else error = true;
            }
            else {
                value = API_1484_11.GetValue(name);
                codeError = API_1484_11.GetLastError().toString();
                if (codeError != "0") {
                    error = API_1484_11.GetErrorString(codeError);
                }
            }
            if (error) debugMessage('SCORM ERROR getting: ' + name);
            return (error && !value) ? false : value.toString();
        },
        // setto il @value al @name
        setValue: function (name, value) {
            if (API.get()) {
                var LMSSetValue;
                LMSSetValue = LMS.isSCORMVersion('1.2') ? API.get().LMSSetValue(name, value) : API_1484_11.SetValue(name, value);
                if (!LMSSetValue.toString()) {
                    debugMessage('Error: ' + name + ', value: ' + value);
                    return false;
                }
                this.settings.param[name] = value;
                return LMSSetValue;
            }
            return false;
        },
        getLastError: function () {
            return API.get().LMSGetLastError().toString();
        },
        getErrorDescription: function (code) {
            if (!code) code = this.getLastError();
            if (code != "0") return API.get().LMSGetErrorString(code);
            return false;
        },
        update: function () {
            // se è abilitato l'invio degli aggiornamenti
            if (options.commit) {
                if (LMS.isSCORMVersion('1.2')) {
                    return LMS.commit();
                }
                else {
                    commitResult = API_1484_11.Commit("");
                    if (commitResult != "true") {
                        debugMessage("Errore: LMSCommit non riuscito. \n" + commitResult);
                        return false;
                    }
                    return true;
                };
            };
            return true;
        }
    };

    var Settings = {
        settings: {
            parsed: false
        },
        string: {
            lastViewed: 0,
            score: 0,
            pages: false
        },
        get: function () {
            return this.string;
        },
        stringify: function () {
            if (!this.get().pages) {
                this.newString();
            }
            return this.get().lastViewed
                + symbolOfScoreAndLastPage
                + this.get().pages
        },
        parse: function () {
            this.get().lastViewed = parseInt(this.getLastViewed());
            this.get().pages = this.getPages();
            return this.get();
        },
        // ottengo il valore dell'ultima pagina visualizzata
        getLastViewed: function () {
            var index = LMS.getAppString();
            if (!index)
                return false;
            return index.split('//')[0];
        },
        getPages: function () {
            if (!LMS.getAppString())
                return false;
            return LMS.getAppString().split(symbolOfScoreAndLastPage)[1];
        },
        updatePages: function (page) {
            var $value = 1;
            if (jQuery.inArray(page - 1, this.get().bookmarks) > -1) $value = 2;
            this.get().pages = this.get().pages.replaceAt((parseInt(page) - 1), $value);
            return this;
        },
        newString: function () {
            this.createPagesString();
            return this.stringify();
        },
        createPagesString: function () {
            var string = ''
            for (var i = 0; i < options.numberOfPages; i++) {
                string += '0';
            }
            this.string.pages = string;
            return string;
        },
        arePagesCompleted: function () {
            for (var i = 0; i < this.get().pages.length; i++) {
                if (this.get().pages.substring(i, i + 1) == 0)
                    return false;
            }
            return true;
        },
        reset: function () {
            this.string.lastViewed = 0;
            this.string.pages = false;
            debugMessage('reset: ' + this.stringify());
        },
        pagesString: function () {
            return this.get().pages;
        }
    };

    var Lezione = {
        settings: {
            stato: '',
            score: 0,
            stringaVisti: '',
            location: '',
            page: ''
        },
        stato: function () {
            return this.settings.stato;
        },
        page: function () {
            return this.settings.page;
        },
        location: function () {
            return this.settings.location;
        },
        stringaVisti: function () {
            if (!this.settings.stringaVisti) this.settings.stringaVisti = StringaVisti.make();
            return this.settings.stringaVisti;
        },
        setPagina: function (n) {
            return this.settings.page = n;
        },
        setArg: function (n) {
            return this.settings.argument = n;
        },
        setStato: function (value) {
            this.settings.stato = value;
            SCORM.setValue("cmi.core.lesson_status", value);
            return this.stato();
        },
        setLocation: function (value) {
            if (!value)
                return false;

            value.replace(" ", "");
            return this.settings.location = value;
        },
        setStringaVisti: function (value) {
            return this.settings.stringaVisti = value;
        },
        getStato: function () {
            return LMS.isAICC() ? AICC.statoLezione() : SCORM.statoLezione();
        },
        // controllo che la lezione sia stata passata
        passed: function () {
            return LMS.isAICC() ? AICC.passed() : SCORM.passed();
        },
        // controllo se la lezione ha avuto esito negativo
        failed: function () {
            return LMS.isAICC() ? AICC.failed() : SCORM.failed();
        },
        completed: function () {
            return LMS.isAICC() ? AICC.completed() : SCORM.completed();
        },
        incomplete: function () {
            return LMS.isAICC() ? AICC.incomplete() : SCORM.incomplete();
        },
        getScore: function () {
            return LMS.isAICC() ? AICC.getScore() : SCORM.getScore();
        },
        getMasteryScore: function () {
            return LMS.isAICC() ? AICC.getMasteryScore() : SCORM.getMasteryScore();
        },
        // controllo se sono state visionate tutte le pagine
        isFinish: function () {
            var isFinish = Settings.arePagesCompleted() || this.getStato() == this.completed();
            return isFinish;
        },
        isCompleted: function () {
            return this.getStato() == this.completed();
        },
        // ottengo l'ultima pagina visualizzata dall'utente
        getLastPageViewed: function () {
            return StringaVisti.getLastViewed(this.stringaVisti());
        },
        getTime: function () {
            return LMS.isAICC() ? AICC.getTime() : SCORM.getTime();
        }
    };

    var Time = {
        settings: {
            timer: "00:00:00"
        },
        // setto il timer
        set: function (value) {
            return this.settings.timer = value;
        },
        timer: function () {
            return this.settings.timer;
        },
        start: function () {
            var time = this.timer();
            var ore = this.getHours(time);
            var minuti = this.getMinutes(time);
            var secondi = this.getSeconds(time);

            // aumento i secondi
            secondi = this.pad2((Number(secondi) + 1));

            // se i secondi raggiungono il 60
            // aumento di 1 il minuto e riazzero i secondi
            if (secondi == 60) {
                secondi = '00';
                minuti = this.pad2((Number(minuti) + 1));
            }

            // se i minuti raggiungono il 60
            // aumento di 1 le ore e riazzero i minuti
            if (minuti == 60) {
                minuti = '00';
                ore = this.pad2((Number(ore) + 1));
            }

            // setto la nuova ora
            this.set(ore + ":" + minuti + ":" + secondi);

            setTimeout(function () {
                Time.start();
            }, 1000);
            return true;
        },
        getHours: function (time) {
            var hours = time.split(':')[0];
            return hours;
        },
        getMinutes: function (time) {
            var minutes = time.split(':')[1];
            return minutes;
        },
        getSeconds: function (time) {
            var seconds = time.split(':')[2];
            return seconds;
        },
        // resetto il timer
        reset: function () {
            return this.set('00:00:00');
        },
        // fixo i numeri al di sotto di 10 con 2 digits
        pad2: function (number) {
            return (number < 10 ? '0' : '') + number;
        }
    };

    var API = {
        settings: {},
        // ottengo le API
        get: function () {
            if (!this.settings.get) {
                var API = null;
                //Search all the parents of the current window if there are any
                if ((window.parent != null) && (window.parent != window)) {
                    API = this.scanParentsForApi(window.parent);
                }
                /*
		If we didn't find the API in this window's chain of parents,
		then search all the parents of the opener window if there is one
                */
                if ((API == null) && (window.top.opener != null)) {
                    API = this.scanParentsForApi(window.top.opener);
                }
                this.settings.get = API;
            }
            return this.settings.get;
        },
        scanParentsForApi: function (win) {
            var nParentsSearched = 0;
            while ((win.API_1484_11 == null) && (win.API == null) &&
                (win.parent != null) && (win.parent != win) &&
                (nParentsSearched <= 500)
            ) {
                nParentsSearched++;
                win = win.parent;
            }
            /*
                If the API doesn't exist in the window we stopped looping on,
                then this will return null.
            */
            if (win.API == null) {
                if (win.API_1484_11 != null) {
                    return win.API_1484_11;
                } else {
                    return null;
                }
            } else {
                return win.API;
            }
        }
    };

    var Test = {
        setScore: function (score) {
            return (LMS.isAICC()) ? AICC.setScore(score) : SCORM.setScore(score);
        }
    };

    var LMS = {
        settings: {
            exit: false,
            connected: false,
            location: ''
        },
        // avvio le definizioni per LMS
        start: function () {
            Cmi.init();
            // effettuo la connessione alla piattaforma
            var connect = this.connect();

            // controllo alla chiusura del browser
            $(window).on('beforeunload', function (event) {
                LMS.manageBrowserExit(event);
            });

            $(document).on('click touchstart', options.closeBtn, function () {
                LMS.exitAu();
                return false;
            });
        },
        // mi connetto alla piattaforma
        // la connessione differisce se la
        // comunicazione è in AICC o in SCORM
        connect: function () {
            if (!this.settings.connected) {
                var connect = false;
                // se è AICC
                if (AICC.hasParamsIdAndUrl()) {
                    debugMessage('AICC: started');
                    this.setType('aicc');
                    if (this.AICCConnect()) connect = true;
                }
                // se è SCORM
                else if (API.get()) {
                    debugMessage('SCORM: started');
                    this.setType('scorm');
                    if (this.SCORMConnect()) connect = true;
                }
                else {
                    this.setType('');
                    connect = true;
                }
                this.settings.connected = connect;
            }
            return (this.settings.connected) ? this.prepare() : false;
        },
        getAppString: function () {
            //return '0//1|0//11111111|0//00000000000|0//0|';
            return SCORM.getValue(LMS.isSCORMVersion('1.2') ? "cmi.core.lesson_location" : "cmi.location");
        },
        location: function () {
            return this.settings.location;
        },
        // connession tramite AICC
        AICCConnect: function () {
            return AICC.parseURL();
        },
        // connessione tramite SCORM
        SCORMConnect: function () {
            var SCORMConnect;
            // se è la versione 1.2
            SCORMConnect = this.isSCORMVersion('1.2') ? API.get().LMSInitialize("") : API_1484_11.Initialize("");
            if (SCORMConnect) {
                SCORM.init();
            }
            return SCORMConnect;
        },
        // ritorno il tipo di comunicazione
        type: function () {
            return options.type;
        },
        // setto il tipo di comunicazione
        setType: function (type) {
            options.type = type;
            return type;
        },
        // controllo se la comunicazione in atto è in AICC
        isAICC: function () {
            return this.type() == 'aicc';
        },
        // controllo se la comunicazione in atto è in SCORM
        isSCORM: function () {
            return this.type() == 'scorm';
        },
        // controllo se è la versione passata dello scorm
        isSCORMVersion: function (version) {
            return options.versionSCORM == version;
        },
        putParam: function (n) {
            var update = false;

            // effettuo l'update del valore AICC
            if (this.isAICC()) {
                AICC.update();
                update = true;
            }
            else {
                SCORM.update();
                update = true;
            };
            return update;
        },
        // preparo la scena per le interazioni future
        prepare: function () {
            // ottengo i parametri
            var params = this.getParam();
            if (params) {
                if (this.isAICC()) {
                    var stringa_visti = StringaVisti.getFromText(params);
                    Lezione.setStringaVisti(stringa_visti ? stringa_visti : StringaVisti.make());
                }
                else {
                    Lezione.setLocation(params.lesson_location);
                    Lezione.setStato(params.lesson_status);
                    //Settings.parse();
                }

                // se la lezione è completata la segno come completata
                if (!Lezione.isFinish()) {
                    debugMessage('isNotFinish');
                    Lezione.setStato(Lezione.incomplete());
                }
                return this.putParam();
            }
            return true;
        },
        getParam: function () {
            var params = false;
            if (this.isAICC()) {
                params = this.getAICCParam();
            }
            else {
                if (this.isSCORMVersion('1.2')) {
                    params = this.getSCORMParam();
                }
                else {
                    Lezione.setStato(this.getValue("cmi.completion_status"));
                }
            }
            return params;
        },
        // ottengo i parametri dell'AICC
        getAICCParam: function () {
            var data = AICC.getData();
            var segnalibroTest = false;
            // Prendo la core_lesson se sono in un test
            if (options.test) {
                var pos = data.indexOf('core_vendor');
                if (pos != -1) {
                    var nuovaStr = data.substring(pos);
                    var pos2 = nuovaStr.indexOf("%0D%0A");
                    if (pos2 != -1) {
                        if (nuovaStr.indexOf("reportcompleto%3Dtrue") != -1) {
                            reportCompleto = "true";
                        }
                        else {
                            reportCompleto = "false";
                        }
                        if (nuovaStr.indexOf("autocertificazione%3Dtrue") != -1) {
                            autocertificazione = "true"
                        }
                        else {
                            autocertificazione = "false"
                        }
                        if (nuovaStr.indexOf("segnalibrotest%3Dtrue") != -1) {
                            segnalibroTest = "true"
                        }
                        else {
                            segnalibroTest = "false"
                        }
                    }
                };
                if (segnalibroTest) {
                    pos = data.indexOf('core_lesson');
                    if (pos != -1) {
                        nuovaStr = data.substring(pos);
                        pos2 = nuovaStr.indexOf("%0D%0A");
                        if (pos2 != -1) {
                            nuovaStr = nuovaStr.substring(pos2 + 6)
                            num = nuovaStr.indexOf("%0D%0A")
                            coreLesson = nuovaStr.substring(0, num)
                            coreLesson = unescape(coreLesson)
                        }
                    }
                }
            }; // options.test
            return data;
        },
        getSCORMParam: function () {
            return SCORM.getParam();
        },
        logout: function () {
            var miaTop = this.trovaTop(window);
            if (miaTop.location == self.location) {
                self.top.close();
            }
            else {
                //self.location = "logout.htm";
            }
        },
        trovaTop: function (win2) {
            if (win2.location == win2.parent.location) {
                return win2;
            }
            else {
                var win2 = this.trovaTop(win2.parent);
                return win2;
            }
        },
        // gestisco l'uscita dell'utente nel caso
        // in cui chiuda la finestra con la x del browser
        manageBrowserExit: function (ev) {
            if (this.type() != "") {
                if (!ev) {
                    ev = event;
                }
                if (!this.isExit()) {
                    debugMessage('Browser Exit')
                    return this.exitAu();
                }
            }
        },
        exitAu: function () {
            this.setCorrectExit();
            if (this.isAICC()) {
                if (AICC.logout()) {
                    return this.logout();
                }
            }
            else {
                if (this.isSCORMVersion('1.2')) {
                    // invio il tempo
                    SCORM.setValue("cmi.core.session_time", Time.timer());
                    // SCORM.setValue("cmi.core.lesson", Time.timer());
                }
                else {
                    var timer_value1 = "";
                    // console.log('Time.timer(): ' + Time.timer());
                    var appo = Time.timer().split(":");
                    if (parseInt(appo[0], 10) > 0) {
                        timer_value1 = parseInt(appo[0], 10) + "H"
                    }
                    if (parseInt(appo[1], 10) > 0) {
                        timer_value1 = timer_value1 + parseInt(appo[1], 10) + "M"
                    }
                    if (parseInt(appo[2], 10) > 0) {
                        timer_value1 = timer_value1 + parseInt(appo[2], 10) + "S"
                    }
                    Time.set("PT" + timer_value1);
                    // console.log('Time.timer after set: ' + Time.timer());

                    // invio il tempo
                    SCORM.setValue("cmi.session_time", Time.timer());
                }

                if (this.isSCORMVersion('1.2')) {
                    SCORM.update();
                    this.finish();
                }
                else if (API_1484_11.Terminate("") != "true") {
                    debugMessage("Errore: LMSFinish non riuscito. \n" + result)
                }

                return this.logout();
            }
        },
        // segno che è avvenuta l'uscita correttamente
        setCorrectExit: function () {
            return this.settings.exit = true;
        },
        // segno che ci sono stati problemi nell'uscire
        setErrorExit: function () {
            return this.settings.exit = false;
        },
        // ritorno il risultato dell'exit se è avvenuto
        isExit: function () {
            return this.settings.exit;
        },
        finish: function () {
            if (API.get()) {
                var LMSFinish = API.get().LMSFinish("");
                if (LMSFinish != "true") {
                    debugMessage("Errore: LMSFinish non riuscito. \n" + LMSFinish)
                    return false;
                }
                else {
                    debugMessage('LMSFinish correttamente riuscito');
                    return this.logout();
                }
            }
        },
        // invio i dati alla piattaforma
        commit: function () {
            if (API.get()) {
                var LMSCommit = API.get().LMSCommit("");
                if (!LMSCommit) {
                    debugMessage("Errore: LMSCommit non riuscito. \n" + LMSCommit);
                    return false;
                }
                return true;
            }
            return false;
        },
        isTest: function () {
            return options.test;
        },
        update: function () {
            debugMessage('update');
            return this.putParam();
        },
        getStudentName:function(){
            return SCORM.getStudentName();
        },
        updateScore: function (score, status) {
            options.test = true;
            Test.setScore(score);
            // Lezione.setStato((status ? Lezione.passed() : Lezione.failed()));
            debugMessage('updateScore');
            return this.putParam();
        },
        getMasteryScore: function () {
            return Lezione.getMasteryScore();
        },
        getAutocertificazione: function () {
            return LMS.isAICC() ? AICC.getAutocertificazione() : SCORM.getAutocertificazione();
        },
        getReportCompleto: function () {
            return LMS.isAICC() ? AICC.getReportCompleto() : SCORM.getReportCompleto();
        },
        getLastPageView: function () {
            return Settings.get().lastViewed;
        },
        updatePages: function (numberPage) {
            Settings.get().lastViewed = numberPage - 1;
            Settings.updatePages(numberPage);
            return LMS.update();
        },
        /**
         * @description update lesson location
         * @param string
         * @return {*|boolean}
         */
        updateLessonLocation(string) {
            // console.log("updateLessonLocation", string);
            SCORM.setValue("cmi.core.lesson_location", string);
            return LMS.commit();
        },
        /**
         * @description get stored lesson_location
         * @return {*}
         */
        getLessonLocation() {
            return this.getParam().lesson_location;
        },
        /**
         * @description update suspend data
         * @param string
         * @return {*|boolean}
         */
        updateSuspendData(string) {
            SCORM.setValue("cmi.suspend_data", string);
            return LMS.commit();
        },
        /**
         * @description get stored suspend_data
         * @return {*}
         */
        getSuspendData() {
            return this.getParam().suspend_data;
        },
        /**
         * @description update lesson location and suspend data
         * @param strings
         */
        updateStrings(strings) {
            // console.log("strings.lessonLocation " + strings.lessonLocation)
            if (strings.lessonLocation) {
                LMS.isSCORMVersion('1.2') ?
                    SCORM.setValue("cmi.core.lesson_location", strings.lessonLocation) :
                    SCORM.setValue("cmi.location", strings.lessonLocation);
                // SCORM.setValue("cmi.lesson_location", strings.lessonLocation);
            }

            if (strings.suspendData)
                SCORM.setValue("cmi.suspend_data", strings.suspendData);

            LMS.commit();
            return this;
        },
        string: function () {
            return Settings.stringify();
        },
        reset: function () {
            Settings.reset();
            Lezione.setStato(Lezione.incomplete());
            return LMS.update();
        },
        setCompleted: function () {
            debugMessage('completed');
            Lezione.setStato(Lezione.completed());
            SCORM.setValue("cmi.session_time", Time.timer());
            return this.update();
        },
        getLastPageOfString: function () {
            return Settings.stringify().split('//')[1].lastIndexOf("1");
        },
        getPagesString: function () {
            return Settings.pagesString();
        },
        setValue: function (attr, value) {
            return SCORM.setValue(attr, value);
        },
        getScore: function () {
            return SCORM.getScore();
        }
    };

    LMS.start(options);
    // Settings.parse();
    return LMS;
}






app.controller('AsideController', function(){});

(function () {

    'use strict';

    var ConclusionTestController = function ($scope, $filter, App, Tracking, Interaction) {
        
        $scope.feedback = false;
        $scope.scoreFeedback = false;
        $scope.ispassed = false;

        // console.log("$scope.calcPerc()", $scope.caslcPerc());

        $scope.totPerc = (100 * $scope.collection.count('isCorrect')) / $scope.collection.count();
        $scope.totPerc = Math.round($scope.totPerc);
        // console.log($scope.totPerc);
        if ($scope.totPerc >= 70) {
            // console.log("here");
            $scope.testFeedback = 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessageYes');
            $scope.scoreFeedback = $filter('translate')('exerciseTemplate.feedbacks.scoreMessage1') + 
                $scope.totPerc + 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessage2');
                $scope.ispassed = true;
        } else {
            $scope.testFeedback = 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessageNo');
            $scope.scoreFeedback = $filter('translate')('exerciseTemplate.feedbacks.scoreMessage1') + 
                $scope.totPerc + 
                $filter('translate')('exerciseTemplate.feedbacks.scoreMessage3');
        }

        $scope.isPassed = function() {
            return $scope.ispassed;
        }

        /*
        if ($scope.isPassed()) {
            Tracking.save({
                score: $scope.totPerc,
                status: $scope.isPassed() ? 'passed' : 'failed'
            });
        }
        */

        // if ($scope.totPerc >= 70) {
            // $scope.page().viewed();
        // }
        Tracking.save({
            score: $scope.totPerc,
            status: $scope.isPassed() ? 'passed' : 'failed'
        });
    };

    ConclusionTestController.$inject = ['$scope', '$filter', 'App', 'Tracking','Interaction'];

    angular.module('Application')
        .controller('ConclusionTestController', ConclusionTestController);
})();

app.controller('CoppieCardController', ['$scope', '$timeout','$interval', 'GameService', function ($scope,$timeout,$interval,GameService) {

    var confirmedCouplesCount = 0;

    $scope.currentStepCount = 0;
    $scope.currentStepCards = $scope.exercise.answers()[$scope.currentStepCount];

    //$scope.timerState.initialTimerMs = 90*1000;

    let score = GameService.getProgressById('G_MEM').score;
    // console.log("score",score)
    if (score >= 0){ //game già avviato
        //card.confirmed=false
        _.each($scope.currentStepCards.cards, function(card){
            card.confirmed=false;
            card.isFlipped=false
            //if (card.isFlipped){
                //$scope.flipCard(card);
            //}
        })
        //$scope.completed = true;
        //$scope.feedback = "Game già completato";
    }

    $scope.timeoverHandler = function(){
        $scope.feedback = "Tempo scaduto!";
        GameService.addScore(0, 0, 0, 'G_MEM');
    }

    $scope.nextStep = function(){
        $scope.loading = true;
        _.each($scope.currentStepCards.cards, function(card){
            if (card.isFlipped){
                $scope.flipCard(card);
            }
        })

        $timeout(function(){
            confirmedCouplesCount = 0;
            $scope.currentStepCount++;
            $scope.currentStepCards = $scope.exercise.answers()[$scope.currentStepCount];
            $scope.loading = false;
        },1000)
        $scope.nextButtonVisible = false;
    }
    //$scope.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    $scope.cardSelection = [];

    $scope.addFlipAnimationToCards = function(){
        // console.log("addFlipAnimationToCards");
        // console.log("flip");
        TweenMax.set($(".card-wrap__card"), {rotationY:0});
        $.each($(".card-wrap__card"), function(i,element) {
            var frontCard = $(this).children(".card__front"),
                backCard = $(this).children(".card__back"),
                tl = new TimelineMax({paused:true});

            tl
                .to(frontCard, 1, {rotationY:180})
                .to(backCard, 1, {rotationY:0},0)
                .to(element, .5, {z:50},0)
                .to(element, .5, {z:0},.5);

            element.animation = tl;

        });
    }

    $scope.flipCard = function(card){
        var idCard = '#card-'+$scope.exercise.getAttr('id')+'-'+_.indexOf($scope.currentStepCards.cards, card);
        if (card.isFlipped) {
            $(idCard)[0].animation.reverse();
        } else {
            $(idCard)[0].animation.play();
        }
        card.isFlipped = !card.isFlipped;

        //$scope.exercise.setAnswer(card);
        //$scope.exercise.confirm();
    }

    $timeout(function(){
        $scope.addFlipAnimationToCards();

        // if exercise already confirmed flip all cards
        /*if ($scope.exercise.isConfirmed()){
            $timeout(function(){
                _.each($scope.currentStepCards.cards, function(card){
                    card.isFlipped = false;
                    $scope.flipCard(card);
                })
                // TODO: Get saved suspendData score from GameService to show the feedback
                var savedScore = 0;//GameService.get(....
                if (savedScore === 10){
                    $scope.feedback = $scope.exercise.getAttr('feedback').less30;
                }else{
                    $scope.feedback = $scope.exercise.getAttr('feedback').greather30;
                }
                confirmedCouplesCount = 3;
            },500)
        }else{ // exercise not yet completed
            $scope.canFlip = true;
        }*/
        $scope.canFlip = true;
    },0)



    $scope.onSelectCard = function(card){

        if ($scope.canFlip && !$scope.timeStarted){
            $scope.timeStarted = true;
        }
        let score = GameService.getProgressById('G_MEM').score;
        if (score < 0){ //game già avviato
            GameService.initGameScore('G_MEM');
        }

        //console.log("card.confirmed",card.confirmed)
        //console.log("$scope.cardSelection.length",$scope.cardSelection.length)
        if (card.confirmed || card.isFlipped && $scope.cardSelection.length < 2){
            //console.log("ci sonooo")
            return;
        }
        $scope.flipCard(card);
        $scope.cardSelection.push(card);
        console.log("$scope.currentStepCount",$scope.currentStepCount)
        console.log("$scope.cardSelection.length",$scope.cardSelection.length)
        
        if ($scope.cardSelection.length === 2){

            // right association
            if ($scope.cardSelection[0].match === $scope.cardSelection[1].match){
                $scope.cardSelection[0].confirmed = $scope.cardSelection[1].confirmed = true;
                confirmedCouplesCount++;
                //console.log("confirmedCouplesCount",confirmedCouplesCount)
                if ((($scope.currentStepCount==0) && confirmedCouplesCount >= 3) || ($scope.currentStepCount==1 && confirmedCouplesCount >= 3)){

                   
                    if ($scope.currentStepCount < 1){
                         // next step
                         $scope.nextButtonVisible = true;
                     }else{
                        $scope.exercise.confirm();
                        $scope.timeStarted = false;
                        //$interval.cancel(timerInterval);
                        $scope.page().viewed();
                        //var remainingTime = $scope.timerState.initialTimerMs-$scope.timerState.timeElapsed;
                        //if ((remainingTime - 1000) > 0){ // se non è scaduto il tempo
                        //var totScore = 150;
                        //var extraScore = Math.floor(remainingTime/1000/10)*10; // 10 punti ogni 10 secondi rimanenti
                        //$scope.feedback = "Complimenti! Hai completato il game. Il tuo punteggio è " + (Math.round(totScore)+extraScore);
                        //GameService.addScore(totScore, extraScore, remainingTime,'G_MEM');
                        //}
                        $scope.continueFedbackVisible = true;
                        //console.log("quiiiiiiiiiiiii")
                    }

                }
            }else{ // wrong association
                var card1 = $scope.cardSelection[0];
                var card2 = $scope.cardSelection[1];
                $timeout(function(){
                    $scope.flipCard(card1)
                    $scope.flipCard(card2)
                },1500);
            }
            $scope.cardSelection = [];
        }
        // $scope.Page.next()

    }


}]);

app.controller('CruciverbaController', ['$scope', 'App', 'MenuButton', 'Overlay', function ($scope, App, MenuButton, Overlay) {
    var model = $scope.page().html() ? $scope.page().html() : $scope.page().video().currentTiming().getModule('Html')[0];
    $scope.propsComponent = model.getAttr('propsComponent');
    $scope.closeModuleHandler = function(){
        App.closeModule();
    }
    $scope.pageViewed = function(){
        $scope.page().viewed();
    }
}]);

app.controller('DownloadCertificateController', function ($scope, App, Tracking, $filter) {

    $scope.page().viewed();
    Tracking.update();

    // create pdf only in offlineMode
    if (App.config().getAttr('offlineMode')) {
        /** FORM FOR OFFLINE PACKAGE **/
        $scope.isOfflineMode = App.config().getAttr('offlineMode');

        var userInfo = App.getUserInfo();
        /** END FORM FOR OFFLINE PACKAGE **/

        $scope.downloadable = false;

        var doc = new jsPDF({
            orientation: 'landscape',
            unit: 'px'
        });

        $scope.createPdf = function (imgData) {
            var MARGIN = 100;
            var WIDTH_IMG = 3508;
            var score = $scope.totPerc;
            var documentStr = "certificates.image64";
            var completionText = $filter('translate')("certificates.completionText");
            var moduleTitle = $filter('translate')("certificates.moduleTitle");

            var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
            if (!isIE11) {
                doc.addFileToVFS("Roboto.ttf", "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");
                doc.addFont('Roboto.ttf', 'Roboto', 'normal');
                doc.setFont('Roboto');
                doc.setFontType("normal");
            }

            var width = doc.internal.pageSize.width;
            var height = doc.internal.pageSize.height;

            var convertPxUnit = function convertPxUnit(pxValue) {
                var perc = WIDTH_IMG / width;
                return pxValue / perc;
            };

            doc.addImage($filter('translate')(documentStr), 'jpg', 0, 0, width, height);
            doc.setTextColor(12, 49, 56);

            doc.setFontSize(38);
            var nomeCognome = (userInfo.firstName + " " + userInfo.lastName).toUpperCase();
            var textWidth = doc.getStringUnitWidth(nomeCognome) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetbName = (width - textWidth) / 2;

            doc.text(textOffsetbName, convertPxUnit(1050), nomeCognome + '');
            /* fine nome cognome */

            /* employeeId */
            if (userInfo.employeeId) {
                doc.setFontSize(23);
                textWidth = doc.getStringUnitWidth("Employee ID: " + userInfo.employeeId) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                var textOffsetEmplId = (width - textWidth) / 2;
                doc.text(textOffsetEmplId, convertPxUnit(1190), "Employee ID: " + userInfo.employeeId);
            }

            /* ghrsId */
            if (userInfo.ghrsId) {
                doc.setFontSize(23);
                textWidth = doc.getStringUnitWidth("GHRS ID: " + userInfo.ghrsId) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                var textOffsetGhrsId = (width - textWidth) / 2;
                var verticalOffset = userInfo.employeeId ? 1310 : 1190;
                doc.text(textOffsetGhrsId, convertPxUnit(verticalOffset), "GHRS ID: " + userInfo.ghrsId);
            }

            /* emailAddress */
            if (userInfo.emailAddress) {
                doc.setFontSize(19);
                textWidth = doc.getStringUnitWidth("SAIPEM EMAIL ADDRESS:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
                var textOffsetGhrsId = (width - textWidth) / 2;
                var verticalOffset = 1430;
                doc.text(textOffsetGhrsId, convertPxUnit(verticalOffset), "SAIPEM EMAIL ADDRESS:");

                textWidth = doc.getStringUnitWidth(userInfo.emailAddress) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                var textOffsetGhrsId = (width - textWidth) / 2;
                var verticalOffset = 1530;
                doc.text(textOffsetGhrsId, convertPxUnit(verticalOffset), userInfo.emailAddress);
            }

            /* score */
            /*doc.setFontSize(32);
            textWidth = doc.getStringUnitWidth(Math.round(score)+"/100") * doc.internal.getFontSize() / doc.internal.scaleFactor;
            console.log("doc.getStringUnitWidth(score)", textWidth);
            console.log("doc.internal.scaleFactor",doc.internal.scaleFactor)
            var textOffsetScore = (width  - textWidth) / 2;
            doc.text( (textOffsetScore), convertPxUnit(1620), Math.round(score) + '/100');*/
            /* fine score */

            var localDate = moment().format("YYYY/MM/DD");
            /* Date */
            doc.setFontSize(22);
            textWidth = doc.getStringUnitWidth("Date: " + localDate) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetDate = (width - textWidth) / 2;
            doc.text(textOffsetDate, convertPxUnit(1900), "Date: " + localDate);

            /* moduleTitle */
            doc.setFontSize(20);
            textWidth = doc.getStringUnitWidth(moduleTitle) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetModuleTitle = (width - textWidth) / 2;
            doc.text(textOffsetModuleTitle, convertPxUnit(855), moduleTitle);
            /* fine moduleTitle */

            /* completionText */
            doc.setFontSize(20);
            textWidth = doc.getStringUnitWidth(completionText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
            var textOffsetCompletionText = (width - textWidth) / 2;
            doc.text(textOffsetCompletionText, convertPxUnit(1700), completionText);
            /* fine completionText */

            $scope.downloadable = true;
        };

        $scope.downloadPdf = function () {
            // Default export is a4 paper, portrait, using milimeters for units
            //$scope.createPdf()
            doc.save('certificate.pdf');
            //getImageFromUrl('images/box_rosso.jpg', $scope.createPdf());
        };

        $scope.createPdf();
    }
});

(function () {

    'use strict';

    var ExerciseCardController = function ($scope, $timeout) {

        function load() {
            // console.log($scope.exercise);
            $timeout(function() {
                if ($scope.exercise.isConfirmed()) {
                    // console.log($scope.exercise.isAnswered());
                    $scope.flipCard($scope.exercise.isAnswered(), true);
                }
            }, 500);
        }

        //$scope.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        $scope.selectedCard = false;

        $scope.slide = function (dir) {
            $('#carousel-example-generic').carousel(dir);
        };

        $scope.addFlipAnimationToCards = function(){
            // console.log("flip");
            TweenMax.set($(".card-wrap__card"), {rotationY:0});
            $.each($(".card-wrap__card"), function(i,element) {
                var frontCard = $(this).children(".card__front"),
                    backCard = $(this).children(".card__back"),
                    tl = new TimelineMax({paused:true});

                tl
                    .to(frontCard, 1, {rotationY:180})
                    .to(backCard, 1, {rotationY:0},0)
                    .to(element, .5, {z:50},0)
                    .to(element, .5, {z:0},.5);

                element.animation = tl;
            });
        }

        $timeout(function () {
            $scope.addFlipAnimationToCards();
        }, 0);

        $scope.cards = [
            {
                id: "mitaca",
                name: "Mitaca",
                imgUrlFront: "images/lavazza-game/avatar/cards/mitaca_front.svg",
                imgUrlBack: "images/lavazza-game/avatar/cards/mitaca_back.svg",
                color: "orange",
                personality: "Tenacious, brave and resourceful",
                meaningName: "Mitaca and Cosecha Principal are the main harvests in Colombia. They have flowers and ripening berries on the same branch"
            },
            {
                id: "kaffa",
                name: "Kaffa",
                imgUrlFront: "images/lavazza-game/avatar/cards/kaffa_front.svg",
                imgUrlBack: "images/lavazza-game/avatar/cards/kaffa_back.svg",
                color: "green",
                personality: "Ambitious, bold and competitive",
                meaningName: "Kaffa is a region of Ethiopia, the land where Coffea Arabica plants were first discovered in the 9th century AD"
            },
            {
                id: "honey",
                name: "Honey",
                imgUrlFront: "images/lavazza-game/avatar/cards/honey_front.svg",
                imgUrlBack: "images/lavazza-game/avatar/cards/honey_back.svg",
                color: "yellow",
                personality: "Determined and ambitious, she likes to stand out",
                meaningName: "'Honey processed' is the liquid process used to prepare coffee in Costa Rica: once the berries have been stripped, the remaining layer of mucilage is left, giving the coffee a particularly intense aroma"
            }
        ]

        $scope.flipCard = function (card, force = false) {
            // if ($scope.exercise.isConfirmed() && !force)
            //     return;

            // console.log(_.indexOf($scope.exercise.answers(), card));
            var idCard = '#card-'+$scope.exercise.getAttr('id')+'-'+_.indexOf($scope.exercise.answers(), card);

            var index = _.indexOf($scope.exercise.answers(), card);

            $scope.cards[index].clicked = true;
            if ($scope.exercise.getAttr('correct')[0]==index){
                $scope.page().viewed();
                $scope.flipCardCorrect=true;
            }

            // console.log(">",idCard);
            // // var idCard = "#"+card.id;
            // console.log("idCard", card);
            // // idCard = '#card1';
            // console.log("idCard", idCard);
            // console.log("idCard", $(idCard));
            if (card.isFlipped) {
                $(idCard)[0].animation.reverse();
            } else {
                // console.log("$(idCard)[0].animation.play();", $(idCard)[0]);
                $(idCard)[0].animation.play();
            }
            // card.isFlipped = !card.isFlipped;

            // if ($scope.exercise.isConfirmed() && !force) {
            $scope.exercise.setAnswer(card);
            $scope.exercise.confirm();
            // }

            if ($scope.areAllCardClicked()) {
                $scope.exercise.setAttr('allCardClicked', true);
            }

        }

        $scope.onSelectAvatar = function(card){
            $scope.selectedCard = card.id;
            var avatarSelected = {
                id: card.id,
                name: card.name,
                avatarImgUrl: "images/lavazza-game/avatar/dancy.svg",
                color: card.color
            }
            // $scope.Page.next()
        }

        $scope.areAllCardClicked = function () {
            return _.filter($scope.cards, function (card) {
                return !card.clicked;
            }).length === 0;
        };

        load();
    };

    ExerciseCardController.$inject = ['$scope', '$timeout'];

    angular.module('Application')
        .controller('ExerciseCardController', ExerciseCardController);
})();

(function() {

    'use strict';

    var ExerciseController = function($scope, $translate, Exercise, Page, Sound) {

        Exercise.promise().then(function()
        {
            var audio = false;
            var model = $scope.page().html() ? $scope.page().html() : $scope.page().video().currentTiming().getModule('Html')[0];
            $scope.collection =  model.exercises();
            $scope.exercises = $scope.collection.all();

            if(model.getAttr('audio')) {
                audio = Sound.create({
                    src: 'audio/'+model.getAttr('audio')
                });

                audio.play();
            }

            $scope.$watch(function()
            {
                return $scope.collection.isBlocked();
            },
                function(value) {

                    if(!value) {
                        // $scope.page().viewed();
                    }
            });

            Page.events.on('change', function() {
               $scope.collection.callEach('cancel');

                if(audio) audio.pause();
            });


        });

    };

    ExerciseController.$inject = ['$scope', '$translate', 'Exercise', 'Page', 'Sound'];

    angular.module('Application')
        .controller('ExerciseController', ExerciseController);
})();

(function () {
  "use strict";

  var ExerciseCrociateController = function ($scope, $timeout,$filter) {
    function load() {
      // console.log($scope.exercise);

      console.log("$scope.exercise", $scope.exercise);
    }

    $scope.isShowedPopup=false;

    $scope.showPopup=function(text){
        $scope.textPopup=text;
        $scope.isShowedPopup=true;    
    }
    $scope.closePopup=function(){
        $scope.textPopup="";
        $scope.isShowedPopup=false;    
    }

    $scope.selectCell = function (row, column) {

    
       if($scope.exercise.solution===true){
        return;
       } 
      //console.log(row, column)
      $scope.exercise.selectCell(row, column);
      $scope.limitClick = $scope.exercise.checkLimitClick();
        if (!$scope.limitClick){
           let foundedWord= $scope.exercise.checkCorrect();
           if (foundedWord!==false){
                var textFound=$filter('translate')('exerciseTemplate.textFound1') + " " + foundedWord;
                if ($scope.exercise.isEnded())
                    textFound=textFound+"<br>"+$filter('translate')('exerciseTemplate.textFound2')
                $scope.showPopup(textFound)
           }
                
        }else{
            $scope.showPopup($filter('translate')('exerciseTemplate.limitClick'))
        }
    };

    $scope.solution=function(){
        $scope.exercise.solution();
    }   
    load();
  };

  ExerciseCrociateController.$inject = ["$scope", "$timeout","$filter"];

  angular
    .module("Application")
    .controller("ExerciseCrociateController", ExerciseCrociateController);
})();


(function () {

    'use strict';

    var ExerciseSelectController = function ($scope, $timeout, $translate) {

        // console.log("ExerciseSelectController");

        function load() {

            // console.log("content", $scope.exercise.getAttr('content'));
            // console.log("options", $scope.exercise.getAttr('options'));

            // console.log(">>>",$scope.exercise.getAttr('content').match(/\[\[(\d+)\]\]/g));
            // console.log(">>>",$scope.exercise.getAttr('content').replace(/\[\[(\d+)\]\]/g, '$1'));
        }

        $scope.getSelectNumber = function () {
            var content = $translate.instant($scope.collection.current().getAttr('content'));
            let matches = content.match(/\[\[(\d+)\]\]/g);
            return matches === null ? 0 : matches.length;
        };

        $scope.replaceContentItems = function () {
            var i, content = $translate.instant($scope.collection.current().getAttr('content'));
            // console.log("content", content);
            for (i = 0; i < $scope.getSelectNumber(); i++) {
                content = content.replace('[[' + i + ']]', $scope.getOption(i));
            }
            return content;
        };

        $scope.options = $scope.collection.current().getAttr('options');
        // console.log($scope.options);

        $scope.getOption = function (index) {
            // console.log("---",$scope.exercise.getAttr('options'));
            var option = $scope.collection.current().getAttr('options')[index];
            var currentId = $scope.collection.current().getAttr('id');
            // if (index == 0) console.log("replaced option", index, option);
            // var html = '<div class="dropdown dropdown'+index+'" ng-init="opened'+index+'=false;" ng-click="opened'+index+' = !opened'+index+'" ' + 
            //     ' ng-class="{\'open\': opened'+index+', \'correct\': (exercise.isConfirmed() && isOptionCorrect('+index+') || isSolutionVisible()) , \'wrong\': (exercise.isConfirmed() && !isOptionCorrect('+index+')) && !isSolutionVisible() }"><button class="dropbtn" ng-bind-html="getAnswer('+index+')"><i class="glyphicon glyphicon-triangle-bottom"></i> {{\'exerciseTemplate.select\'|translate}}</button><div class="dropdown-content" ng-mouseup="checkClick()">';
            // _.each(option.items, function(item, itemIndex) {
            //     var itemText = $translate.instant(item.text);
            //     var itemIcon = $translate.instant(item.icon);
            //     html += '<a href="#" ng-click="setAnswer(\'<span class=\\\'icon\\\'>'+itemIcon+'</span>'+itemText+'\', '+index+', '+itemIndex+')" ' +
            //         ' ng-class="{\'correct\': exercise.isConfirmed() && isOptionRealCorrect('+index+', '+itemIndex+'), \'wrong\': exercise.isConfirmed() && !isOptionRealCorrect('+index+', '+itemIndex+')}"' +
            //         '><span class="icon">' + itemIcon + '</span>'+ itemText +'</a>';
            // });
            // html += '</div></div>';
            var html = `
            <div class="dropdown dropdown${index}" 
                ng-init="opened${currentId}_${index} = false;"
                ng-click="opened${currentId}_${index} = !opened${currentId}_${index}" 
                ng-class="{
                    'open': opened${currentId}_${index},
                    'correct': (isConfirmed() && isOptionCorrect(${index}) || isSolutionVisible()),
                    'wrong': (isConfirmed() && !isOptionCorrect(${index})) && !isSolutionVisible()
                }">
                    <button class="dropbtn" ng-bind-html="getAnswer(${index})">
                        <i class="glyphicon glyphicon-triangle-bottom"></i> {{'exerciseTemplate.select'|translate}}
                    </button>
                    <div class="dropdown-content" ng-mouseup="checkClick()">`;


            var optionItems = option.items;

            if ($scope.collection.current().getAttr('shuffleItems')) {
                if (!option.shuffledItems) {
                    optionItems = _.shuffle(optionItems);
                    // console.log("shuffle", optionItems);
                    option.shuffledItems = optionItems;
                    // console.log(">>>", option.shuffledItems);
                } else {
                    optionItems = option.shuffledItems;
                }
            }

            _.each(optionItems, function (item, itemIndex) {
                var itemText = $translate.instant(item.text);
                html += `<a href="#" 
                    ng-click="setAnswer(${index}, ${item.id})" 
                    ng-disabled="!opened${currentId}_${index}"
                    ng-class="{
                        'correct': isConfirmed() && isOptionRealCorrect(${index}, ${item.id}),
                        'wrong': isConfirmed() && !isOptionRealCorrect(${index}, ${item.id})
                    }">${itemText}</a>`;
            });
            html += `</div></div>`;
            return html;
        };

        $scope.isConfirmed = function () {
            return $scope.collection.current() && $scope.collection.current().isConfirmed();
        };

        $scope.isOptionCorrect = function (index) {
            return $scope.collection.current().getAttr('options')[index].answer === $scope.collection.current().getAttr('options')[index].match;
        };

        $scope.isOptionRealCorrect = function (index, itemIndex) {
            // console.log("TEST", $scope.exercise.getAttr('options')[index].match, itemIndex);
            return $scope.collection.current().getAttr('options')[index].match == itemIndex;
        };

        var solutionVisible = false;

        $scope.showSolution = function () {
            _.each($scope.collection.current().getAttr('options'), function (option, index) {
                // $('.dropdown'+index+' > .dropbtn').text(option);
                // console.log(option, index)
                console.log(option.items[option.match], $translate.instant(option.items[option.match]))
                // var text = '<span class="icon">' + $translate.instant(option.items[option.match].icon) + '</span>' + $translate.instant(option.items[option.match].text);
                var text = $translate.instant(option.items[option.match].text);
                // console.log("test", text);
                $(`.dropdown${index} > .dropbtn`).html(text);
            });
            solutionVisible = true;
        };

        $scope.isSolutionVisible = function () {
            return solutionVisible;
        };

        $scope.areAllCorrect = function () {
            var result = true;
            _.each($scope.collection.current().getAttr('options'), function (option, index) {
                // $('.dropdown'+index+' > .dropbtn').text(option);
                // console.log(option, index)
                if (option.match != option.answer)
                    result = false;
                return;
            });
            return result;
        };

        $scope.setAnswer = function (index, itemIndex) {
            var optionSelected = $scope.collection.current().getAttr('options')[index];

            console.log("optionSelected", optionSelected)

            var optionItemSelected = optionSelected.items[itemIndex];
            var optionSelectedText = $translate.instant(optionItemSelected.text);
            console.log(optionSelectedText);
            if ($scope.collection.current().isConfirmed()) return;
            $(`.dropdown${index} > .dropbtn`).html(optionSelectedText);
            $scope.collection.current().getAttr('options')[index].answer = itemIndex;



            // if ($scope.collection.current().isConfirmed()) return;
            // // console.log("Set answer!", option, index, itemIndex);
            // $('.dropdown'+index+' > .dropbtn').html(option);
            // $scope.collection.current().getAttr('options')[index].answer = itemIndex;
            // // console.log(">!>",$scope.exercise.isAnswered());
            // // console.log("exercise.isCorrect()", $scope.exercise.isCorrect());
        };


        // $scope.setAnswer = function (index, itemIndex) {
        //     var optionSelected = $scope.collection.current().getAttr('options')[index];
        //     var optionItemSelected = optionSelected.items[itemIndex];
        //     var optionSelectedText = $translate.instant(optionItemSelected.text);
        //     if ($scope.collection.current().isConfirmed()) return;
        //     $(`.dropdown${index} > .dropbtn`).html(optionSelectedText);
        //     $scope.collection.current().getAttr('options')[index].answer = itemIndex;
        // };

        $scope.getAnswer = function (index) {
            if (!$scope.collection.current().isConfirmed()) {
                return `<span>${$translate.instant('exerciseTemplate.select')}</span>`;
            } else {
                var i = $scope.collection.current().getAttr('options')[index].answer;
                var text = $scope.collection.current().getAttr('options')[index].items[i].text;
                var icon = $scope.collection.current().getAttr('options')[index].items[i].icon;
                // console.log(text);
                return $translate.instant(text);
                // return '<span class="icon">' + $translate.instant(icon) + '</span>' + $translate.instant(text);
            }
            // console.log("getAnswer", index);
            // console.log($scope.collection.current().getAttr('options')[index]);
        };

        $(window).on('mouseup', function (e) {
            var currentId = $scope.collection.current().getAttr('id');
            _.each($(".dropdown"), function (cont, index) {
                if (!$(cont).is(e.target) && $(cont).has(e.target).length === 0) {
                    // console.log("$scope['opened'+index]",index,$scope['opened'+index])                    
                    $scope[`opened${currentId}_${index}`] = false;
                }
            });
            $scope.$apply();
        });

        // $(window).on('click', function (e) {
        //     console.log(e.target);
        // });

        var calcBoundaries = function () {
            console.log($("#page")[0]);
            var rect0 = $("#page")[0].getBoundingClientRect();
            var rect1 = $(".dropdown7 > .dropdown-content")[0].getBoundingClientRect();
            console.log(rect0);
            console.log(rect1);

            if (rect1.bottom > rect0.bottom) console.log("outside");
        }


        $timeout(function () {
            // var overlap = !(rect1.right < rect2.left || 
            //     rect1.left > rect2.right || 
            //     rect1.bottom < rect2.top || 
            //     rect1.top > rect2.bottom)

            calcBoundaries();
        }, 2500);

        $scope.$watch(function () {
            return $scope.opened7;
        }, function (result) {
            if (result) {
                $timeout(function () {
                    calcBoundaries();
                }, 1500);
            }
        });


        load();

    };

    ExerciseSelectController.$inject = ['$scope', '$timeout', '$translate'];

    angular.module('Application')
        .controller('ExerciseSelectController', ExerciseSelectController);
})();

(function () {

    'use strict';

    var ExerciseSingleAccordionController = function ($scope, $timeout) {

        function load() {
            
        }

        var __currentCollapse = 0;

        $scope.isCurrentCollapse = function (index) {
            return __currentCollapse === index;
        };

        $scope.setAnswer = function (answer) {
            // if (!$scope.hasDone()) _answer = answer;
            // $scope.showOption(answer);
            // $scope.page().viewed();
            // //$rootScope.$emit('page.unblock');
            // //$scope.LMS.updatePages($scope.getIndexPage());
        };

        $scope.hoverOut = function (index) {
            return;
            console.log("HoverOut");
            if (index === __currentCollapse) return;
            $('#collapse_' + index).collapse('hide');
        };

        $scope.setOption = function (index) {
            // return;
            __currentCollapse = index;
        };

        $scope.showOption = function (index) {
            return;
            console.log(index);
            __currentCollapse = index;
            $('.panel-collapse').collapse('hide');
            $('#collapse_' + __currentCollapse).collapse('show');

            // for (var i = 0; i < 3; i++) {
            //     $('#collapse_' + i).collapse(i == __currentCollapse ? 'show' : 'hide');
            // }
            // $scope.$apply();
        };

        load();
    };

    ExerciseSingleAccordionController.$inject = ['$scope', '$timeout'];

    angular.module('Application')
        .controller('ExerciseSingleAccordionController', ExerciseSingleAccordionController);
})();

(function () {

    'use strict';

    var ExerciseYesNoCounterController = function ($scope, $timeout, $translate, Page, Sound) {

        var audioEnd = false;

        $scope.currentRange = 0;

        function load() {}

        if ($scope.exercise.getAttr('audioEnd')) {
            audioEnd = Sound.create({
                src: $translate.instant($scope.exercise.getAttr('audioEnd'))
            });
        }

        $scope.getCounterValues = function () {
            return _.countBy($scope.exercise.getAttr('items'), function (item) {
                return item.answer;
            });
        };

        $scope.isRangeCompleted = function (pageIndex) {
            return _.filter($scope.exercise.getAttr('items'), function (item, index) {
                return Math.floor(index / $scope.exercise.getAttr('itemsPerPage')) === pageIndex && item.answer === undefined;
            }).length === 0;
        };

        $scope.totRanges = function () {
            return Math.ceil($scope.exercise.getAttr('items').length / $scope.exercise.getAttr('itemsPerPage'));
        };

        $scope.isLastRange = function () {
            return $scope.totRanges() - 1 === $scope.currentRange;
        };

        $scope.nextRange = function () {
            $scope.currentRange++;
        };

        $scope.selectRange = function (index) {
            $scope.currentRange = index;
        };

        $scope.isInRange = function (index) {
            return Math.floor(index / $scope.exercise.getAttr('itemsPerPage')) === $scope.currentRange;
        };

        $scope.setAnswer = function (item, index) {
            if ($scope.exercise.isAnswered() || $scope.exercise.isConfirmed())
                return;

            $scope.exercise.setAnswer(item, index);

            if ($scope.exercise.isAnswered()) {
                console.log("CONFIRM");
                $scope.exercise.confirm();
                if (audioEnd) audioEnd.play();
            }
        };

        Page.events.on('change', function() {
            if (audioEnd) audioEnd.pause();
        });

        load();
    };

    ExerciseYesNoCounterController.$inject = ['$scope', '$timeout', '$translate', 'Page', 'Sound'];

    angular.module('Application')
        .controller('ExerciseYesNoCounterController', ExerciseYesNoCounterController);
})();

app.controller('LinksController', ['$scope', '$window', '$translate', 'App', 'MenuButton', 'Tracking', function ($scope, $window, $translate, App, MenuButton, Tracking) {

    // console.log("TEST");

    $scope.page().viewed();

    Tracking.update();

}]);

(function(){

    'use strict';

    var MainController = function(
        $scope,
        App,
        Menu,
        MenuButton,
        Page,
        Dispatcher,
        Exercise,
        Overlay,
        Subtitles,
        Helper,
        Video,
        Glossary,
        Translation,
        $compile,
        $timeout,
        $rootScope,
        $window,
        $translate,
        Tracking
    )
    {

        // inizializzo tutte le variabili quando
        // i file di configurazioni sono stati caricati
        App.promise.then(function () {

            $scope.App = App;
            $scope.Page = Page;
            $scope.menu = Menu;
            $scope.MenuButton = MenuButton;
            $scope.module = App.module();
            $scope.Exercise = Exercise;
            $scope.Overlay = Overlay;
            $scope.Subtitles = Subtitles;
            $scope.Helper = Helper;
            $scope.Glossary = Glossary;
            $scope.Translation = Translation;
            $scope.Video = Video;
       
                    const logoBase64 = 'data:image/png;base64,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'; 
                   

            // get current video
            $scope.video = function(){

                if(!$scope.page())
                  return false;

                return $scope.page().video();
            };

            // shortcut to get current page
            $scope.page = function() {
                if(!$scope.lesson())
                  return false;

                return $scope.lesson().page();
            };

            // shortcut to get current lesson
            $scope.lesson = function() {
                if(!$scope.module())
                  return false;

              return $scope.module().lesson();
            };

            // shortcut to get current module
            $scope.module = function() {
                if(!App.module())
                  return false;
                return App.module();
            };


            Video.events.on('fullscreen', function()
            {
                var videocontrols = $('#video-controls').clone(true, true);
                videocontrols.attr('id', 'video-controls-update');
                videocontrols.removeAttr('ng-if');
                $compile(videocontrols)($scope);
                $('.video-js').append(videocontrols);
                $timeout(function() { $scope.$apply(); },1000);
            });

            Video.events.on('fullscreenOut', function() {
                $('#video-controls-update').remove();
                $timeout(function() { $(window).scrollTop() },1000);
            });

            App.events.on('module.close', function() {
                // console.log("Are all modules viewed?", App.areAllModulesViewed());
                Tracking.update();
            });

            $scope.$watch(function() {
                return (screen.availHeight || screen.height-30) <= window.innerHeight;
            },
            function(value) {
                if(!value)
                {
                    $('#video-controls-update').remove();
                }
            });

            Video.events.on('ended', function() {
                //App.openMenu(true);

                // If it's the end of the module and
                // there are no exercises or timings,
                // close the module and go back to 
                // the modules index
                // if (
                //     (App.isAtLastPage() || !App.hasNextPage()) &&
                //     (!$scope.page().hasExercise() && !$scope.video().hasObligatoryTiming()) 
                // ) {
                //     App.closeModule();
                // }
                // $rootScope.$apply()
            });

            $scope.openLink = function(path) {
                $window.open($translate.instant(path), "_blank");
                return path;
            };

            $scope.loaded = false;
            $scope.hasLoaded = function() {
                return $scope.loaded;
            };

            function load() {
                // console.log('loading...');
                var to = $timeout(function() {
                    // if (!$scope.amIOverControls) {
                        $scope.loaded = true;
                        // console.log('loaded...', $scope.loaded);
                    // }
                }, 1500);
            }
            
            // load();

            App.events.on('module.open', function() {
                $scope.loaded = false;
                // console.log("module open: show controls");
                load();

                resizedw();
            });

            $scope.isOS = function() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }



            // FIXME
            $timeout(function() {
                if (App.modules().count() == 1)
                    // App.goToModule(0);
                    App.goWhereYouLeft();
            }, 500);

            function fixLayoutRatio() {
                var vRatio = 1920 / 1080; // 1.777
                // console.log("VideoRatio:  ", vRatio);

                var wW = $(window).width();
                var wH = $(window).height();
                var wRatio = wW / wH;
                // console.log("WindowRatio: ", wRatio);
                // console.log("Resize based on " + (wRatio > vRatio ? "HEIGHT" : "WIDTH"));

                $timeout(function() {
                    // if (wRatio > vRatio) {
                        // console.log("hLessons", $('#lessons').height());
                        // console.log("hWindow", $(window).height());

                    if ($(window).width() > 1280) {
                        // console.log("WINDWOW > 1200", "height: "+(1200/vRatio) );
                        // console.log("Current height would be: ", (1200 / vRatio), "(" ,((1200 / vRatio)*1.2 + 70), ")",  ((1200 / vRatio)*1.2 + 70) > $(window).height() ? "but it would be to high" : "and it's fine" );

                        if (((1200 / vRatio)*1.2 + 70) > $(window).height()) {
                            $('#lessons').height(($(window).height()*0.8));
                            $('#lessons').width((($(window).height()*0.8)-70) * vRatio);

                            // console.log("New ",(($(window).height()*0.8)-70) * vRatio,"x",($(window).height()*0.8)-70);
                        } else {
                            $('#lessons').width( 1200 );
                            $('#lessons').height( (1200 / vRatio)+70 );
                        }

                        // if (($(window).height()*0.8) < (1200/vRatio)) {
                        //     console.log("VideoH ("+(1200/vRatio)+") > WindowH ("+($(window).height()*0.8)+")");

                        //     $('#lessons').width( (( ($(window).height()*0.8))*vRatio) );
                        // } else {
                        //     console.log("VideoH ("+(1200/vRatio)+") < WindowH ("+($(window).height()*0.8)+")");
                        //     $('#lessons').height( ( ( ($(window).width()) /vRatio) ) * 0.8 );
                        // }
                    } else {
                        // var newH = ( $('#lessons').width() / vRatio );
                        var newH = (($(window).width()*0.9)+70) / vRatio;
                        // console.log("newH", newH);
                        var wH = $(window).height();
                        if (newH > (wH)) {
                            // console.log("HERE");
                            $('#lessons').width(( wH * vRatio ));
                        } else {
                            // console.log("THERE");
                            // $('#lessons').width('90%');
                            $('#lessons').width($(window).width()*0.9);
                            $('#lessons').height((($(window).width()*0.9) / vRatio)+70);
                        }
                    }

                    // console.log("*****************************");

                }, 500);

                var wW = $(window).width();
                var hW = $(window).height();

            }

            function getWindowWidth() {
                return ($(window).innerWidth() > 0) ? $(window).innerWidth() : $(window).width();
                return (window.innerWidth > 0) ? window.innerWidth : screen.width;
            }

            function getWindowHeight() {
                return ($(window).innerHeight() > 0) ? $(window).innerHeight() : $(window).height();
                return (window.innerHeight > 0) ? window.innerHeight : screen.height;
            }

            function fixLayoutMobile() {
                var newWidth = 0, newHeight = 0;
                // console.log("$(window).width() x $(window).height()",$(window).width(), $(window).height(), getWindowHeight()+70);

                if (getWindowWidth() / (getWindowHeight()-70) < 1.77) {
                    // console.log("ALTEZZA");
                    newWidth = '100vw';
                    newHeight = 'calc(56.497175vw + 70px)';
                } else {
                    // alert("LARGHEZZA");
                    // console.log("LARGHEZZA");
                    newWidth = 'calc((100vh - 70px) * 1.77)';
                    newHeight = '100%';
                }
                $timeout(function() {
                    $('#lessons').css({
                        // 'width': '100%',
                        // 'height': '100%',
                        // 'height': 'calc(56.497175vw + 70px)'
                        'width': newWidth,
                        'height': newHeight,
                    });
                }, 550);
            }
                
            function resizedw() {

            $timeout(function() {
                // alert(">",getWindowHeight());
                // alert("wx> " + $(window).width());
                // alert("hx> " + $(window).height());
                // // alert("y> " + $(window).innerHeight());
                // alert("lessons> " + $('#lessons').innerHeight());
                // alert("DPR "+window.devicePixelRatio);

                // if (getWindowWidth() > 1024 && getWindowHeight() > 640) {
                if ($(window).width() > 1024 && $(window).height() > 640) {
                    // console.log("resize");
                    fixLayoutRatio();
                } else {
                    fixLayoutMobile();
                }
            }, 1000);
            }

            var doit;
            $( window ).resize(function() {
                clearTimeout(doit);
                doit = setTimeout(resizedw, 100);
                
                // if (getWindowWidth() > 1024 && getWindowHeight() > 640) {
                //     console.log("resize");
                //     fixLayoutRatio();
                // } else {
                //     $timeout(function() {
                //         $('#lessons').css({
                //             'width': '100%',
                //             'height': '100%',
                //         });
                //     }, 550);
                // }

                // var hIndex = $('#indice').width();
                // console.log("Indice",$('#indice').width());
                
                // var hVideoControls = $('#header .head-video-controls').width();
                // console.log("Width",$('#header .head-video-controls').width());

                // var hWindow = $(window).width();
                
                // $('#header .head-title > h2').width(hWindow - (hIndex + hVideoControls + 75));
                // console.log("newheadtitle", hWindow - (hIndex + hVideoControls));
            });

            $timeout(function() {
                if (getWindowWidth() > 1024) {
                    fixLayoutRatio();
                }
                resizedw();
            }, 1000);

            // fixLayoutRatio();
            resizedw();

            $scope.randomBgColor = false;
            $scope.getRandomBgColor = function() {
                if (!$scope.randomBgColor)
                    $scope.randomBgColor = 'bg-color-0' + ((Math.round(Math.random() * 10) % 4) + 1);
                return $scope.randomBgColor;
            };

            Page.events.on('change', function() {
                $scope.randomBgColor = false;
            });
     
            $timeout(function() {
                if (getWindowWidth() > 1024) {
                    fixLayoutRatio();
                }
                resizedw();
            }, 1000);
            $scope.isPdfLoading = false;
            var certificate = null;
        
            const studentName = Tracking.getStudentName() || 'student name';
            $scope.downloadActive = true;
            const A4_WIDTH_PX  = 1920;
            const A4_HEIGHT_PX = 1080;
            $scope.downloadable = true;

            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'px',
                format: [A4_WIDTH_PX, A4_HEIGHT_PX]
              });
                    //  doc.addFileToVFS('Myfont.ttf', BASE64_FONT_STRING);
                // doc.addFont('Myfont.ttf', 'GTEesti', 'normal');

              $scope.createPdf = function(logo, name) {
                var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                if (!isIE11) {
                    doc.addFileToVFS("Campari.ttf", "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");
                    doc.addFont('Campari.ttf', 'Campari', 'normal');
                    doc.setFont('Campari');
                    doc.setFontType("normal");
                }
                doc.setFillColor(22, 43, 83);
                doc.rect(0, 0, A4_WIDTH_PX, A4_HEIGHT_PX, 'F');
              
                const M = 20;
                doc.setDrawColor(255, 255, 255);
                doc.setLineWidth(6);
                doc.rect(M, M, A4_WIDTH_PX - 2*M, A4_HEIGHT_PX - 2*M);
              
                const TOP_PADDING = 270;
              
                const logoW = 446, logoH = 36;
                const logoX = (A4_WIDTH_PX - logoW) / 2;
                const logoY = M + TOP_PADDING;
                doc.addImage(logo, 'PNG', logoX, logoY, logoW, logoH);
              
                const titleLines = [
                  'Governance AI Advisory Hub',
                  'Onboarding Process for Camparistas'
                ];
                doc.setFontSize(110).setTextColor(255, 255, 255);
              
                let cursorY = logoY + logoH + 120; 
                const lineHeight = 130;
                titleLines.forEach(line => {
                  const tw = doc.getTextWidth(line);
                  const x  = (A4_WIDTH_PX - tw) / 2;
                  doc.text(line, x, cursorY);
                  cursorY += lineHeight;
                });
              
                doc.setFontSize(120).setTextColor(255, 255, 255);
              
                const nameW = doc.getTextWidth(name);
                const nameX = (A4_WIDTH_PX - nameW) / 2;
                doc.text(name, nameX, cursorY + 40);
              
                return doc;
              };
              
              
              
              

        $scope.downloadCertificate = function() {
        if ($scope.isPdfLoading) return;
        $scope.isPdfLoading = true;
        const doc = $scope.createPdf(logoBase64, studentName);
        window.open(doc.output('bloburl'), '_blank');
        $scope.isPdfLoading = false;
        };

        document.addEventListener("visibilitychange", function() {
                if (document.visibilityState === 'visible') {
                   $scope.video().play()
                } else {
                    $scope.video().pause()
                }
                $scope.$apply();
        });
            // App.useLang();
            $scope.lang = function () { return App.useLang() };
            console.log($scope.lang);

        });
    }

    MainController.$inject = [
        '$scope',
        'App',
        'Menu',
        'MenuButton',
        'Page',
        'Dispatcher',
        'Exercise',
        'Overlay',
        'Subtitles',
        'Helper',
        'Video',
        'Glossary',
        'Translation',
        '$compile',
        '$timeout',
        '$rootScope',
        '$window',
        '$translate',
        'Tracking'
    ];

    angular.module('Application')
        .controller('MainController', MainController);

})();

(function () {

    'use strict';

    var MappableController = function ($scope, $translate, $injector, $timeout, $window, App, Page, Subtitles, Tracking, Detailed, Overlay, Translation) {

        $scope.isDevelMode = App.config().getAttr('layout').debugDetailed;

        function load() {

            var model = $scope.page().html() ?
                $scope.page().html() :
                (
                    $scope.page().video().currentTiming() ?
                    $scope.page().video().currentTiming().getModule('Html')[0] :
                    null
                );

            if (!model) return model;

            $scope.isDevelMode = model.getAttr('develMode') || $scope.isDevelMode;

            $scope.image = model.getAttr('image');

            $scope.openOverlay = function (obj) {

                if ($scope.isDevelMode) return; // FIXME

                if (obj.getAttr('nextPage')) {
                    Page.next()
                    return obj;
                }

                if (obj.getAttr('pdf')) {
                    $window.open($translate.instant(obj.getAttr('pdf')), "_blank");
                    obj.open();
                    Overlay.close();
                    return obj;
                }

                if (obj.getAttr('link')) {
                    $window.open($translate.instant(obj.getAttr('link')), "_blank");
                    obj.open();
                    Overlay.close();
                    return obj;
                }

                if (obj.getAttr('href')) {
                    $window.open($translate.instant(obj.getAttr('href')), "_blank");
                    obj.open();
                    Overlay.close();
                    return obj;
                }

                obj.open();
            };

            $scope.areDetailsAllViewed = function () {
                return false;
                return !!!_.filter($scope.page().video().currentTiming().details(), function (detail) {
                    return !detail.viewed();
                }).length;
            };

        }

        Page.events.on('change', function () {
            load();
        });

        load();

        var resize = function (openSubtitle) {
            // $scope.parentContainerWidth = openSubtitle ? window.innerWidth * 70 / 100 : window.innerWidth
            // //$scope.parentContainerWidth = window.innerWidth
            // //console.log("$scope.parentContainerWidth", $scope.parentContainerWidth)
            // $scope.parentContainerHeight = window.innerHeight - 85;
            // //console.log("$scope.parentContainerHeight", $scope.parentContainerHeight)
            // /* spazi neri sopra/sotto video  */
            // //$scope.containerWidth = window.innerWidth;

            // $scope.containerWidth = openSubtitle ? window.innerWidth * 70 / 100 : window.innerWidth
            // //$scope.containerHeight = window.innerWidth * 0.5625;
            // $scope.containerHeight = $scope.containerWidth * 0.5625;
            // /* spazi neri sinistra/destra video  */
            // if ($scope.containerHeight > window.innerHeight - 85) {
            //     $scope.containerHeight = window.innerHeight - 85;
            //     $scope.containerWidth = (window.innerHeight - 85) * 1.777;  // 1.777 = 1920 / 1080 = 1280 / 720;

            // }

            // $scope.containerHeight = window.innerHeight - 85;
            // $scope.containerWidth = (window.innerHeight - 85) * 1.777;  // 1.777 = 1920 / 1080 = 1280 / 720;
        }

        window.onresize = function () {
            $timeout(function () {
                resize(Subtitles.panel.isOpened());
                $scope.$apply();
            }, 0);
        };
        resize(Subtitles.panel.isOpened());

        Subtitles.panel.on("open", function () {
            $timeout(function () {
                resize(true);
                $scope.$apply();
            }, 0);
        });
        Subtitles.panel.on("close", function () {
            $timeout(function () {
                resize();
                $scope.$apply();
            }, 0);
        });


        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) { // ESC
                // console.log(Overlay.isOpened());
                Overlay.close();
                $scope.$apply();
            }
        });

        $scope.isDraggable = false;

        $timeout(function () {
            if ($scope.isDevelMode) {


                $scope.isDraggable = true;
                $scope.toggleDraggable = function () {
                    if ($scope.isDraggable) {
                        // $('.container__clickable-area').draggable({ disabled: true });
                        $('.container__clickable-area').draggable("disable");
                    } else {
                        $('.container__clickable-area').draggable("enable");
                    }
                    $scope.isDraggable = !$scope.isDraggable;
                };
                
                // $('.container__clickable-area').draggable({ disabled: true });
        
                // $('.container__clickable-area').draggable("enable");

                console.log("Devel mode on!");
                $('.container__clickable-area').draggable({
                    drag: function () {
                        console.log($(this).parent().width(), $(this).parent().height());

                        var offset = $(this).offset();
                        var xPos = offset.left;
                        var yPos = offset.top;


                        console.log("w", $(this).outerWidth());
                        console.log("h", $(this).outerHeight());

                        // console.log("xPos", xPos);
                        // console.log("yPos", yPos);
                        // console.log("xPos (-parent)", xPos - $(this).parent().offset().left);
                        // console.log("yPos (-parent)", yPos - $(this).parent().offset().top);
                        // console.log("PERC% W: ", (((xPos - $(this).parent().offset().left) * 100) / $(this).parent().width()));
                        // console.log("PERC% H: ", (((yPos - $(this).parent().offset().top) * 100) / $(this).parent().height()));

                        // console.log("coords",$('#coords-container', this).length);
                        if ($('body #coords-container').length == 0) {
                            jQuery('<div/>', {
                                id: 'coords-container'
                            }).appendTo('body');
                        }
                        $('#coords-container').html(
                            "<div><strong>\"top\"</strong>: \"" + Math.round((((yPos - $(this).parent().offset().top) * 100) / $(this).parent().height()) * 100) / 100 + "%\",</div>" +
                            "<div><strong>\"left\"</strong>: \"" + Math.round((((xPos - $(this).parent().offset().left) * 100) / $(this).parent().width()) * 100) / 100 + "%\",</div>"

                            +
                            "<div><strong>\"width\"</strong>: \"" + Math.round((($(this).outerWidth() * 100) / $(this).parent().width()) * 100) / 100 + "%\",</div>" +
                            "<div><strong>\"height\"</strong>: \"" + Math.round((($(this).outerHeight() * 100) / $(this).parent().height()) * 100) / 100 + "%\"</div>"
                        );
                    }
                });
            }

        }, 1500);
    };

    MappableController.$inject = ['$scope', '$translate', '$injector', '$timeout', '$window', 'App', 'Page', 'Subtitles', 'Tracking', 'Detailed', 'Overlay', 'Translation'];

    angular.module('Application')
        .controller('MappableController', MappableController);

})();

app.controller('MenuController', ['$scope', 'App', 'MenuButton', 'Overlay', function ($scope, App, MenuButton, Overlay) {
        $scope.App = App;
        $scope.MenuButton = MenuButton;
        $scope.Overlay = Overlay;
    }]);

(function(){

	'use strict';

	var ResourcesController = function($scope, $translate, App, Page, Exercise, Sound, Tracking, Translation, $window) {

        var audio = false;

        function load() {
            var model = $scope.page().html() ?
            $scope.page().html() : ($scope.page().video().currentTiming() ? $scope.page().video().currentTiming().getModule('Html')[0] : null);
    
            if(!model) return;

            if (model.getAttr('viewedOnLoad')) {
                $scope.page().viewed();
            }

            if (model.getAttr('audio')) {
                audio = Sound.create({
                    src: model.getAttr('audio')
                });
                
                audio.play();
            }

            Page.events.on('change', function() {
                if(audio) {
                    audio.pause();
                    audio = false;
                }
            });

            App.events.on('module.close', function() {
                if(audio) {
                    audio.pause();
                    audio = false;
                }
            });

        }

        $scope.downloadFile = function(obj) {
            $window.open(obj.target.attributes.href.value);
            $scope.page().viewed();
        };

        load();
	};

	ResourcesController.$inject = ['$scope', '$translate', 'App', 'Page', 'Exercise', 'Sound', 'Tracking', 'Translation', '$window'];

	angular.module('Application')
		.controller('ResourcesController', ResourcesController);

})();

app.controller('SynthesisController', ['$scope', '$window', '$translate', 'App', 'MenuButton', 'Overlay', function ($scope, $window, $translate, App, MenuButton, Overlay) {

    // console.log("TEST");

    $scope.openLink = function(path) {
        // console.log("Open Link");
        $window.open($translate.instant(path), "_blank");

        $scope.page().viewed();

        return path;
    };

}]);

(function () {

    'use strict';

    var TemplateController = function ($scope, $translate, $timeout, App, Page, Video, Exercise, Sound) {

        var __showReport = false;
        var __showRecap = false;
        var __answersGiven = false;
        var __showRecapMessage = false;
        var __canEdit = false;

        var closeModTimeout;
        
        var audio = false;

        function load() {

            // console.log("TemplateController.load()");

            Exercise.promise().then(function () {
                audio = false;

                var model = $scope.page().html() ?
                    $scope.page().html() : ($scope.page().video().currentTiming() ? $scope.page().video().currentTiming().getModule('Html')[0] : null);

                if (!model) return;
                var exerciseIndex = model.getAttr('Exercise');
                console.log(model);
                $scope.collection = Exercise.getById(exerciseIndex);
                $scope.collection = $scope.collection.limit(10);
                $scope.pages = App.lesson().pagesWithExercises();
                $scope.pageIndex = _.indexOf($scope.pages, $scope.page());

                //console.log("audio" + model.getAttr('audio'))

                if (model.getAttr('audio')) {
                    // console.log("audio" + model.getAttr('audio'))
                    audio = Sound.create({
                        src: $translate.instant(model.getAttr('audio'))
                    });
                    // console.log("audio", audio);
                    audio.play();
                }

                $scope.isBlocked = function () {
                    var _return = false;
                    _.each($scope.collection.all(), function (el) {
                        if (!el.isConfirmed()) {
                            _return = true;
                            return;
                        }
                    });
                    return _return;
                }

                $scope.$watch(function () {
                    return $scope.isBlocked();
                },
                    function (value) {
                        if (!value) {
                            // $scope.page().viewed();
                            //console.log("feedback qui")

                            if (!$scope.collection.current().getAttr('feedback')) {
                                if (!$scope.video().ended()) {
                                    $scope.page().video().play();
                                } else if (App.hasNextPage()) {
                                    Page.next();
                                } else {
                                    $scope.showReport();
                                }
                            }
                        }
                    });

                $scope.calcPerc = function () {
                    var number = $scope.collection.getCurrentNumber() - 1;
                    return ((number * 100) / $scope.collection.count());
                };
            });

        }

        // console.log("TemplateController");

        $scope.showReport = function () {
            __showReport = true;
            __showRecap = false;
            __showRecapMessage = false;
            $scope.passed = $scope.collection.count('isCorrect');
        };

        $scope.showRecap = function () {
            __showRecap = true;
            __showReport = false;
            __showRecapMessage = false;
        };

        $scope.retry = function () {
            _.each($scope.collection.all(), function (exercise) {
                exercise.cancel();
            });
            $scope.collection.atStart();
            $scope.collection = null;

            load();

            __showRecap = false;
            __showReport = false;
            __showRecapMessage = false;
            __canEdit = true;
        };

        $scope.showRecapMessage = function () {
            __showReport = false;
            __showRecap = false;
            __showRecapMessage = true;
        }

        $scope.isReportVisible = function () {
            return __showReport;
        };

        $scope.isRecapVisible = function () {
            return !$scope.isReportVisible() && __showRecap;
        };

        $scope.isRecapMessageVisible = function () {
            return !$scope.isReportVisible() && __showRecapMessage;
        };

        $scope.viewAnswersGiven = function () {
            __answersGiven = true;
            __showReport = false;
            $scope.collection.atStart();
        };

        $scope.hideAnswersGiven = function () {
            __answersGiven = false;
            __showReport = true;
            $scope.collection.atStart();
        };

        $scope.canViewAnswersGiven = function () {
            return __answersGiven;
        };

        // Page.events.on('change.pre', function () {
        //     if (!$scope.isBlocked()) $scope.page().viewed();
        // });

        Page.events.on('change', function () {
            load();
        });

        App.events.on('module.close', function () {
            $timeout.cancel(closeModTimeout);
        });

        Video.events.on('play', function () {
            
        });

        load();

    };

    TemplateController.$inject = ['$scope', '$translate', '$timeout', 'App', 'Page', 'Video', 'Exercise', 'Sound'];

    angular.module('Application')
        .controller('TemplateController', TemplateController);
})();

(function () {
    'use strict';

    var TemplateFillController = function ($scope, $translate, $timeout, App, Page, Video, Exercise) {

        function load() {
            Exercise.promise().then(function () {
                var model = $scope.page().html()
                    ? $scope.page().html()
                    : ($scope.page().video().currentTiming() ? $scope.page().video().currentTiming().getModule('Html')[0] : null);

                if (!model) return;

                var exerciseIdx = model.getAttr('Exercise');
                $scope.collection = Exercise.getById(exerciseIdx).limit(1); // una sola fill per pagina
                $scope.collection = Exercise.getById(exerciseIdx).limit(1);
$scope.exercise = $scope.collection.current(); // ← aggiungi questa riga

// se cambi pagina/lingua, riallinea anche exercise
$scope.$watch(function(){ return $scope.collection && $scope.collection.getCurrentNumber(); }, function(){
  if ($scope.collection) $scope.exercise = $scope.collection.current();
});
            });
        }

        $scope.onCellInput = function (cell) {
            $scope.collection.current().setCellAnswer(cell, cell.userAnswer);
        };

        $scope.confirm = function () {
            $scope.collection.current().confirm();
            if ($scope.collection.current().isCorrect()) {
                // opzionale: avanzamento automatico
                if (!$scope.video().ended()) $scope.page().video().play();
                else if (App.hasNextPage()) Page.next();
                else $scope.page().viewed();
            }
        };

        $scope.retry = function () {
            $scope.collection.current().repeat();
        };

        $scope.solution = function () {
            $scope.collection.current().solution();
        };

        $scope.isAnswered = function () {
            return $scope.collection && $scope.collection.current().isAnswered();
        };

        $scope.isCorrect = function () {
            return $scope.collection && $scope.collection.current().isCorrect();
        };

        $scope.isCellCorrect = function (cell) {
            return $scope.collection && $scope.collection.current().isCellCorrect(cell);
        };

        Page.events.on('change', function () { load(); });
        load();
    };

    TemplateFillController.$inject = ['$scope', '$translate', '$timeout', 'App', 'Page', 'Video', 'Exercise'];

    angular.module('Application')
        .controller('TemplateFillController', TemplateFillController);
})();


(function () {

    'use strict';

    var TemplateQuestionController = function ($scope, $translate, App, Page, Video, Exercise, Sound) {

        var audio;

        function load() {
            
        }

        // $scope.retry = function() {
        //     _.each($scope.collection.all(), function(exercise) {
        //         exercise.cancel();
        //     });
        //     $scope.collection.atStart();
        //     $scope.collection = null;

        //     load();
        // };


        // setInterval(function() {
        //     var d = $scope.collection.current().getAttr('choices');
        //     console.log(d);
        //     var e = $scope.collection.current().getAttr('options');
        //     console.log(e);
        // }, 2500);

        /*
        $scope.confirm = function() {
            var exercise = $scope.collection.current();
            exercise.confirm();

            if (exercise.getAttr('type') == 'single') {
                var audioLocale = $translate.instant("exercises.m1_1.feedback." + exercise.getAnsweredIndex() + ".audio");
                if (audioLocale) {
                    audio = Sound.create({
                        src: audioLocale
                    });
                    audio.play();
                }
            }
        };*/

        $scope.confirmAndNext = function() {
            var exercise = $scope.collection.current();
            exercise.confirm();

            if (App.hasNextPage()) Page.next();
            return;
        };

        $scope.answerAndNext = function(a) {
            $scope.collection.current().setAnswer(a, $scope.isRecapVisible());
            if (!$scope.collection.current().getAttr('feedback'))
                return (!$scope.video().ended()) ? $scope.page().video().play() : (App.hasNextPage() ? Page.next() : $scope.showReport());
        };


        $scope.confirm = function() {
            var exercise = $scope.collection.current();
            exercise.confirm();

        };

        $scope.solution = function(){
            var exercise = $scope.collection.current();
            // se l'esercizio è corretto o i tentativi sono finiti,
            // mostra la soluzione
            if (exercise.isCorrect() || !exercise.isRepeatable()) {
                $scope.solutionVisible = true;
            }
        };


        $scope.solutionVisible = false;
        // $scope.isSolutionVisible = function() {
        //     return $scope.solutionVisible;
        // }

        // --------------------------------------------------------------------------------------
        // MULTIPLE -----------------------------------------------------------------------------

        $scope.checkOption = function(option) {

            var ex = $scope.collection.current();
            if (ex.isConfirmed()) {
                return;
            }

            if ($scope.isChecked($scope.collection.current().getAttr('choices'), option)) {

                $scope.collection.current().getAttr('choices').splice(
                    $scope.collection.current().getAttr('choices').indexOf(option),
                    1
                );
                // console.log("REMOVE", $scope.collection.current().getAttr('choices'));

                // var filtered = _.filter($scope.collection.current().getAttr('choices'), function(item) {
                //     return item !== option
                // });
                // console.log(filtered);
                return;
            } else {
                // console.log("ADD", $scope.collection.current().getAttr('choices'));
                // console.log($scope.collection.current());
                if ($scope.collection.current().getAttr('choices') === false) {
                    $scope.collection.current().setAttr('choices', []);
                }
                $scope.collection.current().getAttr('choices').push(option);
            }
        };

        $scope.isOptionCorrect = function(option) {
            var index = $scope.collection.current().corrects().indexOf(option);
            return !(index === -1);
        };

        $scope.isChecked = function(choices, option) {
            if (choices === false)
                return false;
            
            var index = choices.indexOf(option);
            return !(index === -1);
        };

        $scope.isAtLeastOneChecked = function () {
            var exercise = $scope.collection.current();
            return exercise.getAttr('choices').length >= 1;
        };

        // $scope.isRepeatable = function() {
        //     return $scope.collection.current().getAttr('repeat') > 0;
        //     var ex = $scope.collection.current();
        //     var repeat = ex.getAttr('repeat');
        //     ex.setAttr('repeat', repeat - 1);
        // };

        $scope.retry = function() {
            var exercise = $scope.collection.current();
            exercise.repeat();
        };

        // $scope.solutionVisible = false;

        $scope.isSolutionVisible = function() {
            if ($scope.collection) {
                var exercise = $scope.collection.current();

                return ($scope.solutionVisible || ( exercise.isConfirmed() && exercise.getAttr('template') != 'card' ) || (
                    exercise.getAttr('template') == 'card' && !! exercise.getAttr('allCardClicked') ) 
                );
            }

            // return $scope.solutionVisible || ($scope.page().isViewed() && exercise.isConfirmed());
        }

        // fine MULTIPLE ------------------------------------------------------------------------
        // --------------------------------------------------------------------------------------

        $scope.$watch(function() {
                if (!$scope.collection) {
                    return false;
                }

                var exercise = $scope.collection.current();

                if (!exercise) {
                    return false;
                }

                if (!$scope.isSolutionVisible() || !$scope.collection.isAtTheEnd()) {
                    return false;
                }

                return exercise.isCorrect() || !exercise.isRepeatable();
            },
            function(value) {
                if (value) {
                    $scope.page().viewed();
                }
        });


        Page.events.on('change', function () {
            load();
            stopAudio();
        });
        
        App.events.on('module.close', function() {
            stopAudio();
        });

        Video.events.on('play', function () {
            stopAudio();
        });

        function stopAudio() {
            if (audio) {
                audio.pause();
                audio = false;
            }
        };

        load();
    };

    TemplateQuestionController.$inject = ['$scope', '$translate', 'App', 'Page', 'Video', 'Exercise', 'Sound'];

    angular.module('Application')
        .controller('TemplateQuestionController', TemplateQuestionController);
})();


(function () {

    'use strict';

    var TemplateTestController = function ($scope, $translate, App, Page, Exercise, Collection, Sound) {

        var __showReport = false;
        var __showRecap = false;
        var __answersGiven = false;
        var __showRecapMessage = false;
        var __canEdit = false;

        var __showCover = false;

        function load() {

            Exercise.promise().then(function () {
                var audio = false;

                var model = $scope.page().html() ?
                    $scope.page().html() : (
                        $scope.page().video().currentTiming() ? 
                            $scope.page().video().currentTiming().getModule('Html')[0] : null
                        );
                //console.log(model);
                if(!model) return;
                var exerciseIndex = model.getAttr('Exercise');

                // return;
                $scope.collection = Exercise.getById(exerciseIndex);
                
                if (model.getAttr('random'))
                    $scope.collection.shuffle();
                if (model.getAttr('limit'))
                    $scope.collection = $scope.collection.limit(model.getAttr('limit'));

                $scope.collection.callEach('cancel');

                // console.log("Test collection", _.map($scope.collection.all(), function(i) { return i.getAttr('id'); }));
                _.each($scope.collection.all(), function(item) {
                    // console.log("item",item);
                    item.setAttr('finalTestItem', true);
                });
                // console.log($scope.collection);

                $scope.pages = App.lesson().pagesWithExercises();
                $scope.pageIndex = _.indexOf($scope.pages, $scope.page());

                if (model.getAttr('audio')) {
                    audio = Sound.create({
                        src: 'audio/' + model.getAttr('audio')
                    });

                    audio.play();
                }


                $scope.isBlocked=function(){
                    var _return = false;
                    _.each($scope.collection.all(), function (el) {
                        if (!el.isConfirmed()) {
                            _return = true;
                            return;
                        }
                    });
                    return _return;
                }

                $scope.$watch(function () {
                        // console.log("Test Finale", $scope.isBlocked());
                        return $scope.isBlocked();
                    },
                    function (value) {
                        if (!value) {
                            //$scope.page().viewed();
                        }
                    });

                $scope.calcPerc = function () {
                    var number = $scope.collection.getCurrentNumber() - 1;
                    return ((number * 100) / $scope.collection.count());
                };
            });

        }

        $scope.startTest = function() {
            __showCover = false;
        };

        $scope.showReport = function () {
            __showReport = true;
            __showRecap = false;
            __showRecapMessage = false;
            $scope.passed = $scope.collection.count('isCorrect');
        };

        $scope.showRecap = function () {
            __showRecap = true;
            __showReport = false;
            __showRecapMessage = false;
        };

        $scope.retry = function() {
            _.each($scope.collection.all(), function(exercise) {
                exercise.cancel();
            });
            $scope.collection.atStart();
            $scope.collection = null;

            load();

            __showRecap = false;
            __showReport = false;
            __showRecapMessage = false;
            __canEdit = true;
            __answersGiven = false;
        };

        $scope.showRecapMessage = function () {
            __showReport = false;
            __showRecap = false;
            __showRecapMessage = true;
        }

        $scope.isCoverVisible = function () {
            return __showCover;
        };

        $scope.isReportVisible = function () {
            return __showReport;
        };

        $scope.isRecapVisible = function () {
            return !$scope.isReportVisible() && __showRecap;
        };

        $scope.isRecapMessageVisible = function () {
            return !$scope.isReportVisible() && __showRecapMessage;
        };

        $scope.viewAnswersGiven = function () {
            __answersGiven = true;
            __showReport = false;
            $scope.collection.atStart();
        };

        $scope.hideAnswersGiven = function () {
            __answersGiven = false;
            __showReport = true;
            $scope.collection.atStart();
        };

        $scope.canViewAnswersGiven = function () {
            return __answersGiven;
        }

        Page.events.on('change', function () {
            load();
        });

        load();

    };

    TemplateTestController.$inject = ['$scope', '$translate', 'App', 'Page', 'Exercise', 'Collection', 'Sound'];

    angular.module('Application')
        .controller('TemplateTestController', TemplateTestController);
})();

(function(){

	'use strict';

	var TestController = function($scope, App, Page){

		var vm = this;
		var repeated = false;
		var registerDraggedItem = false;

		$scope.exercises = App.module().lesson().page().test().exercises();

		vm.test = function() {
			return App.module().lesson().page().test();
		};

		vm.exercises = function() {
			return $scope.exercises;
		};

		vm.current = function() {
			return vm.exercises().current();
		};

		vm.repeat = function(){
			repeated = true;
			vm.test().repeatOnlyIncorrect();
		};

		vm.next = function() {
			if(!vm.exercises().isAtTheEnd())
			{
				vm.exercises().next();
			
				if(repeated && vm.current().isCorrect())
				{
					vm.next();
				}
			}
			else {
				vm.test().end();
			}
		};

		vm.registerDraggedItem = function(item){
			registerDraggedItem = item;
		};

		vm.canBeDropped = function(evt, ui, match){
			return vm.current().canBeDropped(match);
		};

		vm.test().panels().intro.open();

		if(vm.test().audio())
			vm.test().audio().play();

		$scope.vm = vm;

		$scope.$watch(function(){
			return vm.exercises().isBlocked();
		}, 
		function(value){
			if(!value) {
				App.module().lesson().page().viewed();
			}
		});

		Page.events.on('change.pre', function(){             

			if(vm.test())
			{
				vm.test().repeat();
				vm.test().audio().stop();
			}

		});
	};

	TestController.$inject = ['$scope','App', 'Page'];

	angular.module('Application')
		.controller('TestController', TestController);

})();





app.directive('ngCloseButton', function () {
    return {
        restrict: 'A',
        template: '<a href="#" ng-click="App.panels.closer.open()" class="btn-control btn-logout"><div class="video-control fa fa-close"></div></a>',
        replace: true
    }
});

app.directive('ngHomeButton', function () {
  return {
    restrict: 'A',
    template: '<a href="#" ng-click="App.closeModule()" class="btn-control btn-home"><div class="video-control fa fa-home"></div></a>',
    replace: true
  }
});

app.directive('ngHelpButton', function () {
    return {
        restrict: 'A',
        template: '<a href="#" class="btn-help" ng-click="MenuButton.find(\'help\').toggle()"><span>?</span></a>',
        replace: true
    }
});

app.directive('ngTextButton', function(){
  return {
      restrict: 'A',
    //   template: '<a href="#" class="btn-subtitles" ng-click="Subtitles.panel.toggle()"><span>T</span></a>',
      template: '<a href="#" class="btn-subtitles btn-control" ng-click="Subtitles.panel.toggle()" ><div class="video-control" ng-show="!page().hasExercises()">T</div></a>',
      replace: true
  }
});

app.directive('ngMuteButton', function () {
    return {
        restrict: 'A',
        replace: true,
        template: '<a href="#" class="btn-control btn-audio" ng-click="App.toggleAudio()">' 
          + '<div class="btn-audio-off fa fa-volume-off" ng-if="!App.audioIsPlaying() || !page().video()" ng-class="{\'disabled\': !page().video()}"></div>'
          + '<div class="btn-audio-on fa fa-volume-up" ng-if="App.audioIsPlaying() && page().video()"></div>'
          + '</a>'
    }
});

/**
 * params:
 *  - timerDuration <-- in ms, indica la durata del timer
 *  - timeElapsedMs <-- in ms, indica quanti millisecondi sono trascorsi dall'avvio del timer
 *  - timeStarted <-- true/false, cambiando lo stato dal controller contenitore della direttiva, parte o viene interrotto il timer
 *  - onTimeOverFn <-- la direttiva esegue questa funzione quando scade il timer (gli viene passata dall'esterno)
 *
 *  nel controller contenitore si può inviare l'evento $scope.$broadcast("RESTART_TIMER"); per riavviare il timer
 */
(function(){

    'use strict';

    var CountdownTimer = function($scope, $interval) {

        return {
            restrict: "E",
            scope:{
                timerDuration: '=',
                timeElapsedMs: '=',
                timeStarted: '=',
                onTimeOverFn: '='
            },
            template: `<span class="countdown-timer" ng-class="{'blink': animationBlinkTimer}">{{countdown}}</span>`,
            controller: ['$scope','$interval', function TimerController($scope, $interval){
/*<span className="countdown-timer" ng-class="{'blink': animationBlinkTimer}" ng-if="timeStarted && (timeElapsedMs < timer)">{{countdown}}</span>*/
            }],
            link: function($scope, $element, $attr, ctrl, transclude){
                var startTime = null;
                $scope.timer = $scope.timerDuration || 3000;
                var timerInterval;
                $scope.animationBlinkTimer = false;
                const START_BLINKING_TIMER = 60000;
                /*const OVER_TIME_MESSAGE_AUDIO = new buzz.sound("audio/sfx/wrong_sound",{ formats: [ "mp3"], preload: true});*/
                if (!$scope.timeElapsedMs){
                    $scope.timeElapsedMs = 0;
                }
                var restartTimer = function(){
                    $scope.timeElapsedMs = 0;
                    startTimer();
                }

                var startTimer = function(){
                    $interval.cancel(timerInterval);
                    $scope.timeElapsedMs = 0;
                    startTime = (new Date()).getTime();
                    /*var overFn = function(){
                        TweenMax.to($(this), 0.3, {scaleX: 1.1,scaleY: 1.1});
                    }
                    var outFn = function(){
                        TweenMax.to($(this), 0.3, {scaleX: 1,scaleY: 1});
                    }

                    $(".choice").hover(overFn, outFn)*/

                    timerInterval = $interval(function(){
                        $scope.timeElapsedMs = (new Date()).getTime() - startTime;

                        var remainingTimeMs = ($scope.timeElapsedMs <= $scope.timer) ? ($scope.timer - $scope.timeElapsedMs) : 0;

                        // 1- Convert to seconds:
                        let seconds = Math.trunc(remainingTimeMs / 1000);
                        // 2- Extract hours:
/*
                        const hours = Math.trunc(parseInt( seconds / 3600 )); // 3,600 seconds in 1 hour
*/
                        seconds = seconds % 3600; // seconds remaining after extracting hours
                        // 3- Extract minutes:
                        let minutes = Math.trunc(parseInt( seconds / 60 )); // 60 seconds in 1 minute
                        // 4- Keep only seconds not extracted to minutes:
                        seconds = seconds % 60;


                        //var seconds = Math.max(0, Math.trunc(($scope.timer - $scope.timeElapsedMs)/1000));
                        if (seconds < START_BLINKING_TIMER){
                            $scope.animationBlinkTimer = true;
                        }
                        if (seconds < 10){
                            seconds = "0"+seconds;
                        }
                        if (minutes < 10){
                            minutes = "0"+minutes;
                        }

                        /*var millis = Math.trunc((($scope.timer - $scope.timeElapsedMs)%1000)/10);
                        if (millis < 10){
                            millis = "0"+millis;
                        }*/
                        $scope.countdown = minutes + ":" + seconds /*+ ":" + millis*/;


                        if ($scope.timeElapsedMs >= $scope.timer){
                            debugger;
                            stopTimer();
                            //OVER_TIME_MESSAGE_AUDIO.play();
                            $scope.onTimeOverFn();
                        }
                    }, 10);
                }
              
                $scope.$on('RESTART_TIMER', restartTimer);

                var stopTimer = function(){
                    $scope.timeStarted = false;
                    $interval.cancel(timerInterval);
                }

                $scope.$watch(
                    function(scope) { return scope.timeStarted },
                    function( newValue, oldValue ) {
                        // If enabled, listen for mouse events.
                        if ( newValue ) {
                            startTimer();
                        } else if ( oldValue ) {
                            stopTimer();
                        }
                    }
                );

                $scope.$on('$destroy', function() {
                    stopTimer();
                });
            }
        }
    };

    CountdownTimer.$inject = ['$compile','$interval'];

    app.directive('countdownTimer', CountdownTimer);

})();

app.directive('crossWordCell', function () {
    return {
        restrict: 'E',
        scope: {
            props: '='
        },
        template: `<div class='crosswordcell' ng-if="props.fillable" ng-class="{'fillable': props.fillable, 'filled': props.filled}">
            <div ng-if="props.value" class="cell-index" ng-class="{'left': props.horizontal, 'top': !props.horizontal}">{{props.value}}</div>
            <span>{{props.letter}}</span>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
            //console.log("attributes crosswordcell", scope.props.value);
        }
    }
});

app.directive('crossWordInput', function () {
    return {
        restrict: 'E',
        scope: {
            props: '='
        },
        template: `<div class="crosswordinput">
            <input ng-repeat="cell in cells track by $index" type="text"
                                       maxlength="1"
                                       size="1"
                                       spellcheck="false"
                                       class="crosswordinput"
                                       ng-class="{'filled': confirmedLetters[$index]}"
                                       ng-focus="onFocusHandler($event,$index)"
                                       ng-model="letters[$index]"
                                       ng-disabled="props.readOnly || props.confirmed"
                                       ng-change="valueChangedHandler($event,$index)"
            />
        </div>`,
        link: function (scope, element, attributes) {
            scope.confirmedLetters = scope.props.letters ? scope.props.letters.slice('') : [];

            scope.letters = scope.props.letters ? scope.props.letters.slice('') : [];

            scope.cells = [...Array(scope.props.risposta.length)];

            scope.reset = function(){
                scope.letters = [...scope.confirmedLetters];
            }
            scope.valueChangedHandler = (e,i)=>{
                // se la cella non è vuota, o è già confermata, passo alla prossima
                if (scope.confirmedLetters[i]){
                    scope.lastFocuesdEl.nextElementSibling.focus();
                }else{
                    //scope.letters[i] = e.target.value;
                    if (scope.lastFocuesdEl.value && scope.lastFocuesdEl.nextElementSibling){
                        scope.lastFocuesdEl.nextElementSibling.focus();
                    }
                }

                if ((scope.letters.filter(el=>!!el).length >= scope.props.risposta.length)/* && (scope.letters.join('') === scope.props.risposta)*/){
                    scope.props.onWordFilled(scope.letters.join(''));
                }else{
                    scope.props.onWordFilled('');
                }
                /*setLetters(Array.from(e.target.value));*/
            }

            scope.onFocusHandler = (e,i)=>{
                scope.lastFocuesdEl = e.target;
                if (scope.confirmedLetters[i]){ // se la cella è già confermata passo alla prossima
                    scope.valueChangedHandler(e,i);
                }else{ // altrimenti autoselect del value
                    e.target.value && e.target.select();
                }
            }

            scope.$watch('props.letters', function(value){
                scope.letters = value && value.slice('') || [];
            })

            scope.$watch('props.confirmed', function(newValue, oldValue) {
                if ( (oldValue !== newValue) && !newValue) {
                    scope.letters = [...scope.confirmedLetters];
                }
            });
        },
        controller: function( $scope, $element, $attrs, $transclude ) {
            console.log("NEW CONTROLLER EXEC")
        }
    }
});

/**
 * Logica:
 * - se scade il timer viene mostrato un pulsante per mostrare la soluzione
 * - se sbaglio 3 volte una parola, viene compilata con quella corretta
 */
app.directive('cruciverba', function () {
    return {
        restrict: 'E',
        scope: {
            'props': '=',
            'onClose': '=',
            'onEnded': '='
        },
        template: `<div class="cruciverba">
                <div>
                    <div ng-if="stepGame !== STEPS.SCORE_VIEW">
                        <header-generic hide-timer="(stepGame === STEPS.NOT_STARTED) || (stepGame === STEPS.SCORE_VIEW)" timer-state="timerState" title="Crossword" on-finish-game="finishGameHandler" 
                        on-timer-over="setAllCorrect"
                        on-ended="onEnded"
                        >
                           <div ng-if="(stepGame === STEPS.NOT_STARTED)">
                               
                               
                                <p>Fill in the blank squares with letters to complete the words based on the definitions provided.</p>
                                <p class="text-left">Instruction:</p>
                                <ul class="text-left">
                                    <li>Click on the <strong>Definition</strong> to fill in the word</li>
                                    <li>Click on <strong>Confirm</strong></li>
                                </ul>
                                <p class="text-left">With <strong>Back to definition</strong> you return to the general outline.</p>
                                <p>Ready? Let's begin!</p>
                            </div>
                        </header-generic>
                        <instructions-start ng-if="(stepGame === STEPS.NOT_STARTED)" on-start-click="startGameHandler" ></instructions-start>
                        <table ng-if="detailViewDefinitionIndex === -1">
                            <tbody>
                                <tr ng-repeat="row in crosswordMatrix track by $index">
                                <td ng-repeat="col in row track by $index">
                                    <cross-word-cell props="{'fillable': col.fillable, 'value': col.value, 'filled': !!col.letter, 'letter': col.letter, 'horizontal': col.horizontal}"/>
                                </td>
                                <!--<cross-word-cell ng-repeat="col in row track by $index" props="{'fillable': col?.fillable, 'value': col?.value, 'filled': !!col?.letter, 'letter': col?.letter, 'horizontal': col?.horizontal}"/>-->
                                    <!--<cross-word-cell ng-repeat="col in row" props="{'fillable': col?.fillable, 'value': col?.value, 'filled': !!col?.letter, 'letter': col?.letter, 'horizontal': col?.horizontal}"/>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- vista preview -->
                    <div ng-if="((stepGame === STEPS.STARTED) || (stepGame === STEPS.COMPLETED)) && (detailViewDefinitionIndex === -1)" class="definitions-list">
                        <definition-row ng-repeat="definition in definitions" props="{'preview': true, 'definition': definition, 'index': $index, 'onOpenDetail': openDetailHandler}" />)
                    </div>
    
                    <!-- vista dettaglio -->
                    <div ng-if="((stepGame === STEPS.STARTED) || (stepGame === STEPS.COMPLETED)) && (detailViewDefinitionIndex >= 0)" class="detail-view">
                        <definition-row props="{'definition': definitions[detailViewDefinitionIndex], 'state': (definitions[detailViewDefinitionIndex].completed ? DEFINITION_STATE.COMPLETED : DEFINITION_STATE.EMPTY), onDetailViewCorrect: onDetailViewCorrectHandler, onBackToDefinitions: backToDefinitionsHandler}"/>
                    </div>
                </div>
                <div ng-if="(stepGame === STEPS.COMPLETED) && (detailViewDefinitionIndex < 0)" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="showScoreViewHandler()">SHOW RESULT</button></div>
                
                <div ng-if="(stepGame === STEPS.COMPLETED) && solutionButtonVisible && !areAllCorrect()" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="setAllCorrect()">SOLUTION</button></div>
                <score-view ng-if="(stepGame === STEPS.SCORE_VIEW)" title="Feedback" text="feedbackText" correct="areAllCorrect() && !forcedSolution" on-retry="startGameHandler" on-close="onClose"/>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
            scope.solutionButtonVisible = false;
            scope.STEPS = {
                "NOT_STARTED": "NOT_STARTED",
                "STARTED": "STARTED",
                "COMPLETED": "COMPLETED",
                "SCORE_VIEW": "SCORE_VIEW"
            }
            scope.COUNTDOWN_TIMER_QUESTION_SECONDS = 1000*60;
            scope.detailViewDefinitionIndex = -1;

            scope.finishGameHandler = function(){
                scope.timerState.timeStarted = false;
                scope.solutionButtonVisible = true;
                scope.stepGame = scope.STEPS.COMPLETED;
                scope.detailViewDefinitionIndex = -1;
                // scope.setAllCorrect();
                // scope.page().viewed(true);
                // scope.$apply();

                scope.onEnded();
            }

            scope.setAllCorrect = function(){
                scope.forcedSolution = true;
                scope.definitions.forEach((def,i) => {
                    scope.setWordCorrect(def, i);
                })
                scope.solutionButtonVisible = false;
            }
            scope.showScoreViewHandler = function(){
                scope.stepGame = scope.STEPS.SCORE_VIEW;

                if (scope.areAllCorrect() && !scope.forcedSolution){
                    scope.feedbackText = 'Congratulations! You have completed the game. You can now continue with the training!';
                }else{
                    scope.feedbackText = 'Wrong! You have completed the game. You can now continue with the training! ';
                }
            }

            scope.startGameHandler = function(){
                scope.emptyAll();
                scope.timerState = {
                    timeStarted: true,
                    timeElapsed: 0
                }
                scope.stepGame = scope.STEPS.STARTED;
            }

            scope.definitions = scope.props.definizioni;

            scope.openDetailHandler = (definition, index)=>{
                if (!definition.completed && (scope.stepGame !== scope.STEPS.COMPLETED)){
                    scope.detailViewDefinitionIndex = index;
                }
            }

            scope.stepGame = scope.STEPS.NOT_STARTED;
            console.log("attributes cruciverba", scope.props);
        },
        controller: function($scope){
            $scope.crosswordMatrix = [];
            $scope.backToDefinitionsHandler = function(){
                $scope.detailViewDefinitionIndex = -1;
            }

            const getIntersectedDefinitions = (definition)=>{
                const hasSameRowOrCol = (compiledDef, currentRowCol)=>{
                    if (compiledDef.orizzontale){
                        return (currentRowCol.x >= compiledDef.x) && (currentRowCol.x <= compiledDef.x+compiledDef.risposta.length) &&// escludo le definizioni che hanno colonne diverse da quella compilata
                            (compiledDef.y >= currentRowCol.y) && (compiledDef.y<=currentRowCol.risposta.length+currentRowCol.y)// prendo le definizioni la cui lunghezza arriva alla parola completata
                    }else{
                        return (currentRowCol.y >= compiledDef.y) && (currentRowCol.y <= compiledDef.y+compiledDef.risposta.length) &&// escludo le definizioni che hanno righe diverse da quella compilata
                            (compiledDef.x >= currentRowCol.x) && (compiledDef.x<=currentRowCol.risposta.length+currentRowCol.x)
                    }
                }
                const filteredDefs = $scope.definitions.filter(def => {
                    const isPerpendicular = (definition.orizzontale !== def.orizzontale) // escludo tutte le definizioni con lo stesso orientamento di quella compilata (non possono intersecarsi)
                    return isPerpendicular &&
                        hasSameRowOrCol(definition, def) // escludo le definizioni che hanno righe/colonne diverse da quella compilata
                })
                return filteredDefs;
            }

            const setFilledLetters = function(definition){
                let defs = [...$scope.definitions];
                let filteredDefs = getIntersectedDefinitions(definition); // prendo le definizioni che hanno una lettera in comune con la parola appena compilata
                for (const d of defs){
                    if (d.index === definition.index){
                        d.filledLetters = definition.risposta.split('');
                        d.completed = (definition.risposta.length === d.filledLetters.length);
                    }
                    for (const f of filteredDefs){
                        if (d.index === f.index) { // se trovo la definzione tra quelle che intersecano la parola
                            if (!(d.filledLetters && d.filledLetters.length)){
                                d.filledLetters = [...Array(d.risposta.length)];
                            }
                            let intersectionPosition = definition.orizzontale ? definition.y-d.y : definition.x-d.x
                            d.filledLetters[intersectionPosition] = d.risposta[intersectionPosition];
                        }
                    }
                }
                $scope.definitions = defs;
            }

            const emptyAll = function () {
                $scope.definitions.forEach(def => {
                    delete def.filledLetters;
                    delete def.completed;
                });
                $scope.crosswordMatrix.forEach((m) => {
                    m.forEach((n) => { if (n) delete n.letter; })
                });
                $scope.$apply();
            }
            $scope.emptyAll = emptyAll;

            const setWordCorrect = (def, index)=>{
                let matrix = [...$scope.crosswordMatrix];
                if (def.orizzontale){
                    matrix[def.y].splice(def.x,def.risposta.length, ...[ ...Array(def.risposta.length).keys() ].map( i => {
                        return {
                            fillable: true,
                            value: i === 0 ? def.index : null, // label solo nella prima cella della riga
                            letter: def.risposta[i],
                            horizontal: true
                        }
                    }))
                }else{
                    for (let wIndex = 0; wIndex<def.risposta.length; wIndex++){
                        const rowIndex = wIndex+def.y;
                        let labelIndex = null;
                        let orientationHorizontal = false;
                        if (matrix[rowIndex][def.x] && matrix[rowIndex][def.x].value) { // se ho già una labelIndex (numerino accanto alla cella) non la sovrascrivo con null, ma riprendo quella esistente
                            labelIndex = matrix[rowIndex][def.x].value;
                            orientationHorizontal = matrix[rowIndex][def.x].horizontal;
                        }else{
                            labelIndex = (rowIndex === def.y) ? def.index : null;
                            orientationHorizontal = false;
                        }
                            matrix[rowIndex][def.x] = {
                                fillable: true,
                                value: labelIndex, // label solo nella prima cella della colonna
                                letter: def.risposta[wIndex],
                                horizontal: orientationHorizontal
                            }

                    }
                }
                $scope.crosswordMatrix = matrix;
                setFilledLetters(def);
            }

            $scope.setWordCorrect = setWordCorrect;

            $scope.onDetailViewCorrectHandler = ()=>{
                let definition = $scope.definitions[$scope.detailViewDefinitionIndex];
                setWordCorrect(definition, $scope.detailViewDefinitionIndex);
                $scope.detailViewDefinitionIndex = -1;
            }

            const buildMatrix = () => {
                const matrix = [...Array($scope.props.rows)];
                for (let y = 0; y < matrix.length; y++){
                    matrix[y] = [...Array($scope.props.cols)];
                }
                return matrix;
            }

            const fillMatrixRow = (arr, rowIndex, def) => {
                arr[rowIndex].splice(def.x,def.risposta.length, ...[ ...Array(def.risposta.length).keys() ].map( i => {
                    var labelIndex =  i === 0 ? def.index : null;
                    return {
                        fillable: true,
                        value: labelIndex, // label solo nella prima cella della riga
                        //letter: def.risposta[i],
                        horizontal: true
                    }
                }))
            }
            const fillMatrixColumn = (arr, colIndex, def)=>{
                for (let wIndex = 0; wIndex<def.risposta.length; wIndex++){
                    const rowIndex = wIndex+def.y;
                    if (!(arr[rowIndex][colIndex] && arr[rowIndex][colIndex].value)){ // se ho già una labelIndex (numerino accanto alla cella) non la sovrascrivo con null
                        arr[rowIndex][colIndex] = {
                            fillable: true,
                            value: rowIndex === def.y ? def.index : null, // label solo nella prima cella della colonna
                            //letter: def.risposta[wIndex],
                            horizontal: false
                        }
                    }
                }
            }

            /*$scope.init = function(){*/
                let tmpCrosswordMatrix = buildMatrix();
                for (let y = 0; y<tmpCrosswordMatrix.length; y++){
                    $scope.props.definizioni.forEach(def => {
                        if (def.orizzontale){
                            if (def.y === y){
                                fillMatrixRow(tmpCrosswordMatrix, y, def);
                            }
                        }
                    })
                    $scope.props.definizioni.forEach(def => {
                        if (!def.orizzontale){
                            fillMatrixColumn(tmpCrosswordMatrix,def.x,def);
                        }
                    })
                }

                $scope.crosswordMatrix = tmpCrosswordMatrix;
                $scope.$apply();
                console.log("$scope.crosswordMatrix",$scope.crosswordMatrix)
            /*}*/

            const getCorrectCount = ()=>{
                return $scope.definitions.filter(def => def.completed).length;
            }

            $scope.areAllCorrect = ()=>{
                return getCorrectCount() === $scope.definitions.length;
            }

            $scope.$watch('definitions', function(newValue, oldValue) {
                if (newValue !== oldValue){
                    const allCorrect = $scope.areAllCorrect();
                    console.log("correctCount ", getCorrectCount())
                    if (allCorrect){
                        $scope.finishGameHandler(true);
                    }
                }
            })
        }
    }
});

app.directive('definitionRow', function () {
    return {
        restrict: 'E',
        scope: {
            props: '='
        },
        template: `<div class="definition-row" ng-class="{'preview': props.preview, 'completed': isWordConfirmed && isFilledCorrect()}" ng-click="props.onOpenDetail(props.definition, props.index)">
            <div class="orientation-label"><span ng-class="{'confirmed': props.definition.completed || (isWordConfirmed && isFilledCorrect()), 'ko':(!props.definition.completed) && isWordConfirmed && (!isFilledCorrect())}">{{props.definition.index}} {{props.definition.orizzontale ? "horizontal" : "vertical"}} {{iconLabel}}</span></div>
            <div class="definition">
                <p>{{props.definition.text}}</p>
                <img ng-if="props.preview" src="./assets/images/game/chevron-right.svg" alt=""/>
            </div>
            <div class="input-definition">
                <cross-word-input props="{'risposta':props.definition.risposta, 'letters': props.definition.filledLetters, 'onWordFilled': setFilledWord, 'confirmed': isWordConfirmed, 'readOnly': props.preview}"/>
            </div>

            <div ng-if="!props.preview" class="buttons-container">
                <div class="center-element" ng-if="feedbackVisible && isWordConfirmed">
                        <feedback-row ng-if="isFilledCorrect() && !forcedSolution" correct="true">
                            Correct!
                        </feedback-row>
                        <feedback-row ng-if="!isFilledCorrect() && !forcedSolution" correct="false">
                            Wrong!
                        </feedback-row>
                        <feedback-row ng-if="forcedSolution" correct="false">
                            Solution: {{filledWord}}
                        </feedback-row>
                        <button class="button-game fixed-width" ng-if="!isFilledCorrect() && !isSolutionAvailable" ng-click="tryAgainHandler()">Try again</button>
                        <button class="button-game fixed-width" ng-if="!isFilledCorrect() && isSolutionAvailable" ng-click="showSolution()">Solution</button>
                </div>
                <button class="button-game fixed-width" ng-if="!isWordConfirmed" ng-disabled="!filledWord" ng-class="{'disabled': !filledWord}" ng-click="confirmDefinitionHandler()">Confirm</button>
                <button class="text-button" ng-if="(!isWordConfirmed || !isFilledCorrect())" ng-click="props.onBackToDefinitions();">back to definition</button>
            </div>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {
        },
        controller: function( $scope, $element, $attrs, $transclude ) {
            console.log( $attrs.log + ' (controller)' );
            $scope.forcedSolution = false;

            $scope.tryAgainHandler = ()=>{
                $scope.isWordConfirmed = false;
                $scope.setFilledWord('');
            }

            $scope.showSolution = ()=>{
                $scope.setFilledWord($scope.props.definition.risposta);
                $scope.forcedSolution = true;
                $scope.confirmDefinitionHandler();
            }

            $scope.isFilledCorrect = function(){
                if (!$scope.filledWord){
                    return false;
                }
                return $scope.filledWord.toLowerCase() === $scope.props.definition.risposta.toLowerCase();
            }


            $scope.setFilledWord = function(word){
                $scope.filledWord = word;
            }

            $scope.confirmDefinitionHandler = ()=>{
                if (!$scope.props.definition.tentativi){
                    $scope.props.definition.tentativi = 0;
                }
                $scope.props.definition.tentativi++;
                if ($scope.props.definition.tentativi >= 3){
                    $scope.isSolutionAvailable = true;
                }


                if ($scope.filledWord) {
                    $scope.isWordConfirmed = true;

                    $scope.feedbackVisible = true;
                    if ($scope.isFilledCorrect()){ // risposta corretta
                        setTimeout(()=>{
                            $scope.props.onDetailViewCorrect();
                            $scope.$apply();
                        },2000)
                    }
                }
            }
        },
    }
});

app.directive('feedbackRow', function () {
    return {
        restrict: 'E',
        scope: {
            correct: '='
        },
        transclude: true,
        replace: true,
        template: `<div class="feedback-row" ng-class="{'ok': correct, 'ko': !correct}">
            <div ng-transclude></div>
        </div>`,
        link: function (scope, element, attributes) {
        },
        controller: function($scope){
            console.log("$scope", $scope)
        }
    }
});

(function () {
    'use strict';

    let GaugeDirective = function () {

        return {
            restrict: 'A',
            scope: {
                value: '='
            },
            link: function (scope, element, attributes) {


                let opts = {
                    angle: 0.15, // The span of the gauge arc
                    lineWidth: 0.06, // The line thickness
                    radiusScale: 0.95, // Relative radius
                    animationSpeed: 32,
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#ff0000',   // Colors
                    colorStop: "#55FA22",    // just experiment with them
                    strokeColor:'#eeeeef',
                    shadowColor: '#eeeeef',
                    generateGradient: true,
                    percentColors: [
                        [0.0, "#ff0000"],
                        [0.1, "#f56f16"],
                        [0.3, "#f1cb28"],
                        [0.5, "#ccff00"],
                        [0.7, "#04d216"]
                    ]
                };
                let gauge;

                setTimeout(()=>{
                    gauge = new Donut(document.getElementById(attributes.id)).setOptions(opts);
                    gauge.maxValue = 100; // set max gauge value
                    gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
                    gauge.set(scope.value); // set actual value
                    scope.$watch(()=>scope.value, (val)=>{
                        gauge.set(val);
                    });
                }, 1000);
            }
        }
    };

    angular.module('Application')
        .directive('ngGauge', GaugeDirective);

})();

app.directive('headerGeneric', function () {
    return {
        restrict: 'E',
        scope: {
            hideTimer: '=',
            title: '@',
            onFinishGame: '=',
            onTimerOver: '=',
            onEnded: '=',
            timerState: '='
        },
        transclude: true,
        replace: true,
        template: `<div class="header-generic" ng-style="{'marginBottom': scope.marginBottom ? '20px' : 'initial'}">
          <div class="question-title">
              {{title}}
          </div>
            
            <div ng-transclude></div>
        </div>`,

        // <div style="margin-bottom: 10px">
        //     <countdown-timer ng-if="!hideTimer" time-started="timerState.timeStarted" timer-duration="10000*60" on-time-over-fn="timeoverHandler" time-elapsed-ms="timerState.timeElapsed"/>
        // </div>
        link: function (scope, element, attributes) {
            scope.timeoverHandler = function(){
                scope.onFinishGame();
                scope.onTimerOver();
                scope.onEnded();
            }
            if (scope.timerState){
                scope.timerState.timeStarted = true;
            }
        }
    }
});

app.directive('instructionsStart', function () {
    return {
        restrict: 'E',
        scope: {
            title: '@',
            onStartClick: '='
        },
        transclude:true,
        template: `<div class="instructions-start">
            <div class="instructions">
                <div ng-transclude></div>
            </div>
            <div style="text-align: center; margin: 10px">
                <button class="button-game fixed-width" ng-click="onStartClick()">START</button>
            </div>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {

        }
    }
});

app.directive('scoreView', function () {
    return {
        restrict: 'E',
        scope: {
            title: '@',
            text: '=',
            correct: '=',
            onRetry: '=',
            onClose: '='
        },
        template: `<div class="score-view"><header-generic hide-timer="true" title="{{title}}"><div compile="text"></div>
                <div ng-if="correct" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="onClose()">CLOSE</button></div>
                <div ng-if="!correct" style="text-align:center;margin:10px;"><button class="button-game fixed-width" ng-click="onRetry()">TRY AGAIN</button></div>
                </header-generic>
        </div>`,
        replace: true,
        link: function (scope, element, attributes) {

        }
    }
});

app.directive('a', function () {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                elem.on('click', function (e) {
                    e.preventDefault();
                });
            }
        }
    };
});

app.directive('compile', ['$compile', function ($compile) {
    return function (scope, element, attrs) {
        scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.compile);
                },
                function (value) {
                    var result = element.html(value);
                    $compile(element.contents())(scope);
                }
        );
    };
}]);

app.directive('animate', ['$timeout', function($timeout){
    return {
        restrict: 'A',
        link: function(scope, el, attrs) {
            var el = $(el);
            var $class = attrs.animate;
            var timeout = attrs.animateTimeout;
            
            if(timeout)
            {
                $timeout(function(){
                    el.addClass('animated').addClass($class).removeClass('invisible-opacity'); 
                }, timeout*1000);
            }
            else 
                el.addClass('animated').addClass($class).removeClass('invisible-opacity');
        }
    };
}]);

app.directive('progressBar', ['App', function (App) {
    return {
        restrict: 'A',
        template: '<div id="slider-range-min"></div>',
        scope: {
            video: '=',
            blocked: '='
        },
        replace: true,
        transclude: true,
        link: function (scope, element, attributes) {

            App.promise.then(function () {

                function moveVideo() {
                    var value = _slider.slider('value');
                    var seconds = scope.video.player().duration();
                    var currentTime = (value * seconds) / 100;
                    scope.video.player().currentTime(currentTime);
                }

                var setup = {
                  range: "min",
                  min: 1,
                  max: 100
                }

                var _slider = element.slider(setup);

                attributes.$observe('video', function ()
                {
                    if (scope.video && scope.video.player())
                    {
                        var isDragging = false;

                        _slider.on('slidestart', function () {
                            if (!scope.video.player().paused())
                                scope.video.player().pause();
                            isDragging = true;
                            scope.$parent.$apply();
                        });

                        _slider.on('slidestop', function () {
                            moveVideo();
                            if (scope.video.player().paused())
                                scope.video.player().play();
                            isDragging = false;
                            scope.$parent.$apply();
                        });

                        scope.video.player().on('timeupdate', function () {
                            if (!isDragging)
                            {
                                var position = (100 * scope.video.player().currentTime()) / scope.video.player().duration();
                                _slider = element.slider(setup);
                                _slider.slider('value', position);
                            }
                        });
                    }
                });

                if(App.config().getAttr('restricted'))
                    _slider.slider('disable');

                scope.$watch('blocked', function(value)
                {
                    if(!value)
                        _slider.slider('enable');
                    else
                        _slider.slider('disable');
                });
            });
        }
    }
}]);


app.directive("ngMobileClick", [function () {
    return function (scope, elem, attrs) {
        elem.bind("touchstart click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            scope.$apply(attrs["ngMobileClick"]);
        });
    }
}]);



(function() {
    'use strict';

    var FirstLetterFilter = function () {
        return _.memoize(function(input, letter, label) {
            var input = input || [];
            var out = [];
            input.forEach(function (item) {
                if (item.getAttr(label).charAt(0).toLowerCase() == letter) {
                    out.push(item);
                }
            });
            return out;
        }, function(input, letter, label){
            return letter
        });
    };

    angular.module('Application').filter('firstLetter', FirstLetterFilter);
})();



app.factory('App', ['$http', 'Module', 'Model', 'Panel', 'Event', '$window', '$timeout', '$translate', '$rootScope','Sound',
    function ($http, Module, Model, Panel, Event, $window, $timeout, $translate, $rootScope,Sound) {

        var config = false;
        var loaded = false;

        var modules = [];
        var pages = [];
        var _openMenu = false;

        var audioEndedInstance = false;
        var audioEnded = "ended";

        var audioEndedPlayed = false;

        var eventer = Event.create('app');

        var panels = {
            resume: Panel.create('app.resume'),
            closer: Panel.create('app.closer'),
            logout: Panel.create('app.logout')
        };

        // modulo in cui mi trovo adesso
        var currentModule = false;

        // a little object of configurations
        function Config(data) {
            var model = Model.create({
                attrs: data,
                name: 'app.config'
            });

            // check if app navigation is free
            model.isFree = function () {
                return !model.getAttr('restricted');
            };

            /**
             * @description check if navigation is limited in lesson
             * @return {boolean}
             */
            model.isNavLimitedOnLesson = function() {
                return model.getAttr('layout').nav === 'limited';
            };

            return model;
        };

        var promise = $http.get('config/index.json').success(function (data) {
            config = new Config(data);
            loaded = true;
            modules = Module.collection(config.getAttr('structure').modules);
        });

        $($window).resize(function () {
            if($('slick').length) {
                var slick = $('slick')[0].slick;
                slick.slickSetOption('slidesToShow', service.getSlidesToShow(), true);
                slick.slickSetOption('slidesToScroll', 1, true);
                slick.reinit();
            }
        });

        var service = {
            promise: promise,
            loaded: function () {
                return loaded;
            },
            pages: function () {
                if (!pages.length) {
                    _.each(modules.all(), function (m) {
                        _.each(m.lessons().all(), function (l) {
                            pages = pages.concat(l.pages().all());
                        });
                    });
                }
                ;
                return pages;
            },
            course: function () {
                // console.log(this.config().getAttr('structure').course);
                // console.log(this.config().getAttr('structure').modules);
                return this.config().getAttr('structure').course;
            },
            /**
             * @description get current page number
             * @return {*}
             */
            getCurrentPageNumber() {
                if (!this.module()) return;

                // if navigation is limited only in lesson
                if (this.config().isNavLimitedOnLesson())
                    return this.module().lesson().pages().getCurrentNumber();

                let page = this.module().lesson().page();
                return _.indexOf(this.pages(), page) + 1;
            },
            /**
             * @description get max page number
             * @return int
             */
            getMaxPageNumber() {
                if (this.config().getAttr('layout').nav === 'limited')
                    return this.module().lesson().pages().count();
                return this.pages().length
            },
            // ottengo la struttura dei moduli
            structure: function () {
                return modules;
            },
            layout: function () {
                return config.layout;
            },
            // ottengo la pagina corrente
            page: function () {
                return this.lesson().page();
            },
            // ottengo la lezione corrente
            lesson: function () {
                return this.module().lesson();
            },
            // ottengo il modulo corrente
            module: function () {
                if (currentModule === false) return;
                return this.structure().current();
            },
            modules: function () {
                return this.structure();
            },
            nextModule: function () {
                if (this.structure().isAtTheEnd())
                    return false;

                this.modules().next();
                this.module().setCurrentLesson(0);
                return this;
            },
            prevModule: function () {
                if (this.structure().isAtTheStart())
                    return false;

                if (currentModule > 0)
                    currentModule--;

                this.modules().setCurrent(currentModule);
                this.module().setCurrentLesson(0);
                return this;
            },

            openMenu:function(val){
                return _openMenu=val;
            },

            getOpenMenu:function(){
                // console.log("_openMenu "+ _openMenu)
                return _openMenu;
            },
            /**
             * @description open module
             * @param i
             * @return {*}
             */
            goToModule: function (i) {
                if(i>0 && !config.isFree() && !this.modules().get(i-1).isViewed())
                    return false;

                eventer.emit('module.open.pre');
                currentModule = i;
                this.modules().setCurrent(currentModule);
                // this.module().setCurrentLesson(0);
                
                // if(!this.module().lesson().pages().isAtTheStart()) {
                //     panels.resume.open();
                // }
                // else {
                    var currentPage = this.getCurrentPageNumber() - 1;
                    this.module().lesson().setCurrentPage(currentPage);
                // }
                eventer.emit('module.open');

                return this;
            },
            goTo: function (iModule, iLesson, iPage) {
                var _this = this;

                if (!config.isFree()) {
                    if (iModule > 0 && !_this.modules().get(iModule - 1).isViewed()) {
                        return;
                    }
                    if (iLesson > 0 && !_this.modules().get(iModule).lessons().get(iLesson - 1).isViewed()) {
                        return;
                    }
                    if (iPage > 0 && !_this.modules().get(iModule).lessons().get(iLesson).pages().get(iPage - 1).isViewed()) {
                        return;
                    }
                }

                if (
                    iModule > 0 &&
                    iLesson > 0 &&
                    iPage > 0 &&
                    !_this.modules().get(iModule).lessons().get(iLesson).pages().get(iPage).isViewed() &&
                    !config.isFree()
                ) {
                    // console.log("RETURNNNNNNNN");
                    return;
                }

                _this.modules().setCurrent(iModule);
                currentModule = iModule;
                _this.module().setCurrentLesson(iLesson);
                _this.module().lesson().setCurrentPage(iPage);

                eventer.emit('menu.change');

                return _this;
            },
            closeModule: function () {
                eventer.emit('module.close');
                currentModule = false;
                // Sometimes slick is reinitialized and
                // not look good on page, goTo fix this
                // abruptely
                if($('slick').length) {
                    var slick = $('slick')[0].slick;
                    slick.goTo(slick.getCurrent());
                }
            },
            setFirstPageToView: function (i) {
                var page = this.pages()[i];
                var found = false;
                _.each(this.structure().all(), function (module, mKey) {
                    _.each(module.lessons().all(), function (lesson, lKey) {
                        _.each(lesson.pages().all(), function (p, pKey) {
                            if (page == p) {
                                currentModule = mKey;
                                module.setCurrentLesson(lKey);
                                lesson.setCurrentPage(pKey);
                                return;
                            }
                        });

                        if (found) return;
                    });

                    if (found) return;
                });

                return this;
            },
            /**
             * @description go to first page of lesson
             */
            goToFirstPageOfLesson: function() {
                this.module().lesson().pages().setCurrent(0);
                this.panels.resume.close();
                return this;
            },
            goToPageByIndex: function(i) {
                i = i - 1;
                // console.log(i);

                var found = false;
                var page = this.pages()[i];
                // console.log(page.getAttr('title'));
                _.each(this.structure().all(), function (module, mKey) {
                    _.each(module.lessons().all(), function (lesson, lKey) {
                        _.each(lesson.pages().all(), function (p, pKey) {
                            if (page == p) {
                                currentModule = mKey;
                                service.modules().setCurrent(currentModule);
                                module.setCurrentLesson(lKey);
                                lesson.setCurrentPage(pKey);
                                return;
                            }
                        });

                        if (found) return;
                    });

                    if (found) return;
                });

                this.panels.resume.close();
            },
            config: function () {
                return config;
            },
            panels: panels,
            logout: function () {
                panels.logout.open();
                eventer.emit('logout');
            },
            refresh: function () {
                eventer.emit('refresh');
                return false;
            },
            isAtLastPage: function () {
                return this.getCurrentPageNumber() == this.pages().length;
            },
            hasNextPage: function () {
                
                if (this.config().isNavLimitedOnLesson())
                    if (this.module().lesson().pages().isAtTheEnd()) return false;

                if (!this.module().lesson().pages().isAtTheEnd())
                    return true;

                if (!this.module().lessons().isAtTheEnd())
                    return true;

                if (!this.modules().isAtTheEnd())
                    return true;

                return false;
            },
            hasPrevPage: function () {
                if(this.config().isNavLimitedOnLesson()) {
                    if (this.module().lesson().pages().isAtTheStart()) return false;
                    return true;
                }

                if (!this.modules().isAtTheStart())
                    return true;

                if (!this.module().lessons().isAtTheStart())
                    return true;

                if (!this.module().lesson().pages().isAtTheStart())
                    return true;

                return false;
            },
            events: eventer,
            exitFullscreen: function () {
                if (document.fullscreenElement && document.exitFullscreen) {
                    document.exitFullscreen();
                }
                else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                }
                else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
                else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                else if (document.msCancelFullScreen) {
                    document.msCancelFullScreen();
                }
            },
            getSlidesToShow: function () {
                var w = $(window).width();
                // return 1;

                switch (true) {
                    case (w <= 768):
                        return 4;
                        break;

                    case (w > 1200):
                        return 6;
                        break;

                    case (w <= 1200):
                        return 8;
                        break;
                }
            },
            /**
             * @description get score lesson
             * @return {number}
             */
            score() {
                let score = 0;
                this.modules().forEach((module) => score += module.score());
                // console.log("AppSCORE", score);
                return score;
            },

            /**
             * @description get score lesson (only lesson with exercises)
             * @return {number}
             */
            scoreEx() {
                let score = 0;
                this.modules().forEach((module, index) => {
                    if (index > 0 && index < 5) score += module.score()}
                );
                // console.log("AppSCORE", score);
                return score;
            },

            percScore() {
                return Math.round(this.score() * 100 / this.maxScore());
            },

            /**
             * @description get max score
             * @return {number}
             */
            maxScore() {
                let score = 0;
                this.modules().forEach(module => score += module.maxScore());
                return score;
            },
            /**
             * @description get max score (only lesson with exercises)
             * @return {number}
             */
            maxExScore() {
                let score = 0;
                this.modules().forEach((module, index) => {
                    if (index > 0 && index < 5) score += module.maxScore()
                });
                return score;
            },
            getLastViewedModuleID() {
                let id = 0;
                let mod = _.find(this.modules().all(), (module, index) => {
                    if (!module.isViewed()) { id = index; return true; };
                });
                return id;
            },
            getGaugeValue() {
                return Math.round(this.scoreEx() * 100 / this.maxExScore());
            },
            toggleAudio: function () {
                if(this.module().lesson().page().video()) {
                    var audioIsMuted = ! this.module().lesson().page().video().player().muted()
                    this.module().lesson().page().video().player().muted(audioIsMuted);
                }
            },
            audioIsPlaying: function () {
                return this.module().lesson().page().video() ? (! this.module().lesson().page().video().player().muted()) : false;
            },
            isCurrentModule: function (module) {
                return (this.module() == module);
            },
            areAllModulesViewed: function() {
                var allViewed = true;
                this.modules().forEach((module) => {
                    if (!module.isViewed()) allViewed = false;
                });
                return allViewed;
            },
            goToPageByAbsIndex: function(pageIndex) {

                var _this = this;
                var moduleIndex = _.indexOf(_this.modules().all(), _this.module());
                var lessonIndex = _.indexOf(_this.module().lessons().all(), _this.lesson());

                if (
                    pageIndex > 0 &&
                    !_this.module().lessons().get(lessonIndex).pages().get(pageIndex-1).isViewed()
                    && !config.isFree()
                ) {
                    return;
                }

                _this.modules().setCurrent(moduleIndex);
                _this.module().setCurrentLesson(lessonIndex);
                _this.module().lesson().setCurrentPage(pageIndex);
                
                eventer.emit('menu.change');

                return _this;
            },
            goWhereYouLeft: function() {
                // if (this.isThereAUnitPending()) {
                    
                    currentModule = this.getLastViewedModuleID();
                    if (!config.isFree() && (currentModule > 0 && !this.modules().get(currentModule-1).isViewed())) 
                        return false;

                    eventer.emit('module.open.pre');
                        
                    this.modules().setCurrent(currentModule);
                    // this.module().setCurrentLesson(0);

                    // if(!this.module().lesson().pages().isAtTheStart()) {
                    //     console.log("OPEN");
                    //     panels.resume.open();
                    // }

                    eventer.emit('module.open');
                // }
                
                this.panels.resume.close();

                return this;

            },
            justCloseResumePanel: function() {
                // Reset bookmark for all units
                _.each(modules.all(), function (m) {
                    _.each(m.lessons().all(), function (l) {
                        l.setCurrentPage(0);
                    });
                });

                this.panels.resume.close();
            },
            isResumable: function() {
                var _return = true;

                this.isThereAUnitPending();

                if (isResumed) {
                    _return = false;
                    return _return;
                }

                if (this.areAllModulesViewed()) {
                    _return = false;
                    return _return;
                }

                if (
                    this.getLastViewedModuleID() == 0 &&
                    this.modules().get(0).lesson().pages().currentIndex() == 0
                ) {
                    _return = false;
                    return _return;   
                }

                panels.resume.open();

                return _return;
            },
            isThereAUnitPending: function() {
                var _return = false;
                _.each(modules.all(), function (m) {
                    _.each(m.lessons().all(), function (l) {
                        var pagesCompletions = _.countBy(_.invoke(l.pages().all(), 'isViewed'));
                        // console.log("IF", l.pages().isAtTheStart() && !! pagesCompletions.true && !! pagesCompletions.false);
                        // console.log(l.pages().isAtTheStart(), !! pagesCompletions.true, !! pagesCompletions.false);
                        if (
                            // l.pages().isAtTheStart() && 
                            !! pagesCompletions.true && !! pagesCompletions.false) {
                            _return = true;
                            return _return;
                        }
                        // console.log("---------------------------------------------");
                    });
                });
                // console.log("*** isThereAUnitPending?", _return);
                return _return;
            },
            hasFinalAudioBeenPlayed: function() {
                return audioEndedPlayed;
            },
            setFinalAudioAsPlayed: function() {
                audioEndedPlayed = true;
                return this;
            },
            finalTestModule: function() {
                return _.find(modules.all(), function (m) {
                    return m.isFinalTest();
                });
            },
            isFinalTestPassed: function() {
                // console.log(this.finalTestModule());
                if (!this.finalTestModule())
                    return false;
                return this.finalTestModule().finalTestPercentage() > this.config().getAttr('layout').masteryScore || this.finalTestModule().getAttr('passed');
            },
            isMobile: function() {
                return isMobile.any;
            },
            isPhone: function() {
                return isMobile.phone;
            },
            isPortrait: function() {
                return (window.innerHeight > window.innerWidth);
            },
            // pauseVideo(){
            //     !this.module().lesson().page().video().ended() && this.module().lesson().page().video().pause();    
            // },
            // playVideo(){
            //     !this.module().lesson().page().video().ended() && this.module().lesson().page().video().play();
            // },
            downloadGlossary: function () {
                $window.open($translate.instant('course.glossary'), "_blank");
                return;
            },
            useLang: function () {
                let lang = this.config().getAttr('layout').lang;
                // console.log("useLang", lang);
                if (lang) $translate.use(lang);
                return lang;
            }
        };

        var isResumed = false;

        panels.closer.on('open', function () {
            // $timeout(function() {
            if (
                service.module() &&
                service.module().lesson() &&
                service.module().lesson().page() &&
                service.module().lesson().page().video()) {
                service.module().lesson().page().video().pause();
            }
            // }, 500);
        });

        panels.resume.on('close', function () {
            isResumed = true;

            // $timeout(function() { 
                // if (service.module().lesson().page().video())
                //     service.module().lesson().page().video().play();
            // }, 500);
        });

        eventer.on('module.open', function () {
            isResumed = true;
            if (audioEndedInstance) {
                audioEndedInstance.stop();
            }
        });

        return service;
    }]);


/*! =========================================================
 * bootstrap-slider.js
 *
 * Maintainers: 
 *      Kyle Kemp 
 *          - Twitter: @seiyria
 *          - Github:  seiyria
 *      Rohit Kalkur
 *          - Twitter: @Rovolutionary
 *          - Github:  rovolution
 *
 * =========================================================
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */


/**
 * Bridget makes jQuery widgets
 * v1.0.1
 * MIT license
 */
(function ($) {

    (function ($) {

        'use strict';

        // -------------------------- utils -------------------------- //

        if (typeof String.prototype.trim !== 'function') {
            String.prototype.trim = function () {
                return this.replace(/^\s+|\s+$/g, '');
            }
        }

        if (!Array.prototype.indexOf)
        {
            Array.prototype.indexOf = function (elt /*, from*/)
            {
                var len = this.length >>> 0;

                var from = Number(arguments[1]) || 0;
                from = (from < 0)
                        ? Math.ceil(from)
                        : Math.floor(from);
                if (from < 0)
                    from += len;

                for (; from < len; from++)
                {
                    if (from in this &&
                            this[from] === elt)
                        return from;
                }
                return -1;
            };
        }

        var slice = Array.prototype.slice;

        function noop() {
        }

        if (!Function.prototype.bind) {
            Function.prototype.bind = function (oThis) {
                if (typeof this !== "function") {
                    // closest thing possible to the ECMAScript 5
                    // internal IsCallable function
                    throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
                }

                var aArgs = Array.prototype.slice.call(arguments, 1),
                        fToBind = this,
                        fNOP = function () {
                        },
                        fBound = function () {
                            return fToBind.apply(this instanceof fNOP && oThis
                                    ? this
                                    : oThis,
                                    aArgs.concat(Array.prototype.slice.call(arguments)));
                        };

                fNOP.prototype = this.prototype;
                fBound.prototype = new fNOP();

                return fBound;
            };
        }

        // -------------------------- definition -------------------------- //

        function defineBridget($) {

            // bail if no jQuery
            if (!$) {
                return;
            }

            // -------------------------- addOptionMethod -------------------------- //

            /**
             * adds option method -> $().plugin('option', {...})
             * @param {Function} PluginClass - constructor class
             */
            function addOptionMethod(PluginClass) {
                // don't overwrite original option method
                if (PluginClass.prototype.option) {
                    return;
                }

                // option setter
                PluginClass.prototype.option = function (opts) {
                    // bail out if not an object
                    if (!$.isPlainObject(opts)) {
                        return;
                    }
                    this.options = $.extend(true, this.options, opts);
                };
            }


            // -------------------------- plugin bridge -------------------------- //

            // helper function for logging errors
            // $.error breaks jQuery chaining
            var logError = typeof console === 'undefined' ? noop :
                    function (message) {
                        console.error(message);
                    };

            /**
             * jQuery plugin bridge, access methods like $elem.plugin('method')
             * @param {String} namespace - plugin name
             * @param {Function} PluginClass - constructor class
             */
            function bridge(namespace, PluginClass) {
                // add to jQuery fn namespace
                $.fn[ namespace ] = function (options) {
                    if (typeof options === 'string') {
                        // call plugin method when first argument is a string
                        // get arguments for method
                        var args = slice.call(arguments, 1);

                        for (var i = 0, len = this.length; i < len; i++) {
                            var elem = this[i];
                            var instance = $.data(elem, namespace);
                            if (!instance) {
                                logError("cannot call methods on " + namespace + " prior to initialization; " +
                                        "attempted to call '" + options + "'");
                                continue;
                            }
                            if (!$.isFunction(instance[options]) || options.charAt(0) === '_') {
                                logError("no such method '" + options + "' for " + namespace + " instance");
                                continue;
                            }

                            // trigger method with arguments
                            var returnValue = instance[ options ].apply(instance, args);

                            // break look and return first value if provided
                            if (returnValue !== undefined && returnValue !== instance) {
                                return returnValue;
                            }
                        }
                        // return this if no return value
                        return this;
                    } else {
                        var objects = this.map(function () {
                            var instance = $.data(this, namespace);
                            if (instance) {
                                // apply options & init
                                instance.option(options);
                                instance._init();
                            } else {
                                // initialize new instance
                                instance = new PluginClass(this, options);
                                $.data(this, namespace, instance);
                            }
                            return $(this);
                        });

                        if (!objects || objects.length > 1) {
                            return objects;
                        } else {
                            return objects[0];
                        }
                    }
                };

            }

            // -------------------------- bridget -------------------------- //

            /**
             * converts a Prototypical class into a proper jQuery plugin
             *   the class must have a ._init method
             * @param {String} namespace - plugin name, used in $().pluginName
             * @param {Function} PluginClass - constructor class
             */
            $.bridget = function (namespace, PluginClass) {
                addOptionMethod(PluginClass);
                bridge(namespace, PluginClass);
            };

            return $.bridget;

        }

        // get jquery from browser global
        defineBridget($);

    })($);


    /*************************************************
     
     BOOTSTRAP-SLIDER SOURCE CODE
     
     **************************************************/

    (function ($) {

        var ErrorMsgs = {
            formatInvalidInputErrorMsg: function (input) {
                return "Invalid input value '" + input + "' passed in";
            },
            callingContextNotSliderInstance: "Calling context element does not have instance of Slider bound to it. Check your code to make sure the JQuery object returned from the call to the slider() initializer is calling the method"
        };



        /*************************************************
         
         CONSTRUCTOR
         
         **************************************************/
        var Slider = function (element, options) {
            createNewSlider.call(this, element, options);
            return this;
        };

        function createNewSlider(element, options) {
            /*************************************************
             
             Create Markup
             
             **************************************************/
            if (typeof element === "string") {
                this.element = document.querySelector(element);
            } else if (element.nodeType === 1) {
                this.element = element;
            }

            var origWidth = this.element.style.width;
            var updateSlider = false;
            var parent = this.element.parentNode;
            var sliderTrackSelection;
            var sliderMinHandle;
            var sliderMaxHandle;

            if (this.sliderElem) {
                updateSlider = true;
            } else {
                /* Create elements needed for slider */
                this.sliderElem = document.createElement("div");
                this.sliderElem.className = "slider";

                /* Create slider track elements */
                var sliderTrack = document.createElement("div");
                sliderTrack.className = "slider-track";

                sliderTrackSelection = document.createElement("div");
                sliderTrackSelection.className = "slider-selection";

                sliderMinHandle = document.createElement("div");
                sliderMinHandle.className = "slider-handle min-slider-handle";

                sliderMaxHandle = document.createElement("div");
                sliderMaxHandle.className = "slider-handle max-slider-handle";

                sliderTrack.appendChild(sliderTrackSelection);
                sliderTrack.appendChild(sliderMinHandle);
                sliderTrack.appendChild(sliderMaxHandle);

                var createAndAppendTooltipSubElements = function (tooltipElem) {
                    var arrow = document.createElement("div");
                    arrow.className = "tooltip-arrow";

                    var inner = document.createElement("div");
                    inner.className = "tooltip-inner";

                    tooltipElem.appendChild(arrow);
                    tooltipElem.appendChild(inner);
                };

                /* Create tooltip elements */
                var sliderTooltip = document.createElement("div");
                sliderTooltip.className = "tooltip tooltip-main";
                createAndAppendTooltipSubElements(sliderTooltip);

                var sliderTooltipMin = document.createElement("div");
                sliderTooltipMin.className = "tooltip tooltip-min";
                createAndAppendTooltipSubElements(sliderTooltipMin);

                var sliderTooltipMax = document.createElement("div");
                sliderTooltipMax.className = "tooltip tooltip-max";
                createAndAppendTooltipSubElements(sliderTooltipMax);


                /* Append components to sliderElem */
                this.sliderElem.appendChild(sliderTrack);
                this.sliderElem.appendChild(sliderTooltip);
                this.sliderElem.appendChild(sliderTooltipMin);
                this.sliderElem.appendChild(sliderTooltipMax);

                /* Append slider element to parent container, right before the original <input> element */
                parent.insertBefore(this.sliderElem, this.element);

                /* Hide original <input> element */
                this.element.style.display = "none";
            }
            /* If JQuery exists, cache JQ references */
            if ($) {
                this.$element = $(this.element);
                this.$sliderElem = $(this.sliderElem);
            }

            /*************************************************
             
             Process Options
             
             **************************************************/
            options = options ? options : {};
            // FIX IE8
            if (!Object.keys)
            {
                Object.keys = function (o) {
                    if (o !== Object(o))
                        throw new TypeError('Object.keys called on non-object');
                    var ret = [], p;
                    for (p in o)
                        if (Object.prototype.hasOwnProperty.call(o, p))
                            ret.push(p);
                    return ret;
                }
            }
            var optionTypes = Object.keys(this.defaultOptions);

            for (var i = 0; i < optionTypes.length; i++) {
                var optName = optionTypes[i];

                // First check if an option was passed in via the constructor
                var val = options[optName];
                // If no data attrib, then check data atrributes
                val = (typeof val !== 'undefined') ? val : getDataAttrib(this.element, optName);
                // Finally, if nothing was specified, use the defaults
                val = (val !== null) ? val : this.defaultOptions[optName];

                // Set all options on the instance of the Slider
                if (!this.options) {
                    this.options = {};
                }
                this.options[optName] = val;
            }

            function getDataAttrib(element, optName) {
                var dataName = "data-slider-" + optName;
                var dataValString = element.getAttribute(dataName);

                try {
                    return JSON.parse(dataValString);
                }
                catch (err) {
                    return dataValString;
                }
            }

            /*************************************************
             
             Setup
             
             **************************************************/
            this.eventToCallbackMap = {};
            this.sliderElem.id = this.options.id;

            this.touchCapable = 'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch);

            this.tooltip = this.sliderElem.querySelector('.tooltip-main');
            this.tooltipInner = this.tooltip.querySelector('.tooltip-inner');

            this.tooltip_min = this.sliderElem.querySelector('.tooltip-min');
            this.tooltipInner_min = this.tooltip_min.querySelector('.tooltip-inner');

            this.tooltip_max = this.sliderElem.querySelector('.tooltip-max');
            this.tooltipInner_max = this.tooltip_max.querySelector('.tooltip-inner');

            if (updateSlider === true) {
                // Reset classes
                this._removeClass(this.sliderElem, 'slider-horizontal');
                this._removeClass(this.sliderElem, 'slider-vertical');
                this._removeClass(this.tooltip, 'hide');
                this._removeClass(this.tooltip_min, 'hide');
                this._removeClass(this.tooltip_max, 'hide');

                // Undo existing inline styles for track
                ["left", "top", "width", "height"].forEach(function (prop) {
                    this._removeProperty(this.trackSelection, prop);
                }, this);

                // Undo inline styles on handles
                [this.handle1, this.handle2].forEach(function (handle) {
                    this._removeProperty(handle, 'left');
                    this._removeProperty(handle, 'top');
                }, this);

                // Undo inline styles and classes on tooltips
                [this.tooltip, this.tooltip_min, this.tooltip_max].forEach(function (tooltip) {
                    this._removeProperty(tooltip, 'left');
                    this._removeProperty(tooltip, 'top');
                    this._removeProperty(tooltip, 'margin-left');
                    this._removeProperty(tooltip, 'margin-top');

                    this._removeClass(tooltip, 'right');
                    this._removeClass(tooltip, 'top');
                }, this);
            }

            if (this.options.orientation === 'vertical') {
                this._addClass(this.sliderElem, 'slider-vertical');

                this.stylePos = 'top';
                this.mousePos = 'pageY';
                this.sizePos = 'offsetHeight';

                this._addClass(this.tooltip, 'right');
                this.tooltip.style.left = '100%';

                this._addClass(this.tooltip_min, 'right');
                this.tooltip_min.style.left = '100%';

                this._addClass(this.tooltip_max, 'right');
                this.tooltip_max.style.left = '100%';
            } else {
                this._addClass(this.sliderElem, 'slider-horizontal');
                this.sliderElem.style.width = origWidth;

                this.options.orientation = 'horizontal';
                this.stylePos = 'left';
                this.mousePos = 'pageX';
                this.sizePos = 'offsetWidth';

                this._addClass(this.tooltip, 'top');
                this.tooltip.style.top = -$(this.tooltip).outerHeight() - 14 + 'px';

                this._addClass(this.tooltip_min, 'top');
                this.tooltip_min.style.top = -$(this.tooltip_min).outerHeight() - 14 + 'px';

                this._addClass(this.tooltip_max, 'top');
                this.tooltip_max.style.top = -$(this.tooltip_max).outerHeight() - 14 + 'px';
            }

            if (this.options.value instanceof Array) {
                this.options.range = true;
            } else if (this.options.range) {
                // User wants a range, but value is not an array
                this.options.value = [this.options.value, this.options.max];
            }

            this.trackSelection = sliderTrackSelection || this.trackSelection;
            if (this.options.selection === 'none') {
                this._addClass(this.trackSelection, 'hide');
            }

            this.handle1 = sliderMinHandle || this.handle1;
            this.handle2 = sliderMaxHandle || this.handle2;

            if (updateSlider === true) {
                // Reset classes
                this._removeClass(this.handle1, 'round triangle');
                this._removeClass(this.handle2, 'round triangle hide');
            }

            var availableHandleModifiers = ['round', 'triangle', 'custom'];
            var isValidHandleType = availableHandleModifiers.indexOf(this.options.handle) !== -1;
            if (isValidHandleType) {
                this._addClass(this.handle1, this.options.handle);
                this._addClass(this.handle2, this.options.handle);
            }

            this.offset = this._offset(this.sliderElem);
            this.size = this.sliderElem[this.sizePos];
            this.setValue(this.options.value);

            /******************************************
             
             Bind Event Listeners
             
             ******************************************/

            // Bind keyboard handlers
            this.handle1Keydown = this._keydown.bind(this, 0);
            function addEventListener(element, event, value) {
                if (element.addEventListener)
                {
                    return element.addEventListener(event, value, false);
                }
                else {
                    return element.attachEvent(event, value);
                }
            }
            addEventListener(this.handle1, "keydown", this.handle1Keydown);

            this.handle2Keydown = this._keydown.bind(this, 0);
            addEventListener(this.handle2, "keydown", this.handle2Keydown);

            if (this.touchCapable) {
                // Bind touch handlers
                this.mousedown = this._mousedown.bind(this);
                addEventListener(this.sliderElem, "touchstart", this.mousedown);
            } else {
                // Bind mouse handlers
                this.mousedown = this._mousedown.bind(this);
                addEventListener(this.sliderElem, "mousedown", this.mousedown);
            }

            // Bind tooltip-related handlers
            if (this.options.tooltip === 'hide') {
                this._addClass(this.tooltip, 'hide');
                this._addClass(this.tooltip_min, 'hide');
                this._addClass(this.tooltip_max, 'hide');
            } else if (this.options.tooltip === 'always') {
                this._showTooltip();
                this._alwaysShowTooltip = true;
            } else {
                this.showTooltip = this._showTooltip.bind(this);
                this.hideTooltip = this._hideTooltip.bind(this);

                this.sliderElem.addEventListener("mouseenter", this.showTooltip, false);
                this.sliderElem.addEventListener("mouseleave", this.hideTooltip, false);

                this.handle1.addEventListener("focus", this.showTooltip, false);
                this.handle1.addEventListener("blur", this.hideTooltip, false);

                this.handle2.addEventListener("focus", this.showTooltip, false);
                this.handle2.addEventListener("blur", this.hideTooltip, false);
            }

            if (this.options.enabled) {
                this.enable();
            } else {
                this.disable();
            }
        }

        /*************************************************
         
         INSTANCE PROPERTIES/METHODS
         
         - Any methods bound to the prototype are considered 
         part of the plugin's `public` interface
         
         **************************************************/
        Slider.prototype = {
            _init: function () {
            }, // NOTE: Must exist to support bridget

            constructor: Slider,
            defaultOptions: {
                id: "",
                min: 0,
                max: 10,
                step: 1,
                precision: 0,
                orientation: 'horizontal',
                value: 5,
                range: false,
                selection: 'before',
                tooltip: 'show',
                tooltip_split: false,
                handle: 'round',
                reversed: false,
                enabled: true,
                formatter: function (val) {
                    if (val instanceof Array) {
                        return val[0] + " : " + val[1];
                    } else {
                        return val;
                    }
                },
                natural_arrow_keys: false
            },
            over: false,
            inDrag: false,
            getValue: function () {
                if (this.options.range) {
                    return this.options.value;
                }
                return this.options.value[0];
            },
            setValue: function (val, triggerSlideEvent) {
                if (!val) {
                    val = 0;
                }
                this.options.value = this._validateInputValue(val);
                var applyPrecision = this._applyPrecision.bind(this);

                if (this.options.range) {
                    this.options.value[0] = applyPrecision(this.options.value[0]);
                    this.options.value[1] = applyPrecision(this.options.value[1]);

                    this.options.value[0] = Math.max(this.options.min, Math.min(this.options.max, this.options.value[0]));
                    this.options.value[1] = Math.max(this.options.min, Math.min(this.options.max, this.options.value[1]));
                } else {
                    this.options.value = applyPrecision(this.options.value);
                    this.options.value = [Math.max(this.options.min, Math.min(this.options.max, this.options.value))];
                    this._addClass(this.handle2, 'hide');
                    if (this.options.selection === 'after') {
                        this.options.value[1] = this.options.max;
                    } else {
                        this.options.value[1] = this.options.min;
                    }
                }

                this.diff = this.options.max - this.options.min;
                if (this.diff > 0) {
                    this.percentage = [
                        (this.options.value[0] - this.options.min) * 100 / this.diff,
                        (this.options.value[1] - this.options.min) * 100 / this.diff,
                        this.options.step * 100 / this.diff
                    ];
                } else {
                    this.percentage = [0, 0, 100];
                }

                this._layout();

                var sliderValue = this.options.range ? this.options.value : this.options.value[0];
                this._setDataVal(sliderValue);

                if (triggerSlideEvent === true) {
                    this._trigger('slide', sliderValue);
                }

                return this;
            },
            destroy: function () {
                // Remove event handlers on slider elements
                this._removeSliderEventHandlers();

                // Remove the slider from the DOM
                this.sliderElem.parentNode.removeChild(this.sliderElem);
                /* Show original <input> element */
                this.element.style.display = "";

                // Clear out custom event bindings
                this._cleanUpEventCallbacksMap();

                // Remove data values
                this.element.removeAttribute("data");

                // Remove JQuery handlers/data
                if ($) {
                    this._unbindJQueryEventHandlers();
                    this.$element.removeData('slider');
                }
            },
            disable: function () {
                this.options.enabled = false;
                this.handle1.removeAttribute("tabindex");
                this.handle2.removeAttribute("tabindex");
                this._addClass(this.sliderElem, 'slider-disabled');
                this._trigger('slideDisabled');

                return this;
            },
            enable: function () {
                this.options.enabled = true;
                this.handle1.setAttribute("tabindex", 0);
                this.handle2.setAttribute("tabindex", 0);
                this._removeClass(this.sliderElem, 'slider-disabled');
                this._trigger('slideEnabled');

                return this;
            },
            toggle: function () {
                if (this.options.enabled) {
                    this.disable();
                } else {
                    this.enable();
                }

                return this;
            },
            isEnabled: function () {
                return this.options.enabled;
            },
            on: function (evt, callback) {
                if ($) {
                    this.$element.on(evt, callback);
                    this.$sliderElem.on(evt, callback);
                } else {
                    this._bindNonQueryEventHandler(evt, callback);
                }
                return this;
            },
            getAttribute: function (attribute) {
                if (attribute) {
                    return this.options[attribute];
                } else {
                    return this.options;
                }
            },
            setAttribute: function (attribute, value) {
                this.options[attribute] = value;
                return this;
            },
            refresh: function () {
                this._removeSliderEventHandlers();
                createNewSlider.call(this, this.element, this.options);
                if ($) {
                    // Bind new instance of slider to the element
                    $.data(this.element, 'slider', this);
                }
                return this;
            },
            /******************************+
             
             HELPERS
             
             - Any method that is not part of the public interface.
             - Place it underneath this comment block and write its signature like so:
             
             _fnName : function() {...}
             
             ********************************/
            _removeSliderEventHandlers: function () {
                // Remove event listeners from handle1
                this.handle1.removeEventListener("keydown", this.handle1Keydown, false);
                this.handle1.removeEventListener("focus", this.showTooltip, false);
                this.handle1.removeEventListener("blur", this.hideTooltip, false);

                // Remove event listeners from handle2
                this.handle2.removeEventListener("keydown", this.handle2Keydown, false);
                this.handle2.removeEventListener("focus", this.handle2Keydown, false);
                this.handle2.removeEventListener("blur", this.handle2Keydown, false);

                // Remove event listeners from sliderElem
                this.sliderElem.removeEventListener("mouseenter", this.showTooltip, false);
                this.sliderElem.removeEventListener("mouseleave", this.hideTooltip, false);
                this.sliderElem.removeEventListener("touchstart", this.mousedown, false);
                this.sliderElem.removeEventListener("mousedown", this.mousedown, false);
            },
            _bindNonQueryEventHandler: function (evt, callback) {
                if (this.eventToCallbackMap[evt] === undefined) {
                    this.eventToCallbackMap[evt] = [];
                }
                this.eventToCallbackMap[evt].push(callback);
            },
            _cleanUpEventCallbacksMap: function () {
                var eventNames = Object.keys(this.eventToCallbackMap);
                for (var i = 0; i < eventNames.length; i++) {
                    var eventName = eventNames[i];
                    this.eventToCallbackMap[eventName] = null;
                }
            },
            _showTooltip: function () {
                if (this.options.tooltip_split === false) {
                    this._addClass(this.tooltip, 'in');
                } else {
                    this._addClass(this.tooltip_min, 'in');
                    this._addClass(this.tooltip_max, 'in');
                }
                this.over = true;
            },
            _hideTooltip: function () {
                if (this.inDrag === false && this.alwaysShowTooltip !== true) {
                    this._removeClass(this.tooltip, 'in');
                    this._removeClass(this.tooltip_min, 'in');
                    this._removeClass(this.tooltip_max, 'in');
                }
                this.over = false;
            },
            _layout: function () {
                var positionPercentages;

                if (this.options.reversed) {
                    positionPercentages = [100 - this.percentage[0], this.percentage[1]];
                } else {
                    positionPercentages = [this.percentage[0], this.percentage[1]];
                }

                this.handle1.style[this.stylePos] = positionPercentages[0] + '%';
                this.handle2.style[this.stylePos] = positionPercentages[1] + '%';

                if (this.options.orientation === 'vertical') {
                    this.trackSelection.style.top = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
                    this.trackSelection.style.height = Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';
                } else {
                    this.trackSelection.style.left = Math.min(positionPercentages[0], positionPercentages[1]) + '%';
                    this.trackSelection.style.width = Math.abs(positionPercentages[0] - positionPercentages[1]) + '%';

                    var offset_min = this.tooltip_min.getBoundingClientRect();
                    var offset_max = this.tooltip_max.getBoundingClientRect();

                    if (offset_min.right > offset_max.left) {
                        this._removeClass(this.tooltip_max, 'top');
                        this._addClass(this.tooltip_max, 'bottom');
                        this.tooltip_max.style.top = 18 + 'px';
                    } else {
                        this._removeClass(this.tooltip_max, 'bottom');
                        this._addClass(this.tooltip_max, 'top');
                        this.tooltip_max.style.top = -30 + 'px';
                    }
                }


                var formattedTooltipVal;

                if (this.options.range) {
                    formattedTooltipVal = this.options.formatter(this.options.value);
                    this._setText(this.tooltipInner, formattedTooltipVal);
                    this.tooltip.style[this.stylePos] = (positionPercentages[1] + positionPercentages[0]) / 2 + '%';

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
                    }

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
                    }

                    var innerTooltipMinText = this.options.formatter(this.options.value[0]);
                    this._setText(this.tooltipInner_min, innerTooltipMinText);

                    var innerTooltipMaxText = this.options.formatter(this.options.value[1]);
                    this._setText(this.tooltipInner_max, innerTooltipMaxText);

                    this.tooltip_min.style[this.stylePos] = positionPercentages[0] + '%';

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip_min, 'margin-top', -this.tooltip_min.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip_min, 'margin-left', -this.tooltip_min.offsetWidth / 2 + 'px');
                    }

                    this.tooltip_max.style[this.stylePos] = positionPercentages[1] + '%';

                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip_max, 'margin-top', -this.tooltip_max.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip_max, 'margin-left', -this.tooltip_max.offsetWidth / 2 + 'px');
                    }
                } else {
                    formattedTooltipVal = this.options.formatter(this.options.value[0]);
                    this._setText(this.tooltipInner, formattedTooltipVal);

                    this.tooltip.style[this.stylePos] = positionPercentages[0] + '%';
                    if (this.options.orientation === 'vertical') {
                        this._css(this.tooltip, 'margin-top', -this.tooltip.offsetHeight / 2 + 'px');
                    } else {
                        this._css(this.tooltip, 'margin-left', -this.tooltip.offsetWidth / 2 + 'px');
                    }
                }
            },
            _removeProperty: function (element, prop) {
                if (element.style.removeProperty) {
                    element.style.removeProperty(prop);
                } else {
                    element.style.removeAttribute(prop);
                }
            },
            _mousedown: function (ev) {
                if (!this.options.enabled) {
                    return false;
                }

                this._triggerFocusOnHandle();

                this.offset = this._offset(this.sliderElem);
                this.size = this.sliderElem[this.sizePos];

                var percentage = this._getPercentage(ev);

                if (this.options.range) {
                    var diff1 = Math.abs(this.percentage[0] - percentage);
                    var diff2 = Math.abs(this.percentage[1] - percentage);
                    this.dragged = (diff1 < diff2) ? 0 : 1;
                } else {
                    this.dragged = 0;
                }

                this.percentage[this.dragged] = this.options.reversed ? 100 - percentage : percentage;
                this._layout();

                this.mousemove = this._mousemove.bind(this);
                this.mouseup = this._mouseup.bind(this);

                if (this.touchCapable) {
                    // Touch: Bind touch events:
                    document.addEventListener("touchmove", this.mousemove, false);
                    document.addEventListener("touchend", this.mouseup, false);
                } else {
                    // Bind mouse events:
                    document.addEventListener("mousemove", this.mousemove, false);
                    document.addEventListener("mouseup", this.mouseup, false);
                }

                this.inDrag = true;

                var val = this._calculateValue();
                this._trigger('slideStart', val);
                this._setDataVal(val);
                this.setValue(val);

                this._pauseEvent(ev);

                return true;
            },
            _triggerFocusOnHandle: function (handleIdx) {
                if (handleIdx === 0) {
                    this.handle1.focus();
                }
                if (handleIdx === 1) {
                    this.handle2.focus();
                }
            },
            _keydown: function (handleIdx, ev) {
                if (!this.options.enabled) {
                    return false;
                }

                var dir;
                switch (ev.keyCode) {
                    case 37: // left
                    case 40: // down
                        dir = -1;
                        break;
                    case 39: // right
                    case 38: // up
                        dir = 1;
                        break;
                }
                if (!dir) {
                    return;
                }

                // use natural arrow keys instead of from min to max
                if (this.options.natural_arrow_keys) {
                    var ifVerticalAndNotReversed = (this.options.orientation === 'vertical' && !this.options.reversed);
                    var ifHorizontalAndReversed = (this.options.orientation === 'horizontal' && this.options.reversed);

                    if (ifVerticalAndNotReversed || ifHorizontalAndReversed) {
                        dir = dir * -1;
                    }
                }

                var oneStepValuePercentageChange = dir * this.percentage[2];
                var percentage = this.percentage[handleIdx] + oneStepValuePercentageChange;

                if (percentage > 100) {
                    percentage = 100;
                } else if (percentage < 0) {
                    percentage = 0;
                }

                this.dragged = handleIdx;
                this._adjustPercentageForRangeSliders(percentage);
                this.percentage[this.dragged] = percentage;
                this._layout();

                var val = this._calculateValue();

                this._trigger('slideStart', val);
                this._setDataVal(val);
                this.setValue(val, true);

                this._trigger('slideStop', val);
                this._setDataVal(val);

                this._pauseEvent(ev);

                return false;
            },
            _pauseEvent: function (ev) {
                if (ev.stopPropagation) {
                    ev.stopPropagation();
                }
                if (ev.preventDefault) {
                    ev.preventDefault();
                }
                ev.cancelBubble = true;
                ev.returnValue = false;
            },
            _mousemove: function (ev) {
                if (!this.options.enabled) {
                    return false;
                }

                var percentage = this._getPercentage(ev);
                this._adjustPercentageForRangeSliders(percentage);
                this.percentage[this.dragged] = this.options.reversed ? 100 - percentage : percentage;
                this._layout();

                var val = this._calculateValue();
                this.setValue(val, true);

                return false;
            },
            _adjustPercentageForRangeSliders: function (percentage) {
                if (this.options.range) {
                    if (this.dragged === 0 && this.percentage[1] < percentage) {
                        this.percentage[0] = this.percentage[1];
                        this.dragged = 1;
                    } else if (this.dragged === 1 && this.percentage[0] > percentage) {
                        this.percentage[1] = this.percentage[0];
                        this.dragged = 0;
                    }
                }
            },
            _mouseup: function () {
                if (!this.options.enabled) {
                    return false;
                }
                if (this.touchCapable) {
                    // Touch: Unbind touch event handlers:
                    document.removeEventListener("touchmove", this.mousemove, false);
                    document.removeEventListener("touchend", this.mouseup, false);
                } else {
                    // Unbind mouse event handlers:
                    document.removeEventListener("mousemove", this.mousemove, false);
                    document.removeEventListener("mouseup", this.mouseup, false);
                }

                this.inDrag = false;
                if (this.over === false) {
                    this._hideTooltip();
                }
                var val = this._calculateValue();

                this._layout();
                this._setDataVal(val);
                this._trigger('slideStop', val);

                return false;
            },
            _calculateValue: function () {
                var val;
                if (this.options.range) {
                    val = [this.options.min, this.options.max];
                    if (this.percentage[0] !== 0) {
                        val[0] = (Math.max(this.options.min, this.options.min + Math.round((this.diff * this.percentage[0] / 100) / this.options.step) * this.options.step));
                        val[0] = this._applyPrecision(val[0]);
                    }
                    if (this.percentage[1] !== 100) {
                        val[1] = (Math.min(this.options.max, this.options.min + Math.round((this.diff * this.percentage[1] / 100) / this.options.step) * this.options.step));
                        val[1] = this._applyPrecision(val[1]);
                    }
                    this.options.value = val;
                } else {
                    val = (this.options.min + Math.round((this.diff * this.percentage[0] / 100) / this.options.step) * this.options.step);
                    if (val < this.options.min) {
                        val = this.options.min;
                    }
                    else if (val > this.options.max) {
                        val = this.options.max;
                    }
                    val = parseFloat(val);
                    val = this._applyPrecision(val);
                    this.options.value = [val, this.options.value[1]];
                }
                return val;
            },
            _applyPrecision: function (val) {
                var precision = this.options.precision || this._getNumDigitsAfterDecimalPlace(this.step);
                return this._applyToFixedAndParseFloat(val, precision);
            },
            _getNumDigitsAfterDecimalPlace: function (num) {
                var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                if (!match) {
                    return 0;
                }
                return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
            },
            _applyToFixedAndParseFloat: function (num, toFixedInput) {
                var truncatedNum = num.toFixed(toFixedInput);
                return parseFloat(truncatedNum);
            },
            /*
             Credits to Mike Samuel for the following method!
             Source: http://stackoverflow.com/questions/10454518/javascript-how-to-retrieve-the-number-of-decimals-of-a-string-number
             */
            _getPercentage: function (ev) {
                if (this.touchCapable && (ev.type === 'touchstart' || ev.type === 'touchmove')) {
                    ev = ev.touches[0];
                }
                var percentage = (ev[this.mousePos] - this.offset[this.stylePos]) * 100 / this.size;
                percentage = Math.round(percentage / this.percentage[2]) * this.percentage[2];
                return Math.max(0, Math.min(100, percentage));
            },
            _validateInputValue: function (val) {
                if (typeof val === 'number') {
                    return val;
                } else if (val instanceof Array) {
                    this._validateArray(val);
                    return val;
                } else {
                    throw new Error(ErrorMsgs.formatInvalidInputErrorMsg(val));
                }
            },
            _validateArray: function (val) {
                for (var i = 0; i < val.length; i++) {
                    var input = val[i];
                    if (typeof input !== 'number') {
                        throw new Error(ErrorMsgs.formatInvalidInputErrorMsg(input));
                    }
                }
            },
            _setDataVal: function (val) {
                var value = "value: '" + val + "'";
                this.element.setAttribute('data', value);
                this.element.setAttribute('value', val);
            },
            _trigger: function (evt, val) {
                val = val || undefined;

                var callbackFnArray = this.eventToCallbackMap[evt];
                if (callbackFnArray && callbackFnArray.length) {
                    for (var i = 0; i < callbackFnArray.length; i++) {
                        var callbackFn = callbackFnArray[i];
                        callbackFn(val);
                    }
                }

                /* If JQuery exists, trigger JQuery events */
                if ($) {
                    this._triggerJQueryEvent(evt, val);
                }
            },
            _triggerJQueryEvent: function (evt, val) {
                var eventData = {
                    type: evt,
                    value: val
                };
                this.$element.trigger(eventData);
                this.$sliderElem.trigger(eventData);
            },
            _unbindJQueryEventHandlers: function () {
                this.$element.off();
                this.$sliderElem.off();
            },
            _setText: function (element, text) {
                if (typeof element.innerText !== "undefined") {
                    element.innerText = text;
                } else if (typeof element.textContent !== "undefined") {
                    element.textContent = text;
                }
            },
            _removeClass: function (element, classString) {
                var classes = classString.split(" ");
                var newClasses = element.className;

                for (var i = 0; i < classes.length; i++) {
                    var classTag = classes[i];
                    var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
                    newClasses = newClasses.replace(regex, " ");
                }

                element.className = newClasses.trim();
            },
            _addClass: function (element, classString) {
                var classes = classString.split(" ");
                var newClasses = element.className;

                for (var i = 0; i < classes.length; i++) {
                    var classTag = classes[i];
                    var regex = new RegExp("(?:\\s|^)" + classTag + "(?:\\s|$)");
                    var ifClassExists = regex.test(newClasses);

                    if (!ifClassExists) {
                        newClasses += " " + classTag;
                    }
                }
                element.className = newClasses.trim();
            },
            _offset: function (obj) {
                var ol = 0;
                var ot = 0;
                if (obj.offsetParent) {
                    do {
                        ol += obj.offsetLeft;
                        ot += obj.offsetTop;
                    } while (obj = obj.offsetParent);
                }
                return {
                    left: ol,
                    top: ot
                };
            },
            _css: function (elementRef, styleName, value) {
                elementRef.style[styleName] = value;
            }
        };

        /*********************************
         
         Attach to global namespace
         
         *********************************/
        if ($) {
            var namespace = $.fn.slider ? 'bootstrapSlider' : 'slider';
            $.bridget(namespace, Slider);
        } else {
            window.Slider = Slider;
        }


    })($);

})(window.jQuery);

app.service('Collection', [function () {

    function Collection(elements) {

        var _this = this;
        var current = 0;

        _this.elements = elements;

        _this.all = function () {
            return _this.elements;
        };

        _this.get = function ($index) {
            return _this.all()[$index];
        };

        _this.isEmpty = function () {
            return _this.elements.length;
        };

        _this.isNotEmpty = function () {
            return _this.elements.length;
        };

        _this.add = function (el) {
            _this.elements.push(el);
            return _this;
        };

        _this.count = function (fn) {
            if(fn)
            {
                var count = 0;
                _.each(_this.all(), function(item){
                    if(item[fn]())
                        count++;
                })
                return count;
            }
            else
                return _this.elements.length;
        };

        _this.current = function () {
            return _this.get(current);
        };

        /**
         * @description get current index
         * @return {number}
         */
        _this.currentIndex = function () {
            return current;
        };

        _this.next = function () {
            if (!_this.isAtTheEnd())
                current++;

            return _this;
        };

        _this.prev = function () {
            if (!_this.isAtTheStart())
                current--;

            return _this;
        };

        _this.isCurrent = function ($index) {
            return current == $index;
        };

        _this.isAtTheEnd = function () {
            return current >= _this.count() - 1;
        };

        _this.isAtTheStart = function () {
            return current == 0;
        };

        _this.getCurrentNumber = function () {
            return current + 1;
        };

        _this.setCurrent = function (index) {
            current = index;
            return _this;
        };

        _this.shuffle = function () {
            _this.elements = _.shuffle(_this.elements);
            return _this;
        };

        _this.limit = function (n) {
            _this.elements = _.first(_this.elements, n);
            return _this;
        };

        /**
         * Set collection at start
         * @return {model}
         */
        _this.atStart = function () {
            current = 0;
            return _this;
        };

        _this.atEnd = function () {
            current = _this.count() - 1;
            return _this;
        };

        /**
         * Foreach element in array call a function
         * @param  {string} nameFunction
         * @return {model}
         */
        _this.callEach = function (nameFunction) {
            _.each(_this.elements, function (item) {
                item[nameFunction]();
            });

            return _this;
        };

        _this.isBlocked = function () {
            var _return = false;

            _.each(_this.all(), function (el) {
                if (el.isBlocked()) {
                    _return = true;
                    return;
                }
            });

            return _return;
        };

        _this.filter = function (callback) {
            var array = [];
            _.each(_this.all(), function (item) {
                if (callback(item)) {
                    array.push(item);
                }
            });
            return new Collection(array);
        };

        _this.checkElementsByFn = function(nameFn) {
            var _return = true;

            _.each(_this.all(), function(item){
                if(!item[nameFn]())
                    _return = false;
            });

            return _return;
        }

        /**
         * @description foreach bridge
         * @param callback
         */
        _this.forEach = (callback)=>{
            _this.elements.forEach((item, key)=>{
                return callback(item, key);
            });
            return _this;
        };

        return _this;
    };

    var service = {
        create: function (array) {
            if (!(array instanceof Array)) {
                array = [array];
            }
            return new Collection(array);
        }
    };

    return service;
}]);

(function(){
	
	'use strict';

	var DetailedFactory = function($http, Model, MenuButton, Overlay)
	{
		var all = [];

		function Detailed(attrs) {

			var html = false;
		    var pages = false;
		    var currentPage = 0;
		    var promiseHtml = false;
		    var _opened = false;

		    var model = Model.create({
		        attrs: attrs,
		        name: 'detailed'
		    });

		    model.filepath = function(){
		    	return model.getAttr('file') + '.' + model.getAttr('type');
		    };

		    model.getHtml = function() {
		    	if(!promiseHtml) {
		    		promiseHtml = $http.get(model.filepath()).then(function(data){
		    			html = data.data;
		    		});
		    	}

	    		return html;
		    };

		    model.open = function() {
		    	_opened = true;
				MenuButton.find('detailed').open();
				Overlay.open('detailed', model);
			};

		    model.viewed = function() {
		    	return _opened;
			};

		    model.modelLabel = function(){
				return false;
			};

			model.isVideo = function() {
				return model.getAttr('type') == 'video' || model.getAttr('type') == 'mp4';
			};

		    return model;
		}

		var service = {
			get: function(index) {
				return all[index];
			},
			create: function(attrs) {
				return new Detailed(attrs);
			},
			collection: function (array) {
	            if (!all.length) {
	                var tmp = [];
	                _.each(array, function (item) {
	                    tmp.push(new Detailed(item));
	                });
	                all = Model.collection(tmp);
	            }
	            return all;
	        },
	        all: function(){
	        	return all;
	        },
	        init: function() {
	        	$http.get('config/detailed.json').then(function(response){
					_.each(response.data.items, function(item)
			        {
			           all.push(new Detailed(item)); 
			        });
				});
	        },
	        SortModelLabel: function(model) {
	        	return model.getAttr('label');
	        }
		};

		return service;
	};

	DetailedFactory.$inject = ['$http', 'Model', 'MenuButton', 'Overlay'];
	
	angular.module('Application')
		.factory('Detailed', DetailedFactory)
		.run(['Detailed', function(Detailed) 
		{
			Detailed.init();
		}]);

})();

app.service('Dispatcher', ['Page', 'App', 'MenuButton', 'Menu', '$timeout', '$rootScope',
    function (Page, App, MenuButton, Menu, $timeout, $rootScope) {

        /**
         * al click della pagina successiva
         */
        Page.events.on('next', function () {

            if(!App.hasNextPage()) return;

            if(!App.config().isFree() && !App.module().lesson().page().isViewed()) return;

            if(App.module().lesson().page().video())
                App.module().lesson().page().video().pause();

            if (App.module().lesson().pages().isAtTheEnd()) {
                if (!App.module().lessons().isAtTheEnd()) {
                    App.module().nextLesson();
                    App.module().lesson().pages().atStart();
                }
                else {
                    App.nextModule();
                    App.module().lessons().atStart();
                    App.module().lesson().pages().atStart();
                }
            }
            else {
                App.module().lesson().nextPage();
            }

            Page.events.emit('change');
        });

        /**
         * al click della pagina precedente
         */
        Page.events.on('prev', function () {

            if(!App.hasPrevPage())
                return;

            if(App.module().lesson().page().video())
                App.module().lesson().page().video().pause();

            if (App.module().lesson().pages().isAtTheStart()) {
                if (!App.module().lessons().isAtTheStart()) {
                    App.module().prevLesson();
                    App.module().lesson().pages().atEnd();
                }
                else {
                    App.prevModule();
                    App.module().lessons().atEnd();
                    App.module().lesson().pages().atEnd();
                }
            }
            else {
                App.module().lesson().prevPage();
            }

            Page.events.emit('change');

        }, false);

        /**
         * Ogniqualvolta viene aperto il menu
         */
        Menu.panel.on('open', function () {

            // metto in pausa il video quando viene aperto
            // il menu
            if (App.module().lesson().page().video())
                App.module().lesson().page().video().pause();

        }, false);

    }]);

(function(){

	'use strict';

	var DoitFactory = function($http, $timeout, Model){

		var all = [];

		function Doit(attrs) 
		{
			var wrong = false;
			var help = false;

			var model = Model.create({
	            attrs: attrs,
	            name: 'doit'
	        });

	        model.wrong = function() {
	        	wrong = true;
	        	return model;
	        };

	        model.isWrong = function() {
	        	return wrong;
	        };

	        model.retry = function() {
	        	wrong = false;
	        	return model;
	        };

	        model.help = function(_callback) {
	        	help = true;
	        	
	        	$timeout(function()
	        	{
	        		if(_callback)
	        			_callback(model);
	        	}
	        	, 1500);

	        	return model;
	        };

	        model.refresh = function() {
	        	wrong = false;
	        	help = false;
	        };

	        model.isHelpOpened = function() {
	        	return help;
	        };

	        return model;
		};


		var service = {
			create: function(attrs) 
			{
				return new Doit(attrs);
			},
			get: function(index)
			{
				return all[index];
			},
			all: function() {
				return all;
			},
			load: function(_callback)
			{
				$http.get('config/doits.json').then(function(response)
				{
					_.each(response.data.items, function(item)
					{
						all.push(service.create(item));
					});
					return _callback.call(this, response);
				});
			}
		};

		return service;
	};

	DoitFactory.$inject = ['$http','$timeout', 'Model'];

	/**
	 * Controller
	 */
	var DoItController = function($scope, App)
	{
		$scope.isCoverVisible = true;

		$scope.startDoIt = function() {
			$scope.isCoverVisible = false;

			// launch audio on load if present
			if($scope.doit().audio())
				$scope.doit().audio().play();
		};

		// shortcut to current doit
		$scope.doit = function() {	
			return App.module().lesson().page().doits().current();
		};

		// help function called when user
		// click on help button
		$scope.help = function() 
		{
			$scope.doit().help(function()
			{
				$scope.page().doits().next();
			});
		};

		// get resource if node is a Exercise
		$scope.resource = function()
		{
			if($scope.page().doits().current().__is('exercise'))
				return $scope.page().doits().current();

			return false;
		};

		/**
		 * Watch when do it is completed
		 * page will be set viewed
		 */
		$scope.$watch(function(){
			return App.module().lesson().page().doits().isAtTheEnd();
		}, 
		function(value){
			if(value)
			{
				App.module().lesson().page().viewed();
			}
		});

		App.events.on('refresh', function()
		{
			$scope.page().doits().atStart();
			$scope.page().doits().callEach('refresh').atStart();
		});
	};

	DoItController.$inject = ['$scope', 'App'];

	angular.module('Application')
		.factory('Doit', DoitFactory)
		.controller('DoItController', DoItController);

})();

app.factory('Event', ['$rootScope', '$timeout', 
	function($rootScope, $timeout){
	
	function _Event(name) {
		var _this = this;
		_this.name = name;

		function __event(_event) {
			return _this.name+'.'+_event;
		};

		_this.emit = function(ev, params){
			$rootScope.$emit(__event(ev), params);
		};

		_this.on = function(ev, _function, delay){
			delay = angular.isUndefined(delay) ? false : delay;	

			// avvio l'evento dopo delay tempo se definito
			// altrimenti viene fired all'istante
			$timeout(function(){
				$rootScope.$on(__event(ev), function(event, data){
					return _function.call(this, event, data);
				}, delay);
			});
		};

		return _this;
	};

	var service = {
		create: function(name){
			return new _Event(name);
		}
	}; 

	return service;
}]);

app.factory('Eventer', ['$rootScope', function($rootScope){
	
	function _Event(name) {
		_this.name = name;

		function __event(_event) {
			return _this.name+'.'+_event;
		};

		_this.emit = function(ev, params){
			$rootScope.$emit(__event(ev), params);
		};

		_this.on = function(ev, _function){
			$rootScope.$on(__event(ev), function(event, data){
				return _function.call(this, event, data);
			});
		};

		return _this;
	};

	var service = {
		create: function(name){
			return new _Event(name);
		}
	}; 
}]);

(function(){

	'use strict';

	var ExampleFactory = function($http, Model, MenuButton, Overlay){

		var all = [];

		$http.get('config/examples.json').then(function(response){
			_.each(response.data.items, function(item)
            {
               all.push(new Example(item)); 
            });
		});

		function Example(attrs) {
			var model = Model.create({
	            attrs: attrs,
	            name: 'example'
	        });

			model.filepath = function(){
				return model.getAttr('file') + '.' + model.getAttr('type');
			};

			model.open = function() {
				MenuButton.find('examples').open();
				Overlay.open('examples', model) ;
			};

	        return model;
		};


		var service = {
			create: function(attrs){
				return new Example(attrs);
			},
			get: function(index){
				if(all[index])
					return all[index];

				return false;
			},
			all: function(){
				return all;
			}
		};

		return service;
	};


	ExampleFactory.$inject = ['$http','Model','MenuButton','Overlay'];

	angular.module('Application')
		.factory('Example', ExampleFactory);

})();

(function () {
    "use strict";

    var ExerciseFactory = function ($http, $q, Model, Collection, $translate) {
        var all = null;
        var promise = false;

        /**
         *    Get all Exercises
         */
        var promise = $http.get("config/exercises.json");

        var exercisesNamespace = {};
        /**
         * Exercise with only one single answer correct
         * @param {Obj} attrs
         */
        exercisesNamespace.SingleAnswer = function (attrs) {
            var answered = null;

            var model = Model.create({
                attrs: attrs,
                name: "exercise",
            });

            model.setAnswer = function (a, forceSetter) {
                if (!model.isConfirmed() || forceSetter) {
                    answered = a;
                }

                if (model.getAttr("confirmOnAnswer")) model.setAttr("confirm", true); //model.confirm();

                if (model.getAttr("solutionOnAnswer")) model.setAttr("solution", true);

                return model;
            };

            model.hasSelected = function (a) {
                return answered == a;
            };

            model.isAnswered = function () {
                return answered;
            };

            model.answered = function (a) {
                return a == answered;
            };

            model.isCorrect = function (answer) {
                var answer = answer ? answer : answered;
                return (
                    _.indexOf(model.getAttr("answers"), answer) ==
                    model.getAttr("correct")
                );
            };

            model.cancel = function () {
                answered = null;
                model.setAttr("confirm", false);
                model.setAttr("solution", false);

                return model;
            };

            model.reset = function () {
                model.cancel();
            };

            model.getAnsweredIndex = function () {
                return _.indexOf(model.getAttr("answers"), answered);
            };

            /**
             * Check if exercise is blocked
             * @return {boolean}
             */
            model.isBlocked = function () {
                return !model.isCorrect() && !model.isSolutionVisible();
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.DragDrop = function (attrs) {
            var matches = [];
            var answered = [];
            var options = false;

            var draggedItem = false;

            var model = Model.create({
                attrs: attrs,
                name: "exercise.dragdrop",
            });

            model.middleware.attrs = {
                options: function (value) {
                    if (options == false) options = _.shuffle(value);
                    return options;
                },
            };

            /**
             * Get all matches for options
             * @return {array}
             */
            model.getAllMatches = function () {
                return model.getAttr("matches");
            };

            /**
             * Check if is given almost one answer
             * @return {boolean}
             */
            model.isGivenAlmostOneAnswer = function () {
                var _return = false;

                _.each(model.getAttr("droppables"), function (value) {
                    if (value.answered.length) {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Check if one
             * @returns {boolean}
             */
            model.canBeDroppedMultipleInOne = function () {
                if (model.getAttr("matchesType") == "multiple") return true;

                return false;
            };

            model.dropOptions = function () {
                return {
                    multiple: function () {
                        return model.canBeDroppedMultipleInOne();
                    },
                };
            };

            /**
             * Check if option can be dropped
             * @return {Boolean}
             */
            model.canBeDropped = function (event, ui, param) {
                var defer = $q.defer();

                if (!param) return false;

                if (param.answered.length >= 1 && !model.canBeDroppedMultipleInOne()) {
                    defer.reject();
                } else {
                    defer.resolve();
                }

                return defer.promise;
            };

            /**
             * Save item dragged
             * @param  {Obj} item
             * @return {model}
             */
            model.registerDraggedItem = function (event, ui, item) {
                draggedItem = item;
                return model;
            };

            /**
             * Check if all answers are checked
             * @return {Boolean}
             */
            model.areAllAnswered = function () {
                var _return = true;

                if (model.getAttr("allMatchesMustBeDropped")) {
                    _.each(model.getAttr("draggables"), function (item) {
                        if (!angular.isUndefined(item) && !model.isDragged(item)) {
                            _return = false;
                            return;
                        }
                    });
                } else {
                    _.each(model.getAttr("droppables"), function (value) {
                        if (!value.answered.length) {
                            _return = false;
                            return;
                        }
                    });
                }

                return _return;
            };

            /**
             * Check if element is already dragged
             * @param  {obj}  option
             * @return {Boolean}
             */
            model.isDragged = function (option) {
                var _return = false;

                _.each(model.matches, function (item) {
                    if (item.answered == option) {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Cancel given answers
             * @return {model}
             */
            model.cancel = function () {
                model.copyAttr("droppables", "matches");
                _.each(model.getAttr("droppables"), function (item) {
                    item.answered = [];
                });
                model.copyAttr("draggables", "options");

                model.setAttr("confirm", false);
                model.setAttr("solution", false);

                return model;
            };

            /**
             * Check if exercise answers are correct
             * @return {Boolean}
             */
            model.isCorrect = function () {
                var _return = true;

                _.each(model.getAttr("droppables"), function (item, key) {
                    _.each(item.answered, function (a) {
                        if (!angular.isUndefined(a) && _.indexOf(a.match, key) == -1) {
                            _return = false;
                            return;
                        }
                    });

                    if (!_return) return;
                });

                return _return;
            };

            model.isAssignmentCorrect = function (match, answer) {
                var _return = true;
                var indexMatch = _.indexOf(model.getAttr("droppables"), match);

                if (indexMatch == -1) console.warn("no match");

                if (answer.match[0] != indexMatch) {
                    _return = false;
                    return;
                }

                return _return;
            };

            /**
             * Set solution of exercise
             * @return {model}
             */
            model.solution = function () {
                model.setAttr("solution", true);

                _.each(model.getAttr("droppables"), function (item, key) {
                    var tmp = [];
                    _.each(model.getAttr("options"), function (option) {
                        if (_.indexOf(option.match, key) > -1) {
                            tmp.push(option);
                        }
                    });

                    item.answered = tmp;
                });
                return model;
            };

            // reset all values
            model.cancel();

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.SelectMultiple = function (attrs) {
            var matches = [];
            var options = false;

            var model = Model.create({
                attrs: attrs,
                name: "exercise.select",
            });

            model.middleware.attrs = {
                options: function (value) {
                    // if (options == false)
                    //     options = _.shuffle(value);
                    options = value;
                    return options;
                },
            };

            /**
             * Get all matches for options
             * @return {array}
             */
            model.getAllMatches = function () {
                if (matches.length == 0) {
                    matches = [];
                    _.each(model.getPlainAttr("options"), function (option) {
                        matches = matches.concat(option.match);
                    });

                    matches = _.shuffle(_.uniq(matches));
                }
                return matches;
            };

            /**
             * Check if is given almost one answer
             * @return {boolean}
             */
            model.isGivenAlmostOneAnswer = function () {
                var _return = false;

                _.each(model.getPlainAttr("options"), function (value) {
                    if (value.answer) {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Check if every select has been answered
             * @return {boolean}
             */
            model.isAnswered = function () {
                var _return = true;
                // console.log("areAAnswered", model.getPlainAttr('options'));
                _.each(model.getPlainAttr("options"), function (value) {
                    // console.log("value", value);
                    if (!value.answer && value.answer !== 0) {
                        _return = false;
                        return;
                    }
                });
                // console.log("isC", model.isCorrect());
                return _return;
            };

            /**
             * Cancel given answers
             * @return {model}
             */
            model.cancel = function () {
                _.each(model.getPlainAttr("options"), function (value) {
                    value.answer = false;
                });

                // model.attrs.confirm = false;
                model.setAttr("confirm", false);

                return model;
            };

            // /**
            //  * Check if exercise answers are correct
            //  * @return {Boolean}
            //  */
            // model.isCorrect = function () {
            //     var _return = true;
            //     var corrects = 0;

            //     _.each(model.getAttr('options'), function (option) {
            //         if (_.indexOf(option.match, option.answer) > -1) {
            //             corrects++;
            //         }
            //         else {
            //             _return = false;
            //             return;
            //         }
            //     });

            //     return _return;
            // };

            /**
             * Check if every select has been correctly selected
             * @return {boolean}
             */
            model.isCorrect = function () {
                var _return = true;
                // console.log("isCorrect", model.getAttr('options'));
                _.each(model.getAttr("options"), function (value) {
                    // console.log("> ", value.answer, value.match);
                    if (value.answer != value.match) {
                        _return = false;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Set solution of exercise
             * @return {model}
             */
            model.solution = function () {
                model.setAttr("solution", true);
                _.each(model.getAttr("options"), function (option) {
                    option.answer = option.match[0];
                });
                return model;
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.Multiple = function (attrs) {
            var corrects = [];
            var options = false;

            var model = Model.create({
                attrs: attrs,
                name: "exercise.multiple",
            });

            model.attr.choices = [];

            model.middleware.attrs = {
                options: function (value) {
                    // if (options == false)
                    //     options = _.shuffle(value);

                    options = value;
                    return options;
                },
            };

            model.isAnswered = function () {
                return !!model.getAttr("choices").length;
                // return model.getAttr("choices").length >= model.corrects().length;
            };

            model.hasSelected = function (option) {
                if (_.indexOf(model.getAttr("choices"), option) > -1) return true;

                return false;
            };

            model.isOptionCorrect = function (option) {
                return !!option.correct;
            };

            model.setAnswer = function (option) {
                if (model.isConfirmed()) {
                    return;
                }
                // console.log("option",option);
                // console.log(model.hasSelected(option));
                if (model.hasSelected(option)) {
                    var pos = _.indexOf(model.getAttr("choices"), option);
                    model.getAttr("choices").splice(pos, 1);
                } else {
                    model.getAttr("choices").push(option);
                }
                // console.log(">", model.getAttr("choices"));
                return option;
            };

            model.corrects = function () {
                if (!corrects.length) {
                    _.each(model.getAttr("options"), function (item) {
                        if (item.correct) corrects.push(item);
                    });
                }
                return corrects;
            };

            model.getFeedback = function () {
                var feed = model.getAttr("feedback");

                if (model.isSolutionVisible()) return feed.solution;

                if (model.isCorrect()) return feed.success;
                else return feed.failed;
            };

            model.getFeedbackClass = function () {
                if (model.isSolutionVisible()) return "alert-info";

                return model.isCorrect() ? "alert-success" : "alert-danger";
            };

            model.isCorrect = function () {
                var _return = true;
                if (model.getAttr("choices").length !== model.corrects().length) {
                    return false;
                }
                _.each(model.corrects(), function (item) {
                    if (_.indexOf(model.getAttr("choices"), item) == -1) {
                        _return = false;
                        return;
                    }
                });

                return _return;
            };

            model.cancel = function () {
                // model.setAttr("choices", false);
                model.setAttr("choices", []);
                model.setAttr("confirm", false);
                return model;
            };

            model.solution = function () {
                model.setAttr("choices", model.corrects());
                model.setAttr("confirm", true);
                model.setAttr("solution", true);
                return model;
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.Crociate = function (attrs) {
            var allAnswer;

            var model = Model.create({
                attrs: attrs,
                name: "exercise",
            });

            // model.middleware.attrs = {
            //     answers: function (value) {
            //         if (answers === false && model.getAttr('shuffle')) {
            //             answers = _.shuffle(value);
            //         }
            //         return answers;
            //     }
            // };

            // model.setAnswer = function (a, forceSetter) {
            //     if (!model.isConfirmed() || forceSetter) {
            //         answered = a;
            //     }

            //     if (model.getAttr('confirmOnAnswer'))
            //         model.setAttr('confirm', true); //model.confirm();

            //     if (model.getAttr('solutionOnAnswer'))
            //         model.setAttr('solution', true);

            //     return model;
            // };

            // model.getUserAnswerIndex = function (option) {
            //     var position = _.indexOf(items, option) + 1;
            //     return position > 0 ? position : false;
            // };

            // EDITED 2019-09-01
            // model.isAnswered = function () {
            //     var _isAnswered = false;
            //     // FIXED 2020-03-02 - quando si deseleziona un elemento, la posizione viene settata a option['position'] = 999;, quindi isAnswered continuava a ritornare true
            //     _isAnswered =_.every(model.answers(), function(a) { console.log("isAnswered item", a.position + !!a.position); return a.position && (a.position<= model.answers().length)});

            //     return _isAnswered;
            // };

            model.answersLang = function () {
                return model.getAttr("answers_" + $translate.use());
            };

            model.wordToFoundLang = function () {
                return model.getAttr("wordToFound_" + $translate.use());
            };

            //@index --> param to know which word disabled
            model.disabledCorrect = function (indexToDisabled) {
                _.each(model.answersLang(), function (row, i) {
                    _.each(row, function (column, l) {
                        if (column.group == indexToDisabled) {
                            column.disabled = true;
                        }
                    });
                });
            };

            model.checkLimitClick = function () {
                const allAnswer = [].concat(...model.answersLang());
                let answered = allAnswer.filter((letter) => {
                    return letter.answered;
                }).length;
                //const maxClick=[].concat(...model.getAttr('wordToFound'));
                const counterClick = 0;
                const maxClick = model.wordToFoundLang()
                    .reduce(
                        (accumulator, currentValue) =>
                            accumulator + currentValue.label.length,
                        counterClick
                    );
                return answered > maxClick ? true : false;
            };

            model.checkCorrect = function (answer) {
                var __return = false;
                //convert from matrix to array unique (to use filter when check group)
                const allAnswer = [].concat(...model.answersLang());
                /*
                I loop the array word (obtain index's word) and check the number of click
                that user have done with "group" prop that correspond to the index of word
                Example: 
                "wordToFound":[{"label":"lll"}],
                "answers": [
                    [{"l":"L","group":0},{"l":"E"},{"l":"A"}],
                    [{"l":"L","group":0},{"l":"E"},{"l":"A"}],
                    [{"l":"L","group":0},{"l":"E"},{"l":"A"}]
                ]
                
                if user clicked letters width "group":0, "answered":true prop will be added.
                if the letter with "group":0 have also prop "answered":true then user founded the word
                */

                //console.log("allAnswer",allAnswer)
                _.each(model.wordToFoundLang(), function (word, i) {
                    let founded = allAnswer.filter((letter) => {
                        //return letter.group == i && letter.answered;
                        if (letter.group) {
                            if (letter.group.indexOf(i) > -1 && letter.answered)
                                return true
                        }
                        return false
                        //return (letter.group && letter.group.indexOf(i)>-1) && letter.answered;
                    }).length;
                    if (founded == word.label.length && !word.correct) {
                        word.correct = true;
                        model.disabledCorrect(i);
                        __return = word.label;
                    }
                });
                return __return;
            };

            model.isEnded = function () {
                let founded = model.wordToFoundLang().filter((word) => {
                    return word.correct;
                }).length;
                return (founded >= model.wordToFoundLang().length) ? true : false
            }

            model.solution = function () {
                _.each(model.answersLang(), function (row, i) {
                    _.each(row, function (column, l) {

                        if (column.group >= 0)
                            column.answered = true;
                        else
                            column.answered = false

                    });
                });
                model.setAttr("solution", true);
            }

            model.selectCell = function (row, column) {
                if (!model.answersLang()[row][column].answered)
                    model.answersLang()[row][column].answered = true;
                else model.answersLang()[row][column].answered = false;
                //console.log("model.answers()",model.answers()[row][column])
                //model.answers()[row][column].answered=true
            };

            model.cancel = function () {
                items.length = 0;

                _.each(model.answersLang(), function (answer) {
                    delete answer.position;
                });
                model.setAttr("confirm", false);

                return model;
            };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.OrderOption = function (attrs) {
            var answered = null;
            var answers = false;
            var items = [];

            var model = Model.create({
                attrs: attrs,
                name: "exercise",
            });

            model.middleware.attrs = {
                answers: function (value) {
                    // console.log(value);
                    // console.log(model.getAttr('shuffle'));
                    // return [];
                    // return value;
                    if (answers === false && model.getAttr("shuffle")) {
                        answers = _.shuffle(value);
                    }
                    return answers;
                },
            };

            // model.setAnswer = function (a, forceSetter) {
            //     if (!model.isConfirmed() || forceSetter) {
            //         answered = a;
            //     }

            //     if (model.getAttr('confirmOnAnswer'))
            //         model.setAttr('confirm', true); //model.confirm();

            //     if (model.getAttr('solutionOnAnswer'))
            //         model.setAttr('solution', true);

            //     return model;
            // };

            model.setUserAnswerOrder = function (option, forceSetter) {
                if (model.isConfirmed()) return;
                var position = model.getUserAnswerIndex(option);
                if (position === false) {
                    items.push(option);
                    option["position"] = model.getUserAnswerIndex(option);
                } else {
                    items.splice(position - 1, 1);
                    _.each(items, function (item, index) {
                        // console.log("item",item, index);
                        item["position"] = index + 1;
                        // console.log("item",item, index);
                        // console.log("item------------");
                    });
                    option["position"] = 999;
                }
                // console.log(option, items);
                return option;
            };

            model.getUserAnswerIndex = function (option) {
                var position = _.indexOf(items, option) + 1;
                // console.log("POS", position, option, model.answers());
                // console.log("> ", $scope.items);
                return position > 0 ? position : false;
            };

            // EDITED 2019-09-01
            model.isAnswered = function () {
                var _isAnswered = false;
                // FIXED 2020-03-02 - quando si deseleziona un elemento, la posizione viene settata a option['position'] = 999;, quindi isAnswered continuava a ritornare true
                _isAnswered = _.every(model.answers(), function (a) {
                    console.log("isAnswered item", a.position + !!a.position);
                    return a.position && a.position <= model.answers().length;
                });

                return _isAnswered;
            };

            // model.hasSelected = function (a) {
            //     return answered == a;
            // };

            // model.answered = function (a) {
            //     return a === answered;
            // };

            // model.isAtLeastOneSelected = function () {
            //     return model.isAnswered();
            // };

            model.isCorrect = function (answer) {
                var __result = true;
                _.each(model.answers(), function (answer) {
                    if (answer.order != answer.position) __result = false;
                });
                return __result;
            };

            model.cancel = function () {
                items.length = 0;
                // console.log(">", model.answers());
                _.each(model.answers(), function (answer) {
                    delete answer.position;
                });
                model.setAttr("confirm", false);
                // answered = null;
                return model;
            };

            // model.reset = function () {
            //     model.cancel();
            // };

            // model.getAnsweredIndex = function () {
            //     return _.indexOf(model.getAttr('answers'), answered);
            // };

            // /**
            //  * Check if exercise is blocked
            //  * @return {boolean}
            //  */
            // model.isBlocked = function () {
            //     return !model.isCorrect() && !model.isSolutionVisible();
            // };

            return model;
        };

        /**
         * Exercise with select answer
         * @param {Obj} attrs
         */
        exercisesNamespace.TableMultiple = function (attrs) {
            var corrects = [];
            var rows = [];

            var model = Model.create({
                attrs: attrs,
                name: "exercise.tablemultiple",
            });

            model.rows = function () {
                return model.getAttr("rows");
            };

            model.isAnswered = function () {
                var _return = true;
                _.each(model.rows(), function (item) {
                    if (!item.value) _return = false;
                });
                return _return;
            };

            model.score = function () {
                var score = 0;

                _.each(model.rows(), function (item) {
                    score += item.value;
                });

                return score;
            };

            return model;
        };

        /**
         * Exercise text input
         * @param {Obj} attrs
         */
        exercisesNamespace.Text = function (attrs) {
            var answered = "";

            var model = Model.create({
                attrs: attrs,
                name: "exercise.text",
            });

            model.setAnswer = function (value) {
                if (!value) value = null;
                answered = value;
                return model;
            };

            model.isAnswered = function () {
                return answered;
            };

            model.cancel = function () {
                answered = null;
                model.setAttr("confirm", false);
                return model;
            };

            model.isCorrect = function () {
                return (
                    answered != null &&
                    answered.toLowerCase().replace(".", "") ==
                    model.getAttr("correct").toLowerCase()
                );
            };

            /**
             * Check if exercise is blocked
             * @return {boolean}
             */
            model.isBlocked = function () {
                return !model.isCorrect() && !model.isSolutionVisible();
            };

            return model;
        };

        /**
         * Exercise text input
         * @param {Obj} attrs
         */
        exercisesNamespace.YesNo = function (attrs) {
            var answered = "";

            var model = Model.create({
                attrs: attrs,
                name: "exercise.yesno",
            });

            model.options = function () {
                return model.getAttr("options");
            };

            model.items = function () {
                return model.getAttr("items");
            };

            model.setAnswer = function (item, optionIndex) {
                if (model.isConfirmed()) return;
                // console.log("item", item, optionIndex);
                item.answer = optionIndex;
                // console.log(item.answer);
                return model;
            };

            model.isItemAnswered = function (item) {
                // console.log(item.answer);
                return item.answer !== undefined;
            };

            model.itemAnswered = function (item) {
                // console.log(item.answer);
                return item.answer;
            };

            model.isOptionAnswered = function (item, optionIndex) {
                return item.answer == optionIndex;
            };

            model.isOptionCorrect = function (item, optionIndex) {
                return item.solution == optionIndex;
            };

            /**
             * Check if all items are answered
             * @return {Boolean}
             */
            model.isAnswered = function () {
                var _return = true;
                _.each(model.items(), function (item) {
                    if (angular.isUndefined(item.answer) && item.answer !== 0) {
                        _return = false;
                        return;
                    }
                });
                return _return;
            };

            model.isCorrect = function () {
                var _return = true;
                _.each(model.items(), function (item) {
                    if (
                        angular.isUndefined(item.answer) ||
                        item.answer !== item.solution
                    ) {
                        _return = false;
                        return;
                    }
                });
                return _return;
            };

            model.cancel = function () {
                answered = null;
                model.setAttr('confirm', false);
                return model;
            };

            // model.isCorrect = function () {
            //     return answered != null
            //         && answered.toLowerCase().replace('.', '') == model.getAttr('correct').toLowerCase();
            // };

            return model;
        };
        /**
 * Exercise: Fill (tabellare, con celle input)
 * Supporta equivalenze numeriche (20 == 20,00) e pattern testuali.
 * @param {Obj} attrs
 */
exercisesNamespace.Fill = function (attrs) {
    var model = Model.create({
        attrs: attrs,
        name: "exercise.fill",
    });

    // grid: matrice di celle; ogni cella può essere { text } oppure { input:true, key, ... }
    model.grid = function () {
        return model.getAttr("grid") || [];
    };

    function trimNull(v) {
        return v === undefined || v === null ? "" : ("" + v).trim();
    }

    // Normalizza input:
    // - rimuove spazi/spezzature
    // - gestisce separatori migliaia , . ' e NBSP
    // - individua il separatore decimale come "l’ultimo tra , o ."
    // - converte decimale a '.' per confronto numerico
    function normalizeValue(raw) {
        var s = trimNull(raw);
        if (!s) return { type: "empty", value: "" };

        // rimuovi spazi (incluso NBSP)
        s = s.replace(/\u00A0/g, " ").replace(/\s+/g, "");

        var hasComma = s.indexOf(",") > -1;
        var hasDot = s.indexOf(".") > -1;

        if (hasComma && hasDot) {
            // decimale = l’ultimo separatore che compare
            var lastComma = s.lastIndexOf(",");
            var lastDot = s.lastIndexOf(".");
            var decimalIsComma = lastComma > lastDot;

            if (decimalIsComma) {
                // rimuovi tutti i punti (migliaia), poi virgola -> punto
                s = s.replace(/\./g, "");
                s = s.replace(/,/g, ".");
            } else {
                // rimuovi tutte le virgole (migliaia), lascia il punto
                s = s.replace(/,/g, "");
            }
        } else if (hasComma) {
            // usa la virgola come decimale
            s = s.replace(/,/g, ".");
        } else {
            // solo punto o nessuno → già ok
        }

        // rimuovi apostrofo come migliaia (es. 1'234.56)
        s = s.replace(/'/g, "");

        var num = Number(s);
        if (!isNaN(num) && isFinite(num)) {
            return { type: "number", value: num };
        }

        return { type: "string", value: s.toLowerCase() };
    }

    // Raccoglie tutte le celle input
    model.inputCells = function () {
        var out = [];
        _.each(model.grid(), function (row) {
            _.each(row, function (cell) {
                if (cell && cell.input) out.push(cell);
            });
        });
        return out;
    };

    model.setCellAnswer = function (cell, value) {
        if (model.isConfirmed()) return model;
        cell.userAnswer = value;
        return model;
    };

    model.isCellAnswered = function (cell) {
        var s = trimNull(cell.userAnswer);
        return s.length > 0;
    };

    function matchAgainstAcceptList(userNorm, cell, tol) {
        var list = cell.accept || [];
        for (var i = 0; i < list.length; i++) {
            var accNorm = normalizeValue(list[i]);
            if (userNorm.type === "number" && accNorm.type === "number") {
                if (Math.abs(userNorm.value - accNorm.value) <= tol) return true;
            } else if (userNorm.type === "string" && accNorm.type === "string") {
                if (userNorm.value === accNorm.value) return true;
            }
        }
        return false;
    }

    model.isCellCorrect = function (cell) {
        if (!cell || !cell.input) return true;
        if (!model.isCellAnswered(cell)) return false;

        var userNorm = normalizeValue(cell.userAnswer);
        var tol = (cell.tolerance !== undefined) ? cell.tolerance : 1e-9;

        // Numero target esplicito: { number: { value: 20, tolerance?: 0.01, precision?: 2 } }
        if (cell.number && cell.number.value !== undefined) {
            var target = Number(cell.number.value);
            var t = (cell.number.tolerance !== undefined) ? cell.number.tolerance : tol;
            return (userNorm.type === "number") && Math.abs(userNorm.value - target) <= t;
        }

        // Lista di accettati (misti string/number)
        if (cell.accept && cell.accept.length) {
            return matchAgainstAcceptList(userNorm, cell, tol);
        }

        // Regex (stringa senza / /, opzionale flags)
        if (cell.pattern) {
            try {
                var re = new RegExp(cell.pattern, cell.patternFlags || "i");
                return re.test(trimNull(cell.userAnswer));
            } catch (e) {
                // pattern invalido → consideriamo non corretto
                return false;
            }
        }

        // Se non definita alcuna regola, consideriamo corretto solo se non vuoto
        return userNorm.type !== "empty";
    };

    model.isAnswered = function () {
        var inputs = model.inputCells();
        if (!inputs.length) return false;
        return _.every(inputs, function (c) { return model.isCellAnswered(c); });
    };

    model.isCorrect = function () {
        var inputs = model.inputCells();
        if (!inputs.length) return false;
        return _.every(inputs, function (c) { return model.isCellCorrect(c); });
    };

    model.cancel = function () {
        _.each(model.inputCells(), function (c) { delete c.userAnswer; });
        model.setAttr("confirm", false);
        model.setAttr("solution", false);
        return model;
    };

    model.solution = function () {
        // Precompila le risposte “preferite” (displaySolution > number>precision > primo accept)
        _.each(model.inputCells(), function (c) {
            if (c.displaySolution) {
                c.userAnswer = c.displaySolution;
            } else if (c.number && c.number.value !== undefined) {
                var v = Number(c.number.value);
                if (c.number.precision !== undefined) {
                    c.userAnswer = v.toFixed(c.number.precision);
                } else {
                    c.userAnswer = "" + v;
                }
            } else if (c.accept && c.accept.length) {
                c.userAnswer = "" + c.accept[0];
            }
        });
        model.setAttr("solution", true);
        model.setAttr("confirm", true);
        return model;
    };

    return model;
};

        /**
         **/
        function Feedback(attrs) {
            var model = Model.create({
                attrs: attrs,
                name: "feedback",
            });

            return model;
        }

        /**
         * Get exercise
         * @param {Obj} attrs
         */
        function Exercise(attrs, type) {
            var html = false;
            var pages = false;
            var feedback = false;
            var repeat = 0;
            var timingStarted = false;
            var timingStopped = false;

            switch (type) {
                default:
                case "single":
                    type = "SingleAnswer";
                    break;
                case "select":
                    type = "SelectMultiple";
                    break;
                case "drag":
                    type = "DragDrop";
                    break;
                case "multiple":
                    type = "Multiple";
                    break;
                case "tablemultiple":
                    type = "TableMultiple";
                    break;
                case "text":
                    type = "Text";
                    break;
                case "yesno":
                    type = "YesNo";
                    break;
                case "order":
                    type = "OrderOption";
                    break;
                case "crociate":
                    type = "Crociate";
                    break;
                    case "fill":        type = "Fill"; break;
            }
            var model = new exercisesNamespace[type](attrs);

            model.setAttr("confirm", false);

            /**
             * Get Answer array related
             * @return {array}
             */
            model.answers = function () {
                // console.log("answers normale")
                return model.getAttr("answers");
            };

            /**
             * Confirm answers
             * @return {model}
             */
            model.confirm = function () {
                model.setAttr("confirm", true);

                if (model.getAttr("solutionOnAnswer")) model.setAttr("solution", true); //model.confirm();

                return model;
            };

            /**
             * Check if is confirmed
             * @return {Boolean}
             */
            model.isConfirmed = function () {
                return model.getAttr("confirm");
            };

            /**
             * Check if solution is visible
             * @return {Boolean}
             */
            model.isSolutionVisible = function () {
                return model.getAttr("solution");
            };

            /**
             * Check if exercise is blocked
             * @return {boolean}
             */
            model.isBlocked = function () {
                if (model.getAttr("feedbackOnDrop")) {
                    return !model.areAllAnswered();
                }

                return !model.isCorrect() && !model.isSolutionVisible();
            };

            model.repeat = function () {
                model.cancel();
                model.setAttr("confirm", false);
                repeat++;
                console.log("increment repeat", repeat);
                return model;
            };

            model.getRepeatValue = function () {
                return repeat;
            };

            model.isRepeatable = function () {
                return model.getAttr("repeat") > repeat;
            };

            model.refresh = function () {
                model.repeat();
                model.setAttr("confirm", false);
            };

            model.getFeedback = function () {
                return feedback;
            };

            model.showFeedback = function () {
                if (!feedback) {
                    var attr = model.isCorrect()
                        ? model.getAttr("feedback")[0].correct
                        : model.getAttr("feedback")[0].incorrect;
                    feedback = new Feedback(attr);
                }
                return model;
            };

            model.isFeedbackVisible = function () {
                return feedback ? true : false;
            };

            model.closeFeedback = function () {
                feedback = false;
                return model;
            };

            model.countRepeat = function () {
                return repeat;
            };

            model.startTiming = function () {
                if (!timingStarted) timingStarted = moment();
            };

            model.stopTiming = function () {
                timingStopped = moment();
            };

            model.latency = function () {
                if (timingStopped) return timingStopped.diff(timingStarted, "seconds");
                return 0;
            };

            /**
             * @description return score
             * @return {number}
             */
            model.score = () => {
                var score = 0;
                if (!model.getAttr("score")) return score;

                return model.isCorrect()
                    ? score + model.getAttr("score")
                    : model.getAttr("scorePenalty") && model.isConfirmed()
                        ? score - model.getAttr("scorePenalty")
                        : 0;
            };

            // Many files
            model.manyFromFile("File");

            return model;
        }

        var service = {
            find: function (index) {
                return all[index];
            },
            create: function (attrs) {
                return new Exercise(attrs);
            },
            get: function (index) {
                return this.all()[index];
            },
            getById: function (id) {
                var tmp = [];

                _.each(all, function (item) {
                    if (_.indexOf(id, item.getAttr("id")) > -1) tmp.push(item);
                });

                return Collection.create(tmp);
            },
            all: function (callback) {
                if (all == null) {
                    all = [];
                    promise = promise.then(function (response) {
                        _.each(response.data.items, function (data) {
                            all.push(new Exercise(data, data.type));
                        });

                        if (callback) return callback(all);
                    });
                }

                return all;
            },
            promise: function () {
                return promise;
            },
        };

        return service;
    };

    ExerciseFactory.$inject = ["$http", "$q", "Model", "Collection", "$translate"];

    angular
        .module("Application")
        .factory("Exercise", ExerciseFactory)
        .run([
            "Exercise",
            function (Exercise) {
                Exercise.all();
            },
        ]);
})();


(function(){

	'use strict';

	var GlossaryFactory = function($http, Model, Panel, Collection, $filter)
	{

		var GlossaryPanel = Panel.create('glossary');

		function Term(attrs) {
			var model = Model.create({
				attrs: attrs,
				name: 'term'
			});

			model.startWith = function(letter) {
				var label = model.getAttr('label').toLowerCase();
				var letter = letter.toLowerCase();
				return label.startsWith(letter);
			};

			return model;
		}

		function Glossary(attrs) {

			var activeLetter = false;
			var activeTerm = false;
			var terms = [];

			var model = Model.create({
				attrs: attrs,
				name: 'glossary'
			});

			model.terms = function(array) {

				if(array) {
					_.each(array, function(item) { terms.push(new Term(item)); });
				}

				if(terms.length)
					return terms;
			};

			model.letters = function() {
				var a = [], i = 'a'.charCodeAt(0), j = 'z'.charCodeAt(0);
				for (; i <= j; ++i) {
					a.push(String.fromCharCode(i));
				}
				return a;
			};

			model.filterByActiveLetter = function() {
				if(!model.getActiveLetter())
					return false;
				return $filter('firstLetter')(model.terms(), model.getActiveLetter(), 'label');
			};

			model.filterByLetter = function(letter) {
				return $filter('firstLetter')(model.terms(), letter, 'label');
			};

			model.setActiveLetter = function(letter) {
				activeLetter = letter;
				activeTerm = false;
				return model;
			};

			model.getActiveLetter = function() {
				return activeLetter;
			};

			model.term = function(term) {
				if(term)
					activeTerm = term;
				return activeTerm;
			};

			return model;
		}

		var GlossaryInstance = new Glossary();

		var service = {
			panel: GlossaryPanel,
			init: function() {
				$http.get('config/glossary.json').then(function(response){
					GlossaryInstance.terms(response.data.items);
				});
			},
			instance: GlossaryInstance
		};

		return service;
	};

	GlossaryFactory.$inject = ['$http', 'Model', 'Panel', 'Collection', '$filter'];

	angular.module('Application')
		.factory('Glossary', GlossaryFactory)
		.run(['Glossary', 'App', function(Glossary, App)
		{
			Glossary.init();

			Glossary.panel.on('open', function() {
				App.module().lesson().page().video().pause();
			});
		}]);

})();

app.service('Helper', function () {

    var service = {
        toHHMMSS: function (string) {
            var sec_num = parseInt(string, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);

            if (hours < 10) {
                hours = "0" + hours;
            }
            
            var time = hours + ':' + this.toMMSS(string);
            return time;
        },
        toMMSS: function(string){
            var sec_num = parseInt(string, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            var time = minutes + ':' + seconds;
            return time;
        },
        getLetterMaiusc: function(i) {
            return String.fromCharCode(97 + i).toUpperCase();
        }
    };

    /**
     * Se non esiste definisco la funzione INDEXOF
     */
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
            if (this == null) {
                throw new TypeError();
            }
            var n, k, t = Object(this),
                    len = t.length >>> 0;

            if (len === 0) {
                return -1;
            }
            n = 0;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n != n) { // shortcut for verifying if it's NaN
                    n = 0;
                } else if (n != 0 && n != Infinity && n != -Infinity) {
                    n = (n > 0 || -1) * Math.floor(Math.abs(n));
                }
            }
            if (n >= len) {
                return -1;
            }
            for (k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++) {
                if (k in t && t[k] === searchElement) {
                    return k;
                }
            }
            return -1;
        };
    }

    // attach the .equals method to Array's prototype to call it on any array
    Array.prototype.equals = function (array) {
        // if the other array is a falsy value, return
        if (!array)
            return false;

        // compare lengths - can save a lot of time 
        if (this.length != array.length)
            return false;

        for (var i = 0, l = this.length; i < l; i++) {
            // Check if we have nested arrays
            if (this[i] instanceof Array && array[i] instanceof Array) {
                // recurse into the nested arrays
                if (!this[i].equals(array[i]))
                    return false;
            }
            else if (this[i] != array[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
    }

    /**
     * Se non esiste definisco la funzione TRIM()
     */
    if (typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/gi, '');
        }
    }

    return service;
});

app.factory('Lesson', ['Model', 'Page', function (Model, Page) {

    var all = [];

    function Lesson(attrs) {

        var pages = false;
        // let _duration = null;

        var model = Model.create({
            attrs: attrs,
            name: 'lesson'
        });

        model.pages = function () {
            if (pages === false) {
                pages = Page.collection(attrs.pages)
            }
            return pages;
        };

        model.page = function () {
            return model.pages().current();
        };

        model.prevPage = function () {
            if (!model.pages().isAtTheStart()) {

                if (model.page().audio())
                    model.page().audio().stop();

                if (model.page().video())
                    model.page().video().pause();

                model.pages().prev();
            }
        };

        model.nextPage = function () {
            if (
                model.page().isViewed() &&
                !model.pages().isAtTheEnd()
            ) {
                if (model.page().audio())
                    model.page().audio().stop();

                if (model.page().video())
                    model.page().video().pause();

                model.pages().next();
            }
        };

        /**
         * Go to page if is already viewed
         * @param  {Int} i
         * @param {Boolean} unblock
         * @return {Model}
         */
        model.goToPage = function (i, unblock) {

            if (!model.pages().get(i).isViewed() && !unblock)
                return model;

            if (model.page() && model.page().video())
                model.page().video().pause();

            model.pages().setCurrent(i);
            Page.events.emit('change');
            return model;
        };

        /**
         * Check if page param is the current
         * page in view
         * @param {Page} page
         * @return {Boolean}]
         */
        model.isCurrent = function (page) {
            return model.page() == page;
        };

        /**
         * @description check if lesson is viewed
         * @return {Boolean}
         */
        model.isViewed = function() {
            var _return = true;
            model.pages().all().forEach(function(item) {
                if (!item.isViewed()) {
                    _return = false;
                    return;
                }
            });
            return _return;
        };

        // /**
        //  * @description get duration module
        //  * @return seconds
        //  */
        // model.duration = ()=>{
        //     if(_duration === null) {
        //         model.pages().forEach(page => _duration+=page.duration());
        //     }
        //     return _duration;
        // };
        
        model.setCurrentPage = function (i) {
            model.pages().setCurrent(i);
            return model;
        };

        model.pagesWithExercises = function () {
            return _.filter(pages.all(), function (p) {
                return p.hasExercises();
            });
        };

        model.pagesPassed = function () {
            var passed = 0;

            _.each(pages.all(), function (p) {
                if (p.hasExercises() && p.passed()) {
                    passed++;
                }
            });

            return passed;
        }

        model.isLastPage=function(){
            
            return (model.pages().all().length===(model.pages().currentIndex()+1) ? true : false)
                
            
        }

        /**
         * @description get score lesson
         * @return {number}
         */
        model.score = () => {
            let score = 0;
            model.pages().forEach(page => score += page.score());
            // console.log("LessonSCORE", score);
            return score;
        };

        /**
         * @description get score lesson
         * @return {number}
         */
        model.maxScore = () => {
            let score = 0;
            model.pages().forEach(page => score += page.maxScore());
            return score;
        };

        return model;
    };

    var service = {
        create: function (attrs) {
            return new Lesson(attrs);
        },
        collection: function (array) {
            if (!all.length) {
                var tmp = [];
                _.each(array, function (item) {
                    tmp.push(new Lesson(item));
                });
                all = Model.collection(tmp);
            }
            return all;
        }
    };

    return service;
}]);


app.factory('Menu', ['Panel', function(Panel){
        
    var panel = Panel.create('menu');
        
    var all = [];
        
    var service = {
        panel: panel
    };
    
    return service;
}]);

app.factory('MenuButton', ['Menu', 'Panel', 'Event', '$http',
    function(Menu, Panel, Event, $http){
  
        var buttons = [];
        var all = [];
        var allBottoms = [];
        var allTops = [];

        // get all buttons
        $http.get('config/buttons.json').then(function(response){
        
            buttons = response.data.buttons;

            _.each(buttons, function(item)
            {
               all.push(new Button(item)); 
            });
        });

        var panel = Panel.create('menu-in');
        var eventer = Event.create('menu-in');
        
        // l'ultimo pulsante cliccato
        var lastButtonNameOpened = false;
  
        panel.on('open', function(){
            Menu.panel.open();
        }, false);
        
        panel.on('close', function(){
            Menu.panel.close();
        }, false);
  
        function Button(attrs) {
            var _this = this;
            _this.attrs = attrs;
            
            _this.open = function(name){
                    
                lastButtonNameOpened = name;

                if(!_this.has('fn')) {
                    panel.open();
                    
                    eventer.emit('open', {
                        name: name
                    });
                }
                else {
                    _this.has('fn')['default'].call(this);
                }
                    
            };
            
            _this.hasPanel = function(){
                if(_this.attrs.link)
                    return false;
                
                if(_this.attrs.panel || angular.isUndefined(_this.attrs.panel))
                   return true;
                else
                   return false;
            };
            
            _this.has = function(attr){
                return _this.attrs[attr];
            };
            
            _this.hasExpandedView = function(){
                return _this.attrs.expand;
            };
            
            _this.close = function(){
                
                if(!_this.has('fn')) {
                    lastButtonNameOpened = false;
                    panel.close();
                    eventer.emit('close');
                }
                else {
                    _this.has('fn').reverse.call(this);
                }
            };
            
            _this.toggle = function(){
                if(_this.hasPanel())
                {
                    if(lastButtonNameOpened == _this.attrs.name)
                        return _this.close();
                    else 
                        return _this.open(_this.attrs.name);
                }
            };
            
            _this.isOpened = function(){
                return lastButtonNameOpened == _this.attrs.name;
            };
            
            _this.name = function(){
                return _this.attrs.name;
            };
            
            _this.icon = function(){
                if(_this.attrs.icon)
                    return 'glyphicon-'+_this.attrs.icon;
                return false;
            };
            
            _this.label = function() {
                return _this.attrs.label;   
            };
            
            _this.link = function() {
                return _this.attrs.link;
            };
            
            _this.goBottom = function(){
                return _this.attrs.bottom;
            };

            // get css of button state
            _this.getClasses = function(){
                var classes = '';

                if(_this.isOpened(_this.name()))
                    classes += 'active ';

                if(_this.attrs.disabled)
                    classes += 'disabled ';

                return classes;
            };  

            return _this;
        };
        
        var service = {
            create: function(attrs) {
                return new Button(attrs);
            },
            all: function(){
                return all;
            },
            events: eventer,
            isOpened: function(name){
                return lastButtonNameOpened == name;
            },
            lastOpened: function(){
                var i = false;
                _.each(this.all(), function(item, k){
                    if(item.name() == lastButtonNameOpened)
                    {
                        i = k;
                        return;
                    }
                });
                return this.all()[i];
            },
            allBottoms: function(){
                if(!allBottoms.length)
                {
                    _.each(this.all(), function(item){
                        if(item.goBottom())
                            allBottoms.push(item);
                    });
                }
                return allBottoms;
            },
            allTops: function(){
                if(!allTops.length)
                {
                    _.each(this.all(), function(item){
                        if(!item.goBottom())
                            allTops.push(item);
                    });
                }
                return allTops;
            },
            find: function(name){
                var founded = false;

                _.each(this.all(), function(item){
                    if(item.name() == name) {
                        founded = item;
                        return;
                    }
                });

                return founded;
            },
            isAPanelOpened: function(){
                return lastButtonNameOpened;
            }
        };
        
        return service;
}]);

app.factory('Model', ['Collection', '$injector', 'Sound', '$filter',
    function (Collection, $injector, Sound, $filter) {

        var utils = {
            /**
             * if object has items array, i'll return
             * them, if not i'll return the entire object
             * because it's items array
             * @param  {JSON} obj
             * @return {array}
             */
            getItems: function(obj) {
                return obj && obj.items ? obj.items : obj;
            },
            /**
             * Function applying the options of the object
             * to filter its items
             * es. limit, random, etc.
             * @param  {json} obj   json object
             * @param  {array} items json array of obj children
             * @return {array}
             */
            filterByOptions: function (obj, items) {
                var array = items;

                if(obj.random) {
                    array = _.shuffle(items);
                }

                if(obj.limit) {
                    array = _.initial(array, obj.limit);
                }

                return array;
            },
            /**
             * Check if a number is really integer and not float
             * @param  {Number}  value
             * @return {Boolean}
             */
            isInt: function(value) {
                return Number(value) === value && value % 1 === 0;
            }
        };

        function Model(setup) {
            var _this = this
            var _event = false;
            var audio = false;
            var properties = {};
            _this.attr = setup.attrs;

            _this.middleware = { attrs: {}};

            _this.getAttr = function (attr) {
                if(!angular.isUndefined(_this.middleware.attrs[attr]))
                {
                    return _this.middleware.attrs[attr](_this.getPlainAttr(attr));
                }
                return _this.getPlainAttr(attr);
            };

            _this.getTransAttr = function(attr) {
                return $filter('translate')(_this.getAttr(attr));
            };

            _this.getPlainAttr = function(attr){
                return _this.attr[attr];
            };

            _this.getAttrs = function(){
                return _this.attr;
            };

            _this.setAttr = function(attr, value) {
                _this.attr[attr] = value;
                return _this;
            }

            _this.copyAttr = function(destination, source) {
                _this.attr[destination] = angular.copy(_this.getAttr(source));
                return _this;
            };

            _this.title = function () {
                return _this.getAttr('title');
            };

            _this.name = function(){
                return _this.getAttr('name');
            };

            _this.img = function(){
                return _this.getAttr('img');
            };

            /**
             * Get audio of timing
             * @return {Sound}
             */
            _this.audio = function() {
                if(!audio)
                {
                    if(_this.getAttr('audio'))
                    {
                        audio = Sound.create(_this.getAttr('audio'));
                    }
                }
                return audio;
            };

            /**
             * Check if page has audio and is playing
             * @return {Boolean}
             */
            _this.hasAudioAndIsPlaying = function(){
                if(_this.audio())
                {
                    if(_this.audio().isPaused())
                    {
                        return false;
                    }
                    return true;
                }
            };

            /**
             * Find an obj in a list of fns joined with a '.'
             * in string format
             * @param  {Strin} path
             * @param  {Mix} index
             * @return {Mix}
             */
            _this.findIn = function(path, index) {

                var result = _this.chainFn(path);

                if(result)
                {
                    if(utils.isInt(index))
                    {
                        // index is really an index
                        return result[index];
                    }
                    else
                    {
                        // index in reality is a obj
                        var found = _.indexOf(result, index)
                        return found > -1 ? found : false;
                    }
                }

                return false;
            };

            _this.chainFn = function(path) {
                var methods = path.split('.');
                var result = _this[methods[0]]();
                methods.shift();

                _.each(methods, function(method){
                    result = result[method]();
                });

                return result;
            };

            /**
             * Check if element is of name
             * @param  {string} name
             * @return {boolean}
             */
            _this.__is = function(name) {
                return name == setup.name;
            };

            // add a many relationship
            _this.many = function(model, _callback) {
                // property name (model.questions)
                var propertyName = model.toLowerCase()+'s';
                // the model object to use (Question)
                var injector = $injector.get(model);

                // declare property
                properties[propertyName] = false;

                // create function to get the array of objects
                _this[propertyName] = function()
                {
                    if(!properties[propertyName])
                    {
                        var obj = _this.getAttr(propertyName);

                        if(obj)
                        {
                            var arrayJSONItems = utils.getItems(obj);
                            var array = Collection.create([]);

                            // apply the filter of the objects (limit, random, etc..)
                            arrayJSONItems = utils.filterByOptions(obj, arrayJSONItems);

                            injector.load(function(response)
                            {
                                _.each(arrayJSONItems, function(item)
                                {
                                    var itemToAdd;

                                    // check if is an external resource
                                    if(typeof item == 'string' && item.length > 1)
                                    {
                                        // get resource and position index Exercise:0
                                        var resource = item.split(':');
                                        if(resource.length)
                                        {
                                            var resourceInjector = $injector.get(resource[0]);
                                            itemToAdd = resourceInjector.get(resource[1]);
                                        }
                                    }
                                    else {
                                        itemToAdd = injector.get(item);
                                    }

                                    // add to Collection
                                    if(itemToAdd)
                                        array.add(itemToAdd);
                                });

                                properties[propertyName] = array;
                            });
                        }
                    };

                    return properties[propertyName];
                };

                _this[propertyName]();
            };

            // add a many relationship
            _this.manyFromFile = function(model, _callback) {
                // property name (model.questions)
                var propertyName = model.toLowerCase()+'s';
                // the model object to use (Question)
                var injector = $injector.get(model);

                // declare property
                properties[propertyName] =  Collection.create([]);

                // create function to get the array of objects
                _this[propertyName] = function()
                {
                    if(!properties[propertyName].isNotEmpty())
                    {
                        var obj = _this.getAttr(model);

                        if(obj)
                        {
                            injector.load(function(response)
                            {
                                _.each(obj, function(index)
                                {
                                    var itemToAdd = injector.create(response.data.items[index]);
                                    // add to Collection
                                    if(itemToAdd)
                                        properties[propertyName].add(itemToAdd);
                                });
                            });
                        }
                    };

                    return properties[propertyName];
                };

                _this[propertyName]();
            };

            // add a one relationship
            _this.one = function(model)
            {
                // property name (model.questions)
                var propertyName = model.toLowerCase();

                // the model object to use (Question)
                var injector = $injector.get(model);

                // declare property
                properties[propertyName] = false;

                _this[propertyName] = function()
                {
                    if(!properties[propertyName])
                    {
                        var obj = _this.getAttr(propertyName);

                        if(!obj)
                        {
                            obj = _this.getAttr(model);
                        }

                        if(obj !== false && obj !== null) properties[propertyName] = injector.get(obj);
                    };
                    return properties[propertyName];
                };
            };

            return _this;
        };

        var service = {
            create: function (setup) {
                return new Model(setup);
            },
            collection: function (array) {
                return Collection.create(array);
            }
        };

        return service;
    }]);

app.factory('Module', ['Model', 'Lesson', '$timeout', function (Model, Lesson, $timeout) {

    var all = [];

    function Module(attrs) {

        var lessons = false;
        var exercises = [];
        var _is_visible = false;

        var model = Model.create({
            attrs: attrs,
            name: 'module'
        });

        model.lessons = function () {
            if (lessons === false) {
                lessons = Lesson.collection(attrs.lessons);
            }
            return lessons;
        };

        model.lesson = function () {
            return model.lessons().current();
        };

        model.setCurrentLesson = function (i) {
            model.lessons().setCurrent(i);
            // model.lesson().pages().setCurrent(0);
            return model;
        };

        model.nextLesson = function () {
            if (!model.lessons().isAtTheEnd()) {

                if (model.lesson().page().video())
                    model.lesson().page().video().pause();

                model.lessons().next();
                model.lesson().pages().setCurrent(0);
            }
            return model;
        };

        model.isCurrent = function (lesson) {
            var i = _.indexOf(model.lessons().all(), lesson);
            if (i > -1)
                return model.lessons().isCurrent(i);
            return false;
        }

        model.prevLesson = function () {
            if (!model.lessons().isAtTheStart()) {

                if (model.lesson().page().video())
                    model.lesson().page().video().pause();

                model.lessons().prev();
                model.lesson().pages().setCurrent(0);
            }
            return model;
        };

        model.exercises = function () {
            if (!exercises.length) {
                _.each(model.lessons().all(), function (lesson) {
                    _.each(lesson.pages().all(), function (page) {
                        exercises = _.union(exercises, page.exercises());
                    });
                });
            }
            return exercises;
        };

        // This method gets exercises from pages (only one exercises per page)
        model.moduleExercises = function () {
            if (!exercises.length) {
                _.each(model.lessons().all(), function (lesson) {
                    _.each(lesson.pages().all(), function (page) {
                        // console.log( page.getAttr('title'), page.hasExercise(), page.hasTimingExercises(), page.exercises() );
                        if (page.hasExercise())
                            exercises = _.union(exercises, [page.hasExercise()]);
                    });
                });
            }
            return exercises;
        };
        
        model.improvedModuleExercises = function () {
            if (!exercises.length) {
                _.each(model.lessons().all(), function (lesson) {
                    _.each(lesson.pages().all(), function (page) {
                        // if (page.hasTimingExercises()) console.log( page.getAttr('title'), page.hasExercise(), page.hasTimingExercises() );
                        // console.log(">>>",page.hasTimingExercises());
                        if (page.hasTimingExercises())
                            exercises = _.union(exercises, page.hasTimingExercises());
                    });
                });
            }
            // console.log("TEST", exercises.length, exercises);
            // _.each(exercises, function (exercise) {
            //     if (exercise) {
            //         console.log(typeof exercise, exercise);
            //         console.log("ex", exercise.getAttr('label'));
            //         console.log(exercise.isCorrect(), exercise.isConfirmed());
            //     }
            // });
            return exercises;
        };

        model.testExercises = function () {
            var exercises = [];
            _.each(model.lessons().all(), function (lesson) {
                _.each(lesson.pages().all(), function (page) {
                    // if (page.hasTimingExercises()) console.log( page.getAttr('title'), page.hasExercise(), page.hasTimingExercises() );
                    // console.log(">>>",page.hasTimingExercises());
                    if (page.hasTimingExercises()) {
                        _.each(page.hasTimingExercises(), function(item) {
                            if (item && item.getAttr('finalTestItem')) exercises.push(item);
                        });
                    }
                });
            });
            // console.log(exercises);
            return exercises;
        };

        model.correctExercises = function () {
            var correct;
            if (this.moduleExercises().length) {
                correct = _.filter(this.moduleExercises(), function (exercise) {
                    return exercise.isCorrect();
                });
            }
            // console.log(correct);
            return correct;
        };
        
        model.isAtLeastOneExerciseConfirmed = function () {
            var confirmed;
            if (this.moduleExercises().length) {
                confirmed = _.find(this.moduleExercises(), function (exercise) {
                    return exercise && exercise.isConfirmed();
                });
            }
            // console.log(confirmed);
            return confirmed;
        };

        model.isViewed = function() {
            var _return = true;
            _.each(model.lessons().all(), function(l) {
                _.each(l.pages().all(), function(p) {
                    if(!p.isViewed()) {
                        _return = false;
                        return false;
                    }
                });
            });
            return _return;
        };

        /**
         * @description set visibility after x seconds
         * @param seconds
         */
        model.setVisibilityAfter = function(seconds) {
          $timeout(function() { model.setVisibility() }, seconds*1000);
        };

        /**
         * @description set visibility on
         */
        model.setVisibility = function() {
            _is_visible = true;
        };

        /**
         * @description check if module is visible
         * @return {boolean}
         */
        model.isVisible = function() {
            return _is_visible;
        };

        /**
         * @description get score lesson
         * @return {number}
         */
        model.score = () => {
            let score = 0;
            model.lessons().forEach(lesson => score += lesson.score());
            return score;
        };

        /**
         * @description get max score lesson
         * @return {number}
         */
        model.maxScore = () => {
            let score = 0;
            model.lessons().forEach(lesson => score += lesson.maxScore());
            return score;
        };

        model.isFinalTest = () => {
            return model.getAttr('finaltest');
        };

        model.isFinalTestAttempted = () => {
            var confEx = _.find(model.improvedModuleExercises(), function(exercise) {
                return exercise.isConfirmed();
            });
            // console.log(confEx);
            return !! confEx;
        };

        model.finalTestPercentage = () => {
            var countResults = _.countBy(model.testExercises(), function(exercise) {
                return exercise.isCorrect() && exercise.getAttr('finalTestItem') ? 'correct': 'wrong';
            });
            // console.log(countResults);
            var percentage = ((countResults.correct || 0) * 100) / model.testExercises().length;
            return Math.round(percentage);
        };

        return model;
    }

    var service = {
        create: function (attrs) {
            return new Module(attrs);
        },
        collection: function (array) {
            if (!all.length) {
                var tmp = [];
                _.each(array, function (item) {
                    tmp.push(new Module(item));
                });
                all = Model.collection(tmp);
            }
            return all;
        }
    };

    return service;
}]);

(function () {

    'use strict';

    var PageFactory = function (Model, Video, Subtitles, Event, Exercise, Test, Sound, Timing, Html) {
        var all = [];

        // creo il gestore di eventi
        var eventer = Event.create('page');

        function Page(attrs) {

            var subtitles = false;
            var video = false;
            var test = false;
            var audio = false;
            var exercises = [];

            var viewed = false;

            var model = Model.create({
                attrs: attrs,
                name: 'page'
            });

            model.video = function () {
                if (video === false) {
                    var setup = model.getAttr('video');
                    if (setup) {
                        video = Video.create(setup);
                    }
                    else
                        video = null;
                }
                return video;
            };

            model.disposeVideo = function () {
                model.video().dispose();
                video = false;
                return model;
            };

            model.audio = function () {
                if (!audio) {
                    if (model.getAttr('audio')) {
                        audio = Sound.create(model.getAttr('audio'));
                    }
                }
                return audio;
            };

            /**
             * Check if page has audio and is playing
             * @return {Boolean}
             */
            model.hasAudioAndIsPlaying = function () {
                if (model.audio()) {
                    if (model.audio().isPaused()) {
                        return false;
                    }
                    return true;
                }
            };

            model.subtitles = function () {
                if (!subtitles) {
                    subtitles = Subtitles.create({text: model.getAttr('subtitles')});
                }
                return subtitles;
            };

            /**
             * @description update video in page
             * @return Video|void
             */
            model.updateVideo = function () {
                if (!model.video()) return;

                model.video().pause();
                model.video().updateSrc(model.getAttr('video').src);
                model.video().updateSubs();
                model.video().play();
                return model.video();
            };

            model.hasExercises = function () {
                return model.getAttr('exercises') || (model.html() && model.html().getAttr('Exercise'));
            }

            model.exercises = function () {
                var jsonExercises = model.getAttr('exercises') ? model.getAttr('exercises') : model.html().getAttr('Exercise');

                if (!exercises.length) {
                    _.each(jsonExercises, function (e) {
                        exercises.push(Exercise.find(e));
                    });
                }
                return exercises;
            };

            model.passed = function () {
                if (!model.exercises()) return true;

                var minScore = model.getAttr('minScore') ? model.getAttr('minScore') : exercises.length;
                var corrects = 0;

                _.each(exercises, function (e) {
                    if (e.isCorrect()) {
                        corrects++;
                    }
                });


                return corrects >= minScore;
            }

            model.viewed = function () {
                // console.trace();
                viewed = true;
                eventer.emit('viewed', {model: model});
                return model;
            };

            model.setViewed = function (value) {
                viewed = value;
                return model;
            };

            model.isViewed = function () {
                return viewed;
            };

            /**
             * Get Test model chained with the page
             * @return {Test}
             */
            model.test = function () {
                if (!test) {
                    if (model.getAttr('Test'))
                        test = Test.create(model.getAttr('Test'));
                }
                return test;
            };

            model.htmlSource = function () {
                if (model.html())
                    return 'html/' + model.html().getAttr('src') + '.html';
                return false;
            };

            // /**
            //  * @description get duration page
            //  * @return seconds
            //  */
            // model.duration = () => {
            //     return model.video() ? model.video().duration() : 0;
            // };

            /**
             * @description check if page has exercise
             */
            model.hasExercise = function() {
                if(!model.getAttr('video')) return false;
                let videoTimings = model.getAttr('video').timing;
                if(!videoTimings) return false;

                let timingOptions = videoTimings[videoTimings.length-1];
                let lasttimingpage = model.getAttr('video') ? Timing.create(timingOptions) : false;
                if (lasttimingpage) {
                    let html = lasttimingpage.getModule('Html')[0];
                    if(html && html.getAttr('Exercise')) {
                        return html.exercises().get(0);
                    }
                }
                return false;
            };

            /**
             * @description check if page has exercise
             */
            model.hasTimingExercises = ()=>{
                let exercises = [];

                if (model.getAttr('video')) {
                    let videoTimings = model.getAttr('video').timing;

                    if (videoTimings){

                        videoTimings.forEach(videoTiming => {
                            let timingpage = model.getAttr('video') ? Timing.create(videoTiming) : false;
                            if (timingpage) {
                                let html = timingpage.getModule('Html')[0];
                                if(html && html.getAttr('Exercise')) {
                                    html.getAttr('Exercise').forEach(Ex => {
                                        exercises.push(Exercise.find(Ex));
                                    });
                                }
                            }
                        });
                    }
                }
                // console.log("111", exercises);
                if (!exercises.length && model.hasExercises()) {                   
                    var jsonExercises = model.getAttr('exercises') ? model.getAttr('exercises') : model.html().getAttr('Exercise');
                    
                    if (!exercises.length) {
                        _.each(jsonExercises, function (e) {
                            exercises.push(Exercise.find(e));
                        });
                    }
                }
                // console.log(exercises);
                return (exercises.length) ? exercises : false;

                // let timingOptions = videoTimings[videoTimings.length-1];
                // let lasttimingpage = model.getAttr('video') ? Timing.create(timingOptions) : false;
                // if(lasttimingpage) {
                //     let html = lasttimingpage.getModule('Html')[0];
                //     if(html && html.getAttr('Exercise')) {
                //         return html.exercises().get(0);
                //     }
                // }
                // return false;
            };

            /**
             * @description get score page
             * @return {integer}
             */
            model.score = function() {
                let scorePage = model.isViewed() && model.getAttr('score') ? model.getAttr('score') : 0;
                let ex = model.hasExercise();

                let exs = model.hasTimingExercises();
                if (exs) {
                    exs.forEach(ex => {
                        // if (ex.getAttr('label').includes('exercises.m4_')) {
                        //     console.log(ex.getAttr('label'), ex.score());
                        // }
                        if(ex.getAttr('score')) {
                            scorePage = ex.score() + scorePage;
                        }
                    });
                }
                return scorePage;
            };

            /**
             * @description get score page
             * @return {integer}
             */
            model.maxScore = function() {
                let scorePage = model.getAttr('score') ? model.getAttr('score') : 0;
                let ex = model.hasExercise();

                let exs = model.hasTimingExercises();
                if (exs) {
                    exs.forEach(ex => {
                        if(ex.getAttr('score')) {
                            scorePage = ex.getAttr('score') + scorePage;
                        }
                    });
                }
                return scorePage;
            };

            // many relation with doits
            model.many('Doit');
            model.one('Html');

            return model;
        };

        var service = {
            create: function (attrs) {
                return new Page(attrs);
            },
            collection: function (array) {
                if (!all.length) {
                    var tmp = [];
                    _.each(array, function (item) {
                        tmp.push(new Page(item));
                    });
                    all = Model.collection(tmp);
                }
                return all;
            },
            events: eventer,
            next: function () {
                this.events.emit('change.pre');
                this.events.emit('next');
                return false;
            },
            prev: function () {
                this.events.emit('change.pre');
                this.events.emit('prev');
                return false;
            }
        };

        return service;
    };


    PageFactory.$inject = ['Model', 'Video', 'Subtitles', 'Event', 'Exercise', 'Test', 'Sound', 'Timing', 'Html'];

    angular.module('Application')
        .factory('Page', PageFactory)
        .run(['App', 'Page', 'Subtitles', 'MenuButton', '$rootScope', '$timeout', function (App, Page, Subtitles, MenuButton, $rootScope, $timeout) {
            App.events.on('module.open', function() {
                // when pages load, i set page viewed if
                // navigation is not restricted
                if (App.config().isFree() && App.module()) {
                    App.module().lesson().page().viewed();
                }
            });

            /*
             *   Ogniqualvolta viene cambiata la pagina
             */
            Page.events.on('change', function() {

                // if the page has not subtitles
                // i'll close the panel
                if (!App.module().lesson().page().getAttr('subtitles'))
                    Subtitles.panel.close();

                // chiudo l'ultimo pulsante aperto
                // definito nel caso in cui venga premuto
                // un pulsante di "Vai alla pagina", chiude
                // il popup dell'indice
                if (MenuButton.lastOpened())
                    MenuButton.lastOpened().close();

                // se the page viewed if navigation is not restricted
                if (App.config().isFree()) {
                    App.module().lesson().page().viewed();
                }

                // aggiorno il src del video con quello della
                // pagina effettiva, NECESSARIO perchè il componente
                // Videojs NON gestisce il double-binding
                if (App.module().lesson().page().video()) {
                    let video = App.module().lesson().page().updateVideo();

                    if (!App.panels.resume.isOpened()) {
                        video.play();
                    }
                    else {
                        video.pause();
                    }
                }
                else
                    App.exitFullscreen();

                if (App.module().lesson().page().audio()) {
                    App.module().lesson().page().audio().play();
                }

            });

            App.events.on('menu.change', function() {
                if (App.module().lesson().page().video())
                    App.module().lesson().page().updateVideo();
                    Page.events.emit('change');
            });
            
        }]);

})();


app.factory('Panel', ['Event', '$timeout', function (Event, $timeout) {

    function Panel(_event) {
        
        var events = Event.create(_event+'.panel');
        
        this.attrs = {
            opened: false,
            reduce: false
        };
        
        this.open = function(){
            // console.log("panel.open", this,_event,events);
            this.attrs.opened = true;
            events.emit('open');
            return this;
        };
        
        this.close = function(){
            // console.log("panel.close");
            this.attrs.opened = false;
            events.emit('close');
            return this;
        };
        
        this.isOpened = function(){
            return this.attrs.opened;
        };
        
        this.reduce = function(){
            this.attrs.reduce = true;
            events.emit('reduce');
            return this;
        };
        
        this.expand = function(){
            this.attrs.reduce = false;
            events.emit('expand');
            return this;
        };
        
        this.isReduced = function(){
            return this.attrs.reduce;
        };
        
        this.isClosed = function(){
            return !this.isOpened();
        };

        this.toggle = function(){
            // console.log("toggle");
            if(this.isOpened())
                this.close();
            else 
                this.open();
            events.emit('toggle');
            return this;
        };
        
        this.on = function(event, _function, time){
            events.on(event, _function, time);
        };
        
        return this;
    };

    return {
        create: function (_event) {
            return new Panel(_event);
        }
    }
}]);

(function(){

	'use strict';

	var RepeatFactory = function($http, Model, Overlay, MenuButton){

		var all = [];

		$http.get('config/repeats.json').then(function(response){
			_.each(response.data.items, function(item)
            {
               all.push(new Repeat(item)); 
            });
		});

		function Repeat(attrs) {
			var model = Model.create({
	            attrs: attrs,
	            name: 'repeat'
	        });

			model.filepath = function(){
				return model.getAttr('file') + '.' + model.getAttr('type');
			};

			model.open = function() {
				MenuButton.find('repeat').open();
				Overlay.open('repeat', model) ;
			};

	        return model;
		};


		var service = {
			create: function(attrs){
				return new Term(attrs);
			},
			get: function(index){
				if(all[index])
					return all[index];

				return false;
			},
			all: function(){
				return all;
			}
		};

		return service;
	};


	RepeatFactory.$inject = ['$http','Model', 'Overlay', 'MenuButton'];

	angular.module('Application')
		.factory('Repeat', RepeatFactory);

})();

(function(){

	'use strict';

	var SoundService = function(){

		function Sound(attrs) {

			var model = new buzz.sound('audio/'+attrs.src, {
				formats: ['mp3']
			});

      model.repeat = function() {
          model.stop();
        model.play();
        return model;
      };

			model.duration = function() {
				return model.getDuration();
			};

			return model;

		};

		var service = {
			create: function(attrs) {
				return new Sound(attrs);
			}
		};


		return service;
	};

	SoundService.$inject = [];

	angular.module('Application')
		.factory('Sound', SoundService);

})();

(function(){

    'use strict';

    var SubtitleFactory = function(Panel, Model)
    {
        var panel = Panel.create('subtitles');
    
        function Subtitles(attrs) 
        {            
            var model = Model.create({
                attrs: attrs,
                name: 'subtitle'
            });
            
            model.text = function(){
                return model.getAttr('text');
            };
                
            return model;
        };
      
        var service = {
            create: function(attrs){
                return new Subtitles(attrs);
            },
            panel: panel 
        };
        
        return service;
    };

    SubtitleFactory.$inject = ['Panel', 'Model'];


    angular.module('Application')
        .factory('Subtitles', SubtitleFactory);

})();

(function() {

	'use strict';

	var TestFactory = function(Model, Exercise, Collection, Panel, Event)
	{

		var eventer = Event.create('test');

		function Test(attrs) 
		{
			var _exercises = Collection.create([]);
			var _incorrectExercises = Collection.create([]);
			var ended = false;
			var audio = false;

		 	var model = Model.create({
		        attrs: attrs,
		        name: 'test'
		    });

		    var _panels = {
		    	intro: Panel.create('Test.intro'),
		    	report: Panel.create('test.report')
		    };

		 	/**
		 	 * Get Exercise collection
		 	 * @return {Collection}
		 	 */	
		 	model.exercises = function() {
		 		if(!_exercises.isEmpty())
		 		{	
		 			var limit = model.getAttr('limit');

	 				_.each(model.getAttr('exercises'), function(value, key)
	 				{
	 					_exercises.add(Exercise.all()[value]);
	 				});

	 				if(model.getAttr('random'))
	 					_exercises.shuffle();

	 				if(limit)
	 					_exercises.limit(limit);	 					
		 		}
		 		return _exercises;
		 	};

		 	/**
		 	 * Get Exercise collection of incorrect exercise
		 	 * @return {Collection}
		 	 */
		 	model.incorrectExercises = function() {
		 		var array = false;
				
				array = model.exercises().filter(function(item){
	 				return !item.isCorrect();
	 			}); 
		 		
		 		return array;
		 	};

		 	/**
		 	 * Set test ended state
		 	 * @return {model}
		 	 */
		 	model.end = function(){
		 		ended = true;
		 		eventer.emit('ended', {test: model});
		 		return model;
		 	};

		 	/**
		 	 * Is Test ended?
		 	 * @return {boolean}
		 	 */
		 	model.ended = function() {
		 		return ended;
		 	};

		 	/**
		 	 * Check if test is passed
		 	 * @return {Boolean}
		 	 */
		 	model.isPassed = function() 
		 	{
		 		return model.score() >= model.getMinScoreToPass();
		 	};

		 	/**
		 	 * Get score of test
		 	 * @return {int}
		 	 */
		 	model.score = function()
		 	{
		 		var score = 0;
		 		_.each(model.exercises().all(), function(e)
		 		{
		 			try {
		 				if(e.isCorrect()) 
		 				score++;
		 			}
		 			catch(e) {}
		 		});

		 		return score;
		 	};

		 	/**
		 	 * Get score in percentage
		 	 * @return {int} 
		 	 */
		 	model.getPercScore = function()
		 	{
		 		return model.score() * 10;
		 	};

		 	/**
		 	 * Count number of correct or incorrect answers
		 	 * @param  {string} type
		 	 * @return {int}
		 	 */
		 	model.countAnswers = function(type)
		 	{
		 		var count = 0;
		 		_.each(model.exercises().all(), function(e) 
		 		{
		 			if(type == 'correct' && e.isCorrect())
		 				count++;

		 			if(type == 'incorrect' && !e.isCorrect())
		 				count++;
		 		});

		 		return count;
		 	};

		 	/**
		 	 * Repeat Test
		 	 * @return {Model}
		 	 */
		 	model.repeat = function(){
		 		_.each(model.exercises().all(), function(e){ e.reset(); });
		 		ended = false;
		 		model.exercises().setCurrent(0);
		 		return model;
		 	};

		 	/**
		 	 * Repeat test getting only incorrect exercises
		 	 * @return {Model}
		 	 */
		 	model.repeatOnlyIncorrect = function() {
		 		var firstIncorrectExIndex = null;

		 		_.each(model.exercises().all(), function(e, key){ 
		 			if(!e.isCorrect())
		 			{
		 				e.reset();

		 				if(firstIncorrectExIndex === null)
		 					firstIncorrectExIndex = key;

		 			}
		 		});

		 		ended = false;
		 		model.exercises().setCurrent(firstIncorrectExIndex);
		 	};

		 	model.getMinScoreToPass = function(){
		 		return (model.exercises().count()*model.getAttr('masteryScore'))/10;
		 	};

		 	model.panels = function(){
		 		return _panels;
		 	};

		 	model.audio = function() {
		 		if(!audio && model.getAttr('audio'))
		 		{
		 			audio = new buzz.sound('audio/'+model.getAttr('audio').src, {
					    formats: ["mp3"]
					});
		 		}
		 		return audio;
		 	};

		 	/**
		 	 * Track score 
		 	 * @return {Boolean}
		 	 */
		 	model.isTrackingScore = function()
		 	{
		 		return model.getAttr('track') == 'score';
		 	};

		 	/**
		 	 * Get mastery score in percentage
		 	 * @return {int}
		 	 */
		 	model.getPercMasteryScore = function()
		 	{
		 		return model.getAttr('masteryScore') * 10;
		 	};

		 	/**
		 	 * Get html layout
		 	 * @return {string}
		 	 */
		 	model.layout = function(){
		 		var layout = model.getAttr('layout');
		 		return layout ? layout : 'test.html';
		 	};

		 	model.panels().intro.on('close', function()
		 	{
		 		if(model.audio())
		 			model.audio().pause();
		 	});

		    return model;
		};


		return {
			create: function(attrs){
				return new Test(attrs);
			},
			events: eventer
		};
	};

	TestFactory.$inject = ['Model','Exercise', 'Collection', 'Panel', 'Event'];

	angular.module('Application')
		.factory('Test', TestFactory);

})();

(function(){

    'use strict';

    var TimingFactory = function($rootScope, $timeout, $injector, Model, Event)
    {
        var all = [];
        var eventer = Event.create('timing');

        function Timing(attrs) {

            var _opened = false;
            var audio = false;
            var objects = [];
            var modules = [];

            var model = Model.create({
                attrs: attrs,
                name: 'timing'
            });

            model.canLaunch = function(time){
                if(!model.opened())
                {
                    if(time == 'ended')
                        return model.getAttr('seconds') == 'ended';
                    else
                        return model.getAttr('seconds') == parseInt(time);
                }
                return false;
            };

            model.opened = function(){
                return _opened;
            };

            model.hasModule = function(modelname) {
                return model.getModule(modelname).length ? true : false;
            };

            model.hasModuleExcept = function(modelname){
                var _return = false;

                _.each(model.getAttrs(), function(value, key){
                    if(key != 'seconds' && key != 'restricted' && key != modelname)
                    {
                        _return = true;
                        return;
                    }
                });

                return _return;
            };

            /**
             * Close Timing object
             * @return {this}
             */
            model.close = function(){
                if(model.opened())
                {
                    _opened = false;
                    objects = [];
                    modules = [];
                    eventer.emit('close');
                }
                return model;
            };

            /**
             * Check when timing has to be closed
             * @param  {Video}  video
             * @return {Boolean}
             */
            model.hasToClose = function(video){
                if(model.isRestricted())
                    return false;

                var timeWhenClose = parseInt(model.getAttr('seconds')) + model.getTimeoutVisible();
                return video.currentTime() > timeWhenClose || video.currentTime() < parseInt(model.getAttr('seconds'));
            };

            /**
             * Open Timing object
             * if model is not mandatory to continue video playing
             * i'll make it visible for n seconds
             * @return {this}
             */
            model.open = function(){
                _opened = true;

                eventer.emit('open');

                return model;
            }

            /**
             * If is set a timeout specific, i'll use it
             * otherwise i show timming for 5 seconds
             * @return {Number}
             */
            model.getTimeoutVisible = function(){
                var timeout = model.getAttr('timeout');
                return timeout ? timeout : 5;
            };

            /**
             * Get the Repeat object
             * @return {Repeat}
             */
            model.repeat = function(){
                return Repeat.get(model.getAttr('Repeat'));
            };

            model.repeats = function(){
                if(!repeats.length)
                {
                    _.each(model.getAttr('Repeat'), function(key){
                        repeats.push(Repeat.get(key));
                    });
                }
                return repeats;
            };

            /**
             * Get a module chained with Timing
             * @param  {string} modelname name of a injector
             * @return {Array}
             */
            model.getModule = function(modelname){
                var _module = modelname.toLowerCase()+'s';
                if(angular.isUndefined(modules[_module]))
                {
                    modules[_module] = [];
                    var injector = $injector.get(modelname);

                    _.each(model.getAttr(modelname), function(key){
                        modules[_module].push(injector.get(key));
                    });
                }
                return modules[_module];
            };

            /**
             * Check if Timing is mandatory
             * @return {Boolean}
             */
            model.isRestricted = function(){
                return model.getAttr('restricted') == true;
            };

            /**
             * Get all objects chained with timing
             * @return {Array}
             */
            model.objects = function(){
                if(!objects.length)
                {
                    _.each(model.getAttrs(), function(value, key)
                    {
                        if(
                            key != 'restricted' &&
                            key != 'obligatory' && 
                            key != 'seconds'
                        )
                            objects = objects.concat(model.getModule(key));
                    });
                    objects = _.compact(objects);
                }
                return objects;
            };

            model.details = function () {
                return _.filter(model.objects(), function (object) {
                    return object.__is('detailed')
                });
            }

            model.mandatoryChilds = function () {
                return _.filter(model.objects(), function (object) {
                    return object.getAttr('mandatory');
                })
            }

            model.hasMandatoryChild = function () {
                return !! model.mandatoryChilds().length;
            }

            model.hasViewedAllMandatoryChilds = function () {
                return ! (!!_.find(model.mandatoryChilds(), function (object) {
                    // if (typeof object.viewed !== 'undefined')
                        return ! object.viewed()
                    // if (typeof object.isBlocked !== 'undefined')
                    //     return object.isBlocked()
                }));
            }

            model.hasObligatoryChild = function () {
                return !! model.getAttr('obligatory');
            };

            model.audio = function () {
                if (!audio) {
                    if (model.getAttr('audio')) {
                        audio = Sound.create(model.getAttr('audio'));
                    }
                }
                return audio;
            };

            /**
             * Check if page has audio and is playing
             * @return {Boolean}
             */
            model.hasAudioAndIsPlaying = function () {
                if (model.audio()) {
                    if (model.audio().isPaused()) {
                        return false;
                    }
                    return true;
                }
            };

            return model;
        };

        var service = {
            create: function (attrs) {
                return new Timing(attrs);
            },
            events: eventer
        };

        return service;

    };

    TimingFactory.$inject = ['$rootScope', '$timeout', '$injector', 'Model', 'Event'];

    angular.module('Application')
        .factory('Timing', TimingFactory);

})();

(function() {

    'use strict';

    var VideoService = function($rootScope, $timeout, $interval, $translate, Helper, Panel, Timing, Event, $compile, $filter) {

        var baseName = 'video';
        var eventer = Event.create(baseName);
        var _videoInterval = false;
        var _videoJsInstantiated = false;
        var player = false;
                  var subs = false;
        var _isSrtVisible = false;

        function VideoAdvancedPanelInner() {
            var _this = Panel.create('video.advanced.inner');
            var _type = false;
            var _element = false;

            _this.openAndSet = function(type, el) {
                _type = type;
                _element = el;
                _this.open();
            };

            _this.getElement = function() {
                return _element;
            };

            _this.isTypeOpened = function(type) {
                return _type == type;
            }

            return _this;
        };

        function VideoAdvancedPanel() {
            var _this = Panel.create('video.advanced');
            _this.inner = new VideoAdvancedPanelInner();

            return _this;
        };

        function Video(attrs, setup) {

            var video = {};

            // Panel of advanced features during video playing
            video.advanced = new VideoAdvancedPanel;

            video.attrs = attrs;

            var _timing = false;
            var _timingsArray = [];

            video.replay = function() {
                video.pause();
                video.player().currentTime(0);
                video.play();

                return video;
            };

            video.ended = function() {
                return video.player().ended();
            };

            video.play = function() {
                return video.player().play();
            };

            video.pause = function() {
                return video.player().pause();
            };

            video.paused = function() {
                return video.player().paused();
            };
            video.showSubs = function () {
                subs.subsShow(true);
                _isSrtVisible = true;
                return subs;
            };

            video.hideSubs = function () {
                subs.subsShow(false);
                _isSrtVisible = false;
                return subs;
            };

            video.isSrtVisible = function () {
                return subs.isSrtVisible();
            };

            video.zoomSubtitles = function (value) {
                /* value can be +1 or -1 */
                var currentFontSize =
                    new Number(
                        $("#videojs_html5_api_subs").css("font-size") &&
                        $("#videojs_html5_api_subs").css("font-size").replace("px", "")
                    ) || 20;
                localStorage.setItem("subsFontSize", currentFontSize + value);
                $("#videojs_html5_api_subs").css(
                    "font-size",
                    currentFontSize + value + "px"
                );
            };

            video.toggleSubs = function () {
                if (localStorage.getItem("subsFontSize")) {
                    /*$timeout(function(){
                        $("#videojs_html5_api_subs").css('font-size', localStorage.getItem('subsFontSize') + 'px');
                    },0)*/
                }

                if (!video.isSubtitled()) return;
                subs.subsToggle();
                return subs;
            };

            video.subtitles = function () {
                if (!subs) {
                    service.loadSubs(attrs);
                    if (!video.isSubtitled()) video.hideSubs();

                    // if (!video.isSubtitled()) console.log("test");
                }
                return subs;
            };

            video.updateSubs = function () {
                // video.hideSubs();
                service.loadSubs(attrs);
                if (!video.isSubtitled() || !video.isSrtVisible()) {
                    video.hideSubs();
                }
                return subs;
            };

            video.isSubtitled = function () {
                // return true;
                return video.getAttr("srt");
            };

            video.dispose = function() {
                if (player)
                    video.pause();
                if (service.isLoadedVideoJs())
                    service.disposeVideoJs();
                _videoJsInstantiated = false;
                player = false;
            }

            video.src = function(params) {
                video.player().src(params).load();
                return player;
            };

            video.requestFullscreen = function() {
                eventer.emit('fullscreen');
                return video.player().requestFullscreen();
            };

            video.exitFullscreen = function() {
                eventer.emit('fullscreenOut');
                return video.player().isFullscreen() && video.player().exitFullscreen();
            };

            video.isFullscreen = function() {
                return (screen.availHeight || screen.height - 30) <= window.innerHeight;
            };

            video.currentTime = function() {
                return video.player().currentTime();
            };

            video.duration = function() {
                return video.player().duration();
            };

            video.player = function() {
                if (!player) {
                    player = service.loadVideoJs(setup);
                }
                return player;
            };

            video.updateSrc = function(src) {
                var srcVideo = $translate.use() + '/' + $filter('translate')(src);
                video.src({
                    type: 'video/mp4',
                    src: 'video/' + srcVideo + '.mp4'
                });
                video.stopInterval();
                video.closeAllTimings();
                return video;
            };

            video.backward = function() {
                var time = video.player().currentTime();
                video.player().currentTime(time - 15);
                return video;
            };

            video.forward = function() {
                var time = video.player().currentTime();
                video.player().currentTime(time + 15);
                return video;
            };

            video.durationString = function() {
                return Helper.toMMSS(video.duration());
            };

            video.currentTimeString = function() {
                return Helper.toMMSS(video.currentTime());
            };

            video.getAttr = function(attr) {
                var value = video.attrs[attr];
                if (attr == 'src') value = 'video/' + $filter('translate')(value) + '.mp4';
                return value;
            };

            video.toggle = function() {
                if (video.paused())
                    video.play()
                else
                    video.pause();
                return video;
            };

            video.currentTiming = function() {
                return _timing;
            }

            video.setTiming = function(newTiming) {
                _timing = newTiming;
                return video;
            }

            video.timings = function() {
                if (!_timingsArray.length) {
                    _.each(video.getAttr('timing'), function(item) {
                        _timingsArray.push(Timing.create(item));
                    });
                }
                return _timingsArray;
            }

            /**
             * @description get last timing
             * @return object
             */
            video.lastTiming = function() {
                if(!video.getAttr('timing')) return false;
                return video.timings()[video.getAttr('timing').length-1];
            };

            video.hasRestrictedTimings = function() {
                return !! _.find(video.timings(), function(timing) {
                    return timing.getAttr('restricted') == true;
                });
            }

            video.mandatoryTimings = function () {
                return _.filter(video.timings(), function (timing) {
                    return timing.hasMandatoryChild();
                })
            }

            video.hasMandatoryTiming = function () {
                return !! video.mandatoryTimings().length;
            }

            video.hasViewedAllMandatoryTimingsChilds = function () {
                return ! (!! _.find(video.mandatoryTimings(), function (timing) {
                    return ! timing.hasViewedAllMandatoryChilds();
                }))
            }

            video.obligatoryTimings = function () {
                return _.filter(video.timings(), function (timing) {
                    return timing.hasObligatoryChild();
                });
            }

            video.hasObligatoryTiming = function () {
                return !! video.obligatoryTimings().length;
            }

            video.loopTimings = function() {
                if (!video.timings())
                    return false;

                // check if current timing has to be closed
                // and when
                if (video.currentTiming() && video.currentTiming().hasToClose(video)) {
                    video.currentTiming().close();
                }

                // loop timings to view if one has to be launched
                _.each(video.timings(), function(item) {
                    var time = video.ended() ? 'ended' : video.currentTime();
                    if (item.canLaunch(time)) {
                        if (video.currentTiming() != item) {
                            video.setTiming(item)
                                .currentTiming()
                                .open(video.currentTime());
                        }
                    }
                });
            };

            video.closeAllTimings = function() {
                _.each(video.timings(), function(timing) {
                    timing.close();
                });

                video.advanced.close();
            };

            /**
             * Start to check if objects have to appear in video
             * @return {void}
             */
            video.startInterval = function() {

                video.stopInterval();

                _videoInterval = $interval(function() {
                    video.loopTimings();

                }, 1000);
            };

            /**
             * Remove the check to the video for Timing objects
             * @return {boolean}
             */
            video.stopInterval = function() {
                return $interval.cancel(_videoInterval);
            };

            video.updateSrc(attrs.src);

            video.advanced.inner.on('open', function() {
                video.pause();
            });

            // video.advanced.on('close', function() {
            //     if (!video.ended()) video.play();
            // });

            Timing.events.on('close', function() {

                if (video.advanced.isOpened())
                    video.advanced.close();

                video.setTiming(false);
            });

            Timing.events.on('open', function() {
                video.exitFullscreen();
                video.advanced.open();
            });
              video.updateSrc(attrs.src);
            video.subtitles();

            return video;
        };

        var service = {
            create: function(attrs, setup) {

                if (this.isLoadedVideoJs())
                    return new Video(attrs, setup);

                return false;
            },
            on: function(event, _function) {
                return $rootScope.$on(baseName + '.' + event, function() {
                    _function.call(this);
                });
            },
            events: eventer,
            disposeVideoJs: function() {
                if (!angular.element('#videojs').length) {
                    return;
                }

                _videoJsInstantiated = false;
                videojs('videojs')
                    .pause()
                    .off('ended')
                    .off('timeupdate')
                    .off('play')
                    .off('pause')
                    .dispose();
            },
            loadVideoJs: function(setup) {

                if (!angular.element('#videojs').length) {
                    return;
                }

                var baseSetup = {
                    width: '100%',
                    height: '100%',
                    controls: false,
                    type: 'video/mp4',
                };

                var setup = angular.extend(baseSetup, setup);
                player = videojs('videojs', setup);

                player.ready(function() {
                    this.off('ended').on('ended', function() {
                        eventer.emit('ended');
                        eventer.emit('ended.timings');
                    });

                    this.off('play').on('play', function() {
                        eventer.emit('play');
                    });

                    this.off('pause').on('pause', function() {
                        eventer.emit('pause');
                    });

                    this.on('timeupdate', function() {
                        eventer.emit('timeupdate', {
                            video: video
                        });

                        $timeout(function() {
                            $rootScope.$apply();
                        });
                    });
                    _videoJsInstantiated = true;
                    eventer.emit('videojs');
                });
                return player;
            },
            isLoadedVideoJs: function() {
                return _videoJsInstantiated;
            },
              loadSubs: function (attrs) {
                if (!angular.element("#videojs").length) {
                    return;
                }
                let src = attrs.src;
                // if (Array.isArray(attrs.src)) {
                //     src = service.getProfileVideoIndex(attrs.src);
                // }
            //    console.log(
            //      "srt/"  + $translate.use() + "/" +
            //        $filter("translate")(src) +
            //        ".srt"
            //    );
                // $timeout(function () {
                subs = new Bubbles.videoJS("videojs_html5_api");
                subs.subtitles(false, {
                    language: {
                        language: "Language",
                        file:  "srt/"  + $translate.use() + "/" +
                        $filter("translate")(src) +
                        ".srt"
                    },
                    Italiano: {
                        language: "Italiano",
                        file:  "srt/"  + $translate.use() + "/" +
                        $filter("translate")(src) +
                        ".srt"
                    },
                });
                // }, 100);
            },
        };

        return service;
    };

    VideoService.$inject = ['$rootScope', '$timeout', '$interval', '$translate', 'Helper', 'Panel', 'Timing', 'Event', '$compile', '$filter'];

    angular.module('Application')
        .service('Video', VideoService)
        .run(['Video', 'App', '$rootScope', 'Timing', 'Page', 'Overlay', function(Video, App, $rootScope, Timing, Page, Overlay) {

            Video.events.on('ended', function() {
                //if (!App.module().lesson().page().video().hasRestrictedTimings()) {   
                if (
                    !App.module().lesson().page().video().hasMandatoryTiming() &&
                    !App.module().lesson().page().video().hasObligatoryTiming())
                    App.module().lesson().page().viewed();
                //}

                if (App.config().getAttr('layout').autoplay) {
                    if (
                        !App.module().lesson().page().video().timings().length && 
                        !App.module().lesson().page().getAttr('preventAutoplay')
                    )
                        Page.next();
                }
            });

            Video.events.on('ended.timings', function() {
                
                if (App.module()) {
                    var video = App.module().lesson().page().video();
                    if (video)
                        video.loopTimings();
                }

                $rootScope.$apply();

                if (App.module() && App.module().lesson().page().audio())
                    App.module().lesson().page().audio().play();
            });

            Video.events.on('pause', function() {
                if (App.module())
                    if (App.module().lesson().page().video())
                        App.module().lesson().page().video().stopInterval();
            });

            Video.events.on('play', function() {
                if (App.module().lesson().page().video())
                    App.module().lesson().page().video().startInterval();

                if (App.module().lesson().page().video() &&
                    App.module().lesson().page().video().currentTiming() &&
                    App.module().lesson().page().video().currentTiming().isRestricted()
                )
                    App.module().lesson().page().video().currentTiming().close();
            });

            Overlay.events.on('close', function () {
                // console.log(App.module());
                if (
                    App.module().lesson().page().video() &&
                    App.module().lesson().page().video().hasMandatoryTiming() &&
                    App.module().lesson().page().video().hasViewedAllMandatoryTimingsChilds()
                ) {
                    App.module().lesson().page().viewed(true);
                }
            });

            Timing.events.on('open', function() {

                if (
                    App.module().lesson().page().video() &&
                    App.module().lesson().page().video().currentTiming() &&
                    App.module().lesson().page().video().currentTiming().isRestricted() && !App.module().lesson().page().video().paused()
                ) {
                    App.module().lesson().page().video().pause();
                }

            });

            App.events.on('module.close', function() {
                _.each(App.pages(), function(p) {
                    if (p.video()) p.disposeVideo();
                });
                Video.disposeVideoJs();
            });

            // App.events.on('module.open', function () {
            //     Video.loadVideoJs();
            // });

            App.events.on('menu.change', function () {
                Video.loadVideoJs();
            });

            Video.events.on('videojs', function() {
                Page.events.emit('change');
            });
        }]);

})();


(function(){

	'use strict';

	var VideoExerciseFactory = function($http, Model, MenuButton, Overlay){

		var all = [];

		$http.get('config/videoexercises.json').then(function(response){
			_.each(response.data.items, function(item)
            {
               all.push(new VideoExercise(item)); 
            });
		});

		function VideoExercise(attrs) {
			var model = Model.create({
	            attrs: attrs,
	            name: 'videoexercise'
	        });

			model.filepath = function(){
				return model.getAttr('file') + '.' + model.getAttr('type');
			};

			model.open = function() {
				MenuButton.find('video-exercises').open();
				Overlay.open('video-exercises', model) ;
			};

	        return model;
		};


		var service = {
			create: function(attrs){
				return new VideoExercise(attrs);
			},
			get: function(index){
				if(all[index])
					return all[index];

				return false;
			},
			all: function(){
				return all;
			}
		};

		return service;
	};


	VideoExerciseFactory.$inject = ['$http','Model', 'MenuButton', 'Overlay'];

	angular.module('Application')
		.factory('VideoExercise', VideoExerciseFactory);

})();



(function () {

    'use strict';

    var FileFactory = function ($http, Model) {

        var all = [];

        function File(attrs) {

            var model = Model.create({
                attrs: attrs,
                name: 'File'
            });

            model.filepath = function() {
                return model.getAttr('path') + '/' + model.getAttr('filename') + '.' + model.getAttr('type');
            };


            return model;
        };


        var service = {
            create: function (attrs) {
                return new File(attrs);
            },
            get: function (index) {
                if (all[index])
                    return all[index];

                return false;
            },
            all: function () {
                return all;
            },
            load: function (_callback) {
                $http.get('config/files.json').then(function (response) {
                    _.each(response.data.items, function (item) {
                        all.push(service.create(item));
                    });
                    return _callback ? _callback.call(this, response) : false;
                });
            }
        };

        return service;
    };

    FileFactory.$inject = ['$http', 'Model'];

    angular.module('Application')
        .factory('File', FileFactory)
        .run(['File', function (File) {
            File.load();
        }]);
 
})();

(function () {

    'use strict';

    var HtmlFactory = function ($http, Model, Exercise) {

        var all = [];

        var promise = $http.get('config/htmls.json');

        promise.then(function (response) {
            _.each(response.data.items, function (item) {
                all.push(service.create(item));
            });
        });

        function Html(attrs) {

            var model = Model.create({
                attrs: attrs,
                name: 'Html'
            });

            /**
             * @description get Exercises collection
             * @return {*}
             */
            model.exercises = ()=>{
                return Exercise.getById(model.getAttr('Exercise'));
            }

            model.source = function () {
                return 'html/' + model.getAttr('src') + '.html';
            };

            model.getBackground = function () {
                var backdrop = model.getAttr('backdrop');

                if (backdrop == false)
                    return '';

                if (backdrop == true)
                    return '';

                if (backdrop) {
                    var style = {
                        'background-repeat': 'no-repeat',
                        'background-size': 'cover',
                        'background-position': 'center center',
                        'background-image': 'url(images/' + backdrop + '.jpg)'
                    };
                    return style;
                }
            };

            return model;
        };


        var service = {
            create: function (attrs) {
                return new Html(attrs);
            },
            get: function (index) {
                if (all[index])
                    return all[index];

                return false;
            },
            all: function () {
                return all;
            },
            promise: function () {
                return promise;
            }
        };

        return service;
    };


    HtmlFactory.$inject = ['$http', 'Model', 'Exercise'];

    angular.module('Application')
        .factory('Html', HtmlFactory);

})();



(()=>{
    'use strict'

    let LessonLocationFactory = ()=>{

        function LessonLocation(app) {
            let model = this;
            let _app = app;

            model.create = function () {
                let string = '';
                _app.modules().forEach(module => {
                    module.lessons().forEach(lesson => {
                        string += lesson.pages().currentIndex() + '//';
                        lesson.pages().forEach(page => {
                            string += page.isViewed() ? '1' : '0';
                        });
                        string += '|';
                    });
                });
                return string;
            };

            model.get = function () {
                return model.create();
            };

            return model;
        };

        return LessonLocation;
    };

    LessonLocationFactory.$inject = [];

    angular.module('Application').factory('LessonLocation', LessonLocationFactory);

})();

(() => {
    'use strict'

    let LessonLocationParserFactory = () => {

        function LessonLocationParser(string, app) {
            let model = this;
            let _string = string;
            let _app = app;

            model.parse = function () {
                if(_string) {
                    let splitted = _string.split('|');
                    let key = 0;
                    let counterLesson = -1;
                    // let counterPage = 0;
                    // var currentBookmark=0;
                    _app.modules().forEach(module => {
                        module.lessons().forEach(lesson => {
                            let pagesSplittedString = splitted[key].split('//');
                            //console.log("TCL: model.parse -> pagesSplittedString", pagesSplittedString)
                            lesson.pages().forEach((page, k) => {
                                if(pagesSplittedString[1][k] === '1') page.setViewed(true);
                            });
                            if(pagesSplittedString[1].indexOf('1') !== -1) {
                                // counterPage = pagesSplittedString[1].indexOf('1');
                                // counterLesson++;
                            }
                            // else{
                            //     return;
                            // }
                            var currentBookmark = Number(pagesSplittedString[0]);
                            // var currentBookmark = Number(pagesSplittedString[0]);
                            //console.log("TCL: model.parse -> currentBookmark", currentBookmark)
                            // var bookmark = (
                            //     pagesSplittedString[1].indexOf('0') > -1
                            //     //  || 
                            //     // (currentBookmark+1) != pagesSplittedString[1].length
                            // ) ? currentBookmark : 0;
                            lesson.pages().setCurrent(currentBookmark);
                            key++;
                        });

                        
                        // console.log("counterPage", counterPage);
                        counterLesson = counterLesson > -1 ? counterLesson : 0;
                        console.log("counterLesson", counterLesson);
                        module.lessons().setCurrent(counterLesson);
                        // module.lessons().current().setCurrentPage(currentBookmark);
                    });
                }

                return model;
            };

            return model;
        };

        return LessonLocationParser;
    };

    LessonLocationParserFactory.$inject = [];

    angular.module('Application').factory('LessonLocationParser', LessonLocationParserFactory);

})();

(() => {
    'use strict'

    let OLDLessonLocationParserFactory = () => {

        function OLDLessonLocationParser(string, app) {
            let model = this;
            let _string = string;
            let _app = app;

            /*** PRIVACY ***/
            // _string = '3//1110000000000000000000|0//00000000000|0//00000000000000|0//0|'; // MOD1 - 1a domanda
            // _string = '9//1111111111000000000000|0//00000000000|0//00000000000000|0//0|'; // MOD1 - Approfondimento
            // _string = '0//1111111111111111111111|0//00000000000|0//00000000000000|0//0|'; // MOD1 - Completato
            // _string = '0//1111111111111111111111|0//11111111111|0//00000000000000|0//0|'; // MOD2 - Completato
            // _string = '0//1111111111111111111111|0//11111111111|0//11111111111111|0//0|'; // MOD3 - Completato
            // _string = '0//1111111111111111111111|0//11111111111|0//11111111111111|0//1|'; // MOD4 - Completato

            model.parse = function () {
                if(_string) {
                    let splitted = _string.split('|');
                    let key = 0;
                    let counterLesson = -1;
                    let counterPage = 0;

                    _app.modules().forEach(module => {
                        module.lessons().forEach(lesson => {
                            let pagesSplittedString = splitted[key].split('//');
                            lesson.pages().forEach((page, k) => {
                                if(pagesSplittedString[1][k] === '1') page.setViewed(true);
                            });
                            if(pagesSplittedString[1].indexOf('1') !== -1) {
                                counterPage = pagesSplittedString[1].indexOf('1');
                                counterLesson++;
                            }
                            var currentBookmark = Number(pagesSplittedString[0]);
                            var bookmark = (
                                pagesSplittedString[1].indexOf('0') > -1
                                //  || 
                                // (currentBookmark+1) != pagesSplittedString[1].length
                            ) ? currentBookmark : 0;
                            // lesson.pages().setCurrent(bookmark);
                            key++;
                        });
                        // console.log("counterLesson", counterLesson);
                        // console.log("counterPage", counterPage);
                        counterLesson = counterLesson > -1 ? counterLesson : 0;
                        module.lessons().setCurrent(counterLesson);
                        module.lessons().current().setCurrentPage(0);
                    });
                }

                return model;
            };

            return model;
        };

        return OLDLessonLocationParser;
    };

    OLDLessonLocationParserFactory.$inject = [];

    angular.module('Application').factory('OLDLessonLocationParser', OLDLessonLocationParserFactory);

})();

(()=>{

    'use strict';

    let SuspendDataFactory = ()=>{

        function SuspendData() {
            let model = this;
            let _modules = null;
            /**
             * @description set modules
             * @param modules
             */
            model.setModules = (modules)=>{
                _modules = modules;
                return model;
            };

            /**
             * @description return string for suspenddata
             * @return {string}
             */
            model.get = ()=>{
                let string = '';
                _modules.forEach((module, modIndex) => {
                    var modString = model.stringifyModule(module);
                    string += (modIndex+1);
                    if (modString) string += '_' + modString;
                    string += '|';
                });
                return string;
            };

            /**
             * @description stringify module
             * @param module
             * @return {string}
             */
            model.stringifyModule = (module)=>{
                let string = ``;

                module.moduleExercises().forEach((exercise, exIndex) => {

                    if (exercise.getAttr('type') == 'multiple') {

                        if (!exercise.isConfirmed() || !exercise.getAttr('choices').length) {
                            string += null + `!` ;
                        } else {
                            var choices = [];
                            exercise.getAttr('choices').forEach(choice => {
                                var choiceIndex = _.indexOf(exercise.getAttr('options'), choice);
                                choices.push(choiceIndex);
                            });

                            string += choices.join(':') + `!`;
                        }

                    }

                    if (exercise.getAttr('type') == 'single') {

                        if (exercise.isConfirmed() && exercise.getAnsweredIndex() >= 0) {
                            string += exercise.getAnsweredIndex() + `!`;
                        } else {
                            string += null + `!`;
                        }
                    
                    }

                });
                
                string = string.slice(0, -1);

                // module.lessons().forEach(lesson => string += model.stringifyLesson(lesson));
                string += '';
                return string;
            };

            /**
             * @description stringify lesson
             * @param lesson
             * @return {string}
             */
            model.stringifyLesson = (lesson)=>{
                let string = ``;
                lesson.pages().forEach(page => string += model.stringifyPage(page));
                string += '';
                return string;
            };

            /**
             * @description stringify page
             * @param page
             * @return {string}
             */
            model.stringifyPage = (page)=>{
                let string = '';
                let pageScore = page.getAttr('score') && page.isViewed() ? 1 : 0;
                let answeredIndex = null;

                // get index answer
                let answeredIndexes = [];
                let answeredIndexesString = null;
                let exs = page.hasTimingExercises();
                
                // if page has id i'll save all
                if(page.getAttr('id')) {
                    string += `${page.getAttr('id')}_${pageScore}`;
                    if(answeredIndexesString !== null) string += `_${answeredIndexesString}`;
                    string += '|';
                }

                return string;
            };

            return model;
        }

        return (SuspendData);

    };

    SuspendDataFactory.$inject = [];

    angular.module('Application')
        .factory('SuspendData', SuspendDataFactory);

})();

(()=>{

    'use strict';

    let SuspendDataParserFactory = ()=> {

        function Parser(string, app, score) {
            let _string = string;
            /*[
                1 => 1,
                2 => [0,0]
            ]*/
            // _string = '1_0|2_0:2!0:1:2!null!1|3|4|';
            // _string = '1_1!0!1!0|2_null!null|3_null!null!null|4_null!null!null!null!null!null!null!null!null!null!null!null!null!null|';
            
            let _app = app;
            let model = this;

            // console.log(score);
            // let _score = 82;//score;
            let _score = score;

            /**
             * @description parse suspend data
             */
            model.parse = ()=>{
                if(!_string) return;
                let temp = _string.split('|');
                let parsedStringModule = [];
                temp.splice(-1, 1);
                temp.forEach((page) => {
                    let array = page.split('_');
                    let pageId = array[0];
                    array.shift();
                    parsedStringModule[pageId] = array;
                });
                // console.log(parsedStringModule);
                _app.modules().forEach((module, modIndex) => {
                    let saved = parsedStringModule[modIndex + 1];
                    if (saved && saved.length > 0) {

                        var exAnswers = saved[0].split('!');
                        module.improvedModuleExercises().forEach((exercise, exIndex) => {

                            if (exercise.getAttr('type') == 'multiple' &&
                                exAnswers[exIndex] !== null &&
                                exAnswers[exIndex] !== 'null' &&
                                exAnswers[exIndex] != -1) 
                            {
                                var answers = exAnswers[exIndex].split(':');
                                answers.forEach(answer => {
                                    var answer = exercise.getAttr('options')[answer];
                                    exercise.getAttr('choices').push(answer);
                                })
                                exercise.setAttr('confirm', true);
                            }

                            if (exercise.getAttr('type') == 'single' && 
                                exAnswers[exIndex] !== null &&
                                exAnswers[exIndex] !== 'null' &&
                                exAnswers[exIndex] != -1)
                            {
                                var answer = exercise.getAttr('answers')[Number(exAnswers[exIndex])];
                                exercise.setAnswer(answer, true);
                                exercise.setAttr('confirm', true);
                            }

                        });

                    }

                    if (_score && _score > 70 && module.getAttr('finaltest')) { // FIXME **********************
                        // console.log("SET MOD SCORE");
                        module.setAttr('passed', true);
                    }

                });
            };

            return model;
        }

        return Parser;
    };

    SuspendDataParserFactory.$inject=[];

    angular.module('Application')
        .factory('SuspendDataParser', SuspendDataParserFactory);

})();



app.service('GameService', ['Tracking', function (Tracking) {

    var _progress = {
        'G_CRUC': {
            score: -1,
            remainingTime: 0,
            saved: false
        },
        'G_MEM': {
            score: -1,
            remainingTime: 0,
            saved: false
        },
        'G_ASSIGN': {
            score: -1,
            remainingTime: 0,
            saved: false
        }
    }

    var getSuspendData = function(){
        var strSuspendData = Tracking.getSuspendData() || "";//T15000|200
        return strSuspendData;
    }



    var str = getSuspendData();
    if (str && (str.length > 0)){
        var arrayScore = str.split("|"); // es. ["G_CRUC:100:200|G_MEM:200:200|G_ASSIGN:300:200"]
        _.each(arrayScore, (scoreEl)=>{
            console.log("score", scoreEl, scoreEl.split(':'));
            // let id = parseInt(scoreEl.split(':')[0]);
            let id = scoreEl.split(':')[0];
            let score = parseInt(scoreEl.split(':')[1]) || -1;
            let extraScore = parseInt(scoreEl.split(':')[2]) ;

            console.log(id, score, extraScore);
            if (score >= 0){ // se score < 0 l'esercitazione non è completata
                _progress[id].score = score;
                _progress[id].extraScore = extraScore;
                _progress[id].saved = true;
            }
        })
    }

    var buildStringSuspendData = function(){
        /*var outputStr = "T" + _progress.remainingTime + "|" + _progress.score;*/
        let keys = Object.keys(_progress);
        let outputStr = "";
        _.each(keys, (key)=>{
            if (outputStr.length){
                outputStr += '|';
            }
            outputStr += key + ':' + _progress[key].score + ':' + _progress[key].extraScore;
        })
        return outputStr;
    }

    var addScore = function(_score, _extraScore, _remainingTime = 0, _gameId){
        if (!_progress[_gameId].saved){ // salvo solo se non ho già tracciato
            _progress[_gameId].score = _score;
            _progress[_gameId].extraScore = _extraScore;
            _progress[_gameId].remainingTime = _remainingTime;
            _progress[_gameId].saved = true;
            Tracking.updateSuspendData(buildStringSuspendData());
        }
    }

    return {
        /*start: function(){
            Tracking.updateSuspendData("T0|0/"); // all'avvio traccio 0ms rimasti, così se l'utente chiude a metà è come se avesse consumato tutto il timer.
        },*/
        addScore: addScore,
        initGameScore: function(_gameId){ // richiamato all'apertura di un game, per tracciare 0 ed evitare che l'utente chiudda e riapra a metà
            _progress[_gameId].score = 0;
            _progress[_gameId].extraScore = 0;
            _progress[_gameId].remainingTime = 0;
        },
        getProgress: function(){
            return _progress;
        },
        getProgressById: function(_idGame){
            return _progress[_idGame];
        },
        getScore: function(){
            let keys = Object.keys(_progress);
            let totalScore = 0;
            _.each(keys, (key)=>{
                totalScore+=_progress[key].score+_progress[key].extraScore;
            })
            return totalScore;
        },
        updateSuspendData: function(){
            Tracking.updateSuspendData(buildStringSuspendData());
        },
        isCompleted: function(){
            return getSuspendData() && (getSuspendData().length > 0);
        }
    };
}]);

(function()
{
  angular.module('Application')
    .run(function()
    {
      // Check if browser is IE
      if(navigator.userAgent.indexOf('MSIE') > -1 || (!(window.ActiveXObject) && "ActiveXObject" in window))
      {
        var doc = document.documentElement;
        doc.setAttribute('data-useragent', 'ie');
      }
    });

})();

app.service('Overlay', ['MenuButton', 'Page', 'Event', function(MenuButton, Page, Event) {

	var objOpened = false;
    var _overlay = false;
    var sectionName = false;

    var eventer = Event.create('overlay');

	var service = {
		events: eventer,
		
		tmpObj: function(obj){
			objOpened = obj;
		},
		getTmpObj: function(){
			return objOpened;
		},
		open: function(name, obj){
        	if(obj) {
        		sectionName = name;
            	this.tmpObj(obj);
			}
			
			_overlay = true;
			
            eventer.emit('open');
		},
		close: function(){
			_overlay = false;
			this.tmpObj(false);

            eventer.emit('close');
		},
		isOpened: function(){
			return _overlay;
		},
		isSectionOpened: function(name){
			return sectionName == name;
		}
	};

	/**
	 * Events
	 */
	MenuButton.events.on('open', function () {
        service.close();
    });

    MenuButton.events.on('close', function () {
        service.close();
    });


	Page.events.on('change', function() {
		service.close();
	});

	return service;

}]);

(function () {

    'use strict';

    let TrackingService = function (App, SuspendData, LessonLocation, SuspendDataParser, LessonLocationParser, $timeout) {

        var lms = $.LMS({
            debug: false,
            pages: false
        });

        var storedString = false;

        let suspend_data = new SuspendData();

        var string = false;

        var service = {
            init: function () {
                string = new LessonLocation(App);
                suspend_data.setModules(App.modules());
                (new LessonLocationParser(lms.getLessonLocation(), App)).parse();
                (new SuspendDataParser(lms.getSuspendData(), App, lms.getScore())).parse();
            },
            string: function () {
                return string.get();
            },
            getLastOpened: function () {
                return string.getLastOpened();
            },
            update: function () {
                // console.log("App.isAtLastPage()", App.isAtLastPage());
                // if (App.isAtLastPage() && false) {
                //     //FIXME (if there's a test at the end)
                //     // var stringaToPass=string.get().split("//")[1];
                //     // var isComplete = stringaToPass.indexOf("0") === -1;
                //     // if (isComplete) 
                //         //this.complete();
                // }
                // else {
                    $timeout(function () {
                        // console.log("%cTracking.update()[lessonLocation]: ", "background-color: black;color: yellowgreen;", string.get());
                        // console.log("%cTracking.update()[suspendData]: ", "background-color: black;color: yellowgreen;", suspend_data.get());
                        if (string)
                            lms.updateStrings({
                                lessonLocation: string.get(),
                                suspendData: suspend_data.get()
                            });

                        // if (App.areAllModulesViewed()) lms.setCompleted();
                    });
                // }
            },
            complete: function () {
                $timeout(function () {
                    lms.setCompleted();
                    if (string)
                        lms.updateStrings({
                            lessonLocation: string.get(),
                            suspendData: suspend_data.get()
                        });
                });
                return this;
            },
            getStudentName:function(){
                return lms.getStudentName()
            },
            stored: function () {
                return storedString;
            },
            logout: function () {
                return lms.exitAu();

            },
            getSuspendData: function(){
                return lms.getSuspendData();
            },
            // save statement on LMS
            save: function (params) {
                lms.updateScore(params.score, params.status);
            },
            lms: function(){
                return lms;
            }
        };

        return service;
    };

    TrackingService.$inject = ['App', 'SuspendData', 'LessonLocation','SuspendDataParser', 'LessonLocationParser', '$timeout'];

    var InteractionModel = function ($timeout, Tracking) {
        var nInteractions = 0;

        // Interaction Object
        function Interaction(attrs) {
            var model = this;
            var attrs = attrs;

            var root = 'cmi.interactions.';

            function convertiSecToTime(tmSecs) {
                var tm = "00:00:00";
                if (tmSecs > 0) {
                    var hrs = Math.floor(tmSecs / 3600);
                    var min = Math.floor((tmSecs % 3600) / 60);
                    var sec = Math.floor(tmSecs % 60);
                    tm = convertiZeri(hrs, min, sec);
                }
                return tm;
            };

            function convertiZeri(h, m, s) {
                var tm;
                tm = (h < 10 ? "0" : "") + h + ":";
                tm += (m < 10 ? "0" : "") + m + ":";
                tm += (s < 10 ? "0" : "") + s;
                //
                return tm;
            }

            model.getAttr = function (attr) {
                return attrs[attr];
            };

            model.getRoot = function () {
                return root + nInteractions + '.';
            };

            model.get = function (attr) {
                return model.getRoot() + attr;
            };

            model.set = function (attr, value) {
                return Tracking.lms().setValue(model.get(attr), value);
            };

            /**
             *    Send data to LMS
             * @return void
             **/
            model.submit = function () {
                //attrs.txt[2] = attrs.txt[2].join('_');

                $timeout(function () {
                    model.set('id', attrs.id);
                    //model.set('objectives.0.id', '');
                    model.set('time', model.getTimeString());
                    model.set('type', 'performance');
                    /** INDICE DELLA Risposta corretta **/
                    model.set('correct_responses.0.pattern', attrs.response.join('_'));
                    //model.set('weighting', '');
                    /** DOMANDA TESTO :: RISPOSTA UTENTE :: PUNTI OTTENUTI **/
                    model.set('student_response', attrs.txt.join('||'));
                    /** CORRECT || WRONG */
                    model.set('result', attrs.result);
                    /** TEMPO nella DOMANDA **/
                    model.set('latency', convertiSecToTime(attrs.latency));

                    Tracking.lms().update();

                    nInteractions++;
                });
                return;
            };

            model.getTimeString = function () {
                var date = new Date();
                return date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
            };

            model.getResponseStatus = function () {
                return model.getAttr('correct') == model.getAttr('response');
            };

            model.getString = function () {
                return model.getAttr('id') + '//' +
                    model.getTimeString() + '//' +
                    'performance' + '//' +
                    attrs.response.join('_') + '//' +
                    attrs.txt.join(' | ') + '//' +
                    attrs.result + '//' +
                    convertiSecToTime(attrs.latency);
            };
        };

        return {
            create: function (attrs) {
                return new Interaction(attrs);
            }
        }

    };

    InteractionModel.$inject = ['$timeout', 'Tracking'];

    angular.module('Application')
        .service('Tracking', TrackingService)
        .factory('Interaction', InteractionModel)
        .run(['$rootScope', '$timeout', 'Html', 'Exercise', 'Tracking', 'App', 'Page', 'Test', 'Video', function ($rootScope, $timeout, Html, Exercise, Tracking, App, Page, Test, Video) {

            App.promise.then(function () {
                Exercise.promise().then(function() {
                    Html.promise().then(()=>{
                        Tracking.init();
                    });
                });
            });

            App.events.on('logout', function () {
                $timeout(function () {
                    Tracking.logout();
                }, 1000);
            });

            Page.events.on('viewed', function () {
                // if (App.config().isFree())
                Tracking.update();
            });

            Page.events.on('change', function () {
                // if (App.config().isFree())
                Tracking.update();
            });

            Page.events.on('prev', function () {
                // if (App.config().isFree())
                Tracking.update();
            });
            
            Page.events.on('next', function () {
                // if (App.config().isFree())
                Tracking.update();
            });

            Video.events.on('ended', function () {
                if (!App.config().isFree())
                    Tracking.update();
            });

            /**
             * Track score if test must be tracked
             */
            Test.events.on('ended', function (e, params) {
                var test = params.test;

                if (test.isTrackingScore()) {
                    Tracking.save({
                        score: test.score() * 10,
                        status: test.isPassed()
                    });
                }
            });
        }]);

})();


(function () {
    'use strict';

    var TranslationService = function (Model, Event, $http, $translate) {
        var all = [];

        var promise = false;

        var eventer = Event.create('translation');

        var TranslationModel = function (attrs) {
            var model = Model.create({
                attrs: attrs,
                name: 'translation'
            });

            model.isDisabled = function () {
                return model.getAttr('disabled');
            };

            model.active = function () {
                eventer.emit('change');
                if (!model.isDisabled()) {
                    $translate.use(model.getAttr('lang'));
                }
            };

            model.isActive = function () {
                return $translate.use() == model.getAttr('lang');
            };

            return model;
        };

        var service = {
            all: function () {
                return all;
            },
            listLang: function () {
                var array = [];
                _.each(all, function (item) {
                    array.push(item.getAttr('lang'));
                });

                return array;
            },
            promise: promise,
            init: function () {
                promise = $http.get('config/translations.json')
                    .success(function (data) {
                        _.each(data.translations, function (item) {
                            all.push(new TranslationModel(item));
                        });
                    });
            },
            current: function () {
                var _return = false;
                _.each(all, function (item) {
                    if (item.isActive()) {
                        _return = item;
                        return false;
                    }
                });
                return _return;
            },
            isSelected: function () {
                return this.current() ? this.current() : false;
            },
            events: eventer
        };

        return service;
    };

    TranslationService.$inject = ['Model', 'Event', '$http', '$translate'];

    angular.module('Application')
        .service('Translation', TranslationService)
        .config(['$translateProvider', function ($translateProvider) {
            $translateProvider
                .useStaticFilesLoader({
                    prefix: 'config/locales/locale-',
                    suffix: '.json'
                })
                .useSanitizeValueStrategy('sanitizeParameters')
                .useLoaderCache(true)
                .uniformLanguageTag('bcp47')
                // .preferredLanguage('ja')
                ;
        }])
        .run(['Translation', 'App', '$rootScope', function (Translation, App, $rootScope) {
            Translation.init();

            // when app is loaded
            App.promise.then(function () {
                // when language change
                $rootScope.$on('$translateChangeEnd', function () {
                    if (App.module()) {
                        // necessary to update current video when language change
                        App.module().lesson().page().updateVideo();
                    }
                });
            });
        }]);

})();